const en = {
wholesaleQtyLabel: "Wholesale min. quantity",
priceLabels: "Price labels",
bankLedgerMenu: "Banking & Accounts",
save: "Save", cancel: "Cancel", delete: "Delete", edit: "Edit", add: "Add",
    search: "Search", loading: "Loading...", confirm: "Confirm", close: "Close",
    clear: "Clear", print: "Print", export: "Export", all: "All",
    actions: "Actions", noData: "No data", noResults: "No results", noSearchResult: "No matching products",
    operationFailed: "Failed", addSuccess: "Added", updateSuccess: "Updated",
    deleteSuccess: "Deleted", deleteFailed: "Delete failed", loadFailed: "Load failed",
    deleteConfirm: "Confirm delete?", fillCompleteInfo: "Please fill all fields",
    username: "Username", password: "Password", login: "Login", logout: "Logout",
    deviceVerifyTitle: "New device: we e-mailed you a code", deviceVerifyResent: "Code re-sent", deviceVerifyResend: "Resend code", deviceVerifyHelp: "Valid 10 minutes. Not arriving? The owner can approve this device under Trusted devices, or contact Sellox support.", trustedDevicesMenu: "🔐 Trusted devices", adminTabMerchantHint: "Merchant? Use the 'Merchant Login' tab (store ID + username + password)", adminLogin: "Admin Login", tenantLogin: "Tenant Login", posLogin: "POS Cashier", posLoginHint: "Cashier only - go directly to POS", enterPos: "Enter POS",
    fillAllFields: "Please fill all fields", tenantIdLabel: "Tenant ID", providedByAdmin: "Provided by admin",
    pointsLookup: "Member Points Lookup", loyaltyTierBenefits: "Tier Benefits", pointsHistory: "Points History",
    memberCode: "Member Code", cancelled: "Cancelled",
    unitPcs: "pcs",
    plan_basic: "Basic", plan_pro: "Pro", plan_enterprise: "Enterprise",
    plan_lifetime_1: "Basic · 1 store (lifetime)", plan_lifetime_2: "Business · 2 stores (lifetime)", plan_lifetime_4: "Enterprise · 4 stores (lifetime)", plan_lifetime_6: "Flagship · unlimited (lifetime)", plan_lifetime_5: "Enterprise · 11 stores (lifetime, legacy)",
    plan_trial: "Trial",
    upgradePlan: "Upgrade Plan",
    upgradePlanCurrent: "Current Plan",
    upgradePlanTo: "Upgrade to",
    upgradePlanConfirm: "Confirm Upgrade",
    upgradePlanSuccess: "Plan upgraded successfully",
    upgradePlanCurrentLimits: "Current limits",
    upgradePlanUsers: "users",
    upgradePlanStores: "stores",
    upgradePlanUnlimited: "Unlimited",
    deleteTenant: "Delete Tenant",
    deleteTenantWarning: "All tenant data will be permanently deleted and cannot be recovered!",
    deleteEnterPassword: "Enter admin password to confirm deletion",
    deletePasswordWrong: "Wrong password, deletion cancelled",
    deleteTenantConfirm: "Confirm Delete",
    shopUrl: "Shop URL",
    dashboard: "Dashboard", storeManagement: "Stores", warehouseManagement: "Warehouses",
    productManagement: "Products", transferManagement: "Transfers",
    customerManagement: "Customers", supplierManagement: "Suppliers",
    purchaseManagement: "Purchases", salesManagement: "Sales",
    onlineOrders: "Online Orders", reports: "Reports", exchangeRates: "Exchange Rates",
    paymentSettings: "Payment Settings", salesReport: "Sales Report",
    saasManagement: "SaaS Tenants", adminManual: "Admin Manual", videoTutorials: "Video Tutorials", userManual: "User Manual",
    todaySales: "Today Sales", onlineOrderTotal: "Online Orders", totalProducts: "Products",
    pendingOrders: "Pending Orders", recentSales: "Recent Sales", quickActions: "Quick Actions",
    productCode: "Code", productName: "Product Name", category: "Category",
    unit: "Unit", costPrice: "Cost", margin: "Margin",
    price1: "Price 1", price2: "Price 2", price3Box: "Price 3 (Box)",
    boxQuantity: "Box Qty", status: "Status", active: "Active", inactive: "Inactive",
    addProduct: "Add Product", editProduct: "Edit Product", priceSettings: "Price Settings",
    marginFormula: "Cost x (1 + Margin%)",
    searchProduct: "Search product name/code...",
    importProducts: "Import Products", selectFile: "Select File",
    supportedFormats: "Supported Formats", importSuccess: "Import Success",
    importFailed: "Import Failed", downloadTemplate: "Download Template",
    importCount: "Import Count", skipDuplicate: "Skip Duplicate", overwriteDuplicate: "Overwrite",
    duplicateHandling: "Duplicate Handling", startImport: "Start Import",
    importing: "Importing...", importResult: "Import Result",
    created: "Created", updated: "Updated", skipped: "Skipped", failed: "Failed",
    posTitle: "POS", currency: "Currency", shift: "Shift",
    openShift: "Open shift", openingCashFloat: "Opening cash float", openingCashHint: "How much cash is in the drawer now for change? It will be deducted at shift close.",
    startShift: "Start Shift", endShift: "End Shift", noShift: "No Shift",
    shiftSince: "Shift since", salesOrder: "Sales Order", items: "items",
    products: "Products", quantity: "Qty", priceType: "Price Type",
    unitPrice: "Unit Price", amount: "Amount", total: "Total",
    sendToCashier: "📨 Send to cashier", checkout: "Checkout", scanOrSearch: "Scan barcode / Search product...",
    box: "Box", boxes: "boxes", pieces: "pcs",
    paymentMethod: "Payment Method", cash: "Cash", card: "Card", giftCard: "🎫 Gift Voucher",
    received: "Received", change: "Change", confirmPayment: "Confirm Payment", orderComplete: "Order Completed", skip: "Skip",
    storeCode: "Store Code", storeName: "Store Name", addStore: "Add Store",
    editStore: "Edit Store", headquarters: "HQ", associatedWarehouse: "Warehouse",
    physicalStore: "Physical Store", onlineStore: "Online Store",
    selectWarehouse: "Select Warehouse",
    warehouseCode: "Warehouse Code", warehouseName: "Warehouse Name", addWarehouse: "Add Warehouse",
    setMainWarehouse: "Set as Main Warehouse", inventoryQty: "Stock Qty",
    reservedQty: "Reserved Qty", availableQty: "Available Qty",
    noInventoryData: "No inventory data", inventoryList: "Inventory List",
    customerCode: "Customer Code", customerName: "Customer Name", addCustomer: "Add Customer",
    searchCustomerPlaceholder: "Search customer name, phone...",
    memberLevel: "Member Level", points: "Points", balance: "Balance",
    normal: "Normal", vip: "VIP",
    supplierCode: "Supplier Code", supplierName: "Supplier Name", addSupplier: "Add Supplier",
    contact: "Contact",
    createPurchaseOrder: "New Purchase Order", orderNo: "Order No.", itemCount: "Items",
    purchaseNoProducts: "No products yet. Please add products in Product Management first",
    purchaseBatchSelect: "Select products (multi-select)",
    purchaseBatchAdd: "Batch add to order",
    purchaseAddedItems: "Added items",
    purchaseItemsAdded: "items added",
    purchaseSelectAtLeastOne: "Please select at least one product",
    purchaseNotesPlaceholder: "Notes (optional)",
    transferBatchSelect: "Select products to transfer (multi-select)",
    transferBatchConfirm: "Batch transfer",
    transferSelectAtLeastOne: "Please select at least one product",
    transferNoStock: "No products with stock in this warehouse",
    transferSelectWarehouseFirst: "Please select a source warehouse first",
    transferQty: "Transfer qty",
    reportCurrency: "Currency Display",
    reportBoth: "Both",
    reportExchangeRate: "Current exchange rate",
    reportUsdSales: "USD Sales",
    reportBsSales: "Bolivar Sales",
    dbBusinessOverview: "Business Overview",
    dbPurchaseIn: "Purchases",
    dbTotalPO: "Total POs",
    dbReceived: "Received",
    dbPendingReceive: "Pending",
    dbTotalPurchaseItems: "Total items",
    dbTotalPurchaseAmount: "Total amount",
    dbDamageLoss: "Damage / Loss",
    dbLossRecords: "Loss records",
    dbLossQty: "Lost quantity",
    dbLossValue: "Loss value",
    dbRetailSales: "Retail Sales",
    dbTotalOrders: "Total orders",
    dbTotalItems: "Total items",
    dbTotalRevenue: "Total revenue",
    dbWholesale: "Wholesale",
    dbCompleted: "Completed",
    dbPending: "Pending",
    dbTotalPaid: "Paid",
    dbUnpaid: "Unpaid",
    dbPaidToSupplier: "Paid to Suppliers",
    dbSupplierDebt: "Owed to Suppliers",
    poRecordPay: "Record Payment",
    poPayAmount: "Payment amount",
    poPayAll: "Pay full amount",
    poPaySuccess: "Payment recorded",
    posStockLookup: "Stock Lookup",
    posReserved: "Reserved",
    posAvailable: "Available",
    posMinStock: "Min Stock",
    posOutOfStock: "Out of Stock",
    posLowStock: "Low Stock",
    allWarehouses: "All Warehouses",
    posCartEmpty: "Click products on the left to add",
    posNeedShift: "Please start a shift before checkout",
    totalAmount: "Total", createTime: "Created",
    receiveGoods: "Receive", receivedStatus: "Received", pendingReceive: "Pending",
    selectSupplier: "Select Supplier", selectProduct: "Select Product",
    receiveWarehouse: "Receiving Warehouse", createSuccess: "Created",
    addItems: "Add Items",
    otherPayment: "Other", completedStatus: "Completed", pendingStatus: "Pending",
    newTransfer: "New Transfer", sourceWarehouse: "Source",
    targetWarehouse: "Destination", product: "Product", transferConfirm: "Confirm Transfer",
    inventoryOverview: "Inventory Overview", transferHistory: "Transfer History",
    stock: "Stock", time: "Time", source: "Source", target: "Target",
    sameWarehouseError: "Source and target cannot be the same",
    transferSuccess: "Transfer Success", transferFailed: "Transfer Failed",
    salesReportTitle: "Sales Report", storeFilter: "Store Filter",
    dateFrom: "From", dateTo: "To", generateReport: "Generate",
    printReport: "Print Report", totalSales: "Total Sales", totalOrders: "Total Orders", avgPerOrder: "Avg/Order", byCurrency: "By Currency", byPaymentMethod: "By Payment Method",
    totalItems: "Total Items", storeSalesDetail: "Store Sales Detail",
    productSalesDetail: "Product Sales Detail", soldQuantity: "Sold Qty",
    salesAmount: "Sales Amount", topProducts: "Top Products",
    shopTitle: "Online Store", myOrders: "My Orders", addToCart: "Add to Cart",
    cart: "Cart", checkoutTitle: "Checkout", orderSuccess: "Order Success",
    orderLookup: "Track Order", orderNumber: "Order No.", phone: "Phone",
    shippingInfo: "Shipping Info", paymentInfo: "Payment Info",
    online: "Online", offline: "Offline", offlineMode: "Offline Mode",
    cachedData: "Cached", offlineCacheMode: "Offline mode - using cached data, orders sync when back online",
    offlineNoCache: "Offline with no cache - please connect and login first",
    pendingSync: "Pending Sync", syncNow: "Sync Now", syncSuccess: "Sync Success",
    offlineWarning: "Offline mode - data will sync when connection is restored",
    location: "Location", type: "Type",
    retail: "Retail", warehouse: "Warehouse", mainWarehouse: "Main Warehouse",
    name: "Name", contactPhone: "Phone", email: "Email", address: "Address",
    purchaseOrder: "Purchase Order", supplier: "Supplier",
    received_status: "Received", pending: "Pending",
    language: "Language", chinese: "中文", english: "English", spanish: "Espanol",
    discount: "Discount", orderDetail: "Order Detail", shipping: "Shipping",
    paid: "Paid", processing: "Processing", shipped: "Shipped", completed: "Completed",
    customer: "Customer", date: "Date",
    systemSettings: "System Settings", employees: "Employees", stockAlerts: "Stock Alerts", stockTaking: "Stock Taking",
    stockLoss: "Stock Loss", stockLossManagement: "Stock Loss Management", newStockLoss: "New Stock Loss", stockLossSuccess: "Stock loss recorded",
    stockLossSearchProduct: "Search product name or code...", stockLossQty: "Loss Quantity", stockLossReason: "Loss Reason",
    stockLossNotePlaceholder: "Additional notes (optional)", stockLossCostEstimate: "Estimated Loss", confirmStockLoss: "Confirm Loss",
    stockLossOnlyManagers: "Only managers/admins can record stock loss", totalLossRecords: "Loss Records", totalLossQty: "Loss Quantity",
    totalCostLoss: "Total Cost Loss", costLoss: "Loss", operator: "Operator", allReasons: "All Reasons",
    companyName: "Company Name", taxId: "Tax ID", companyAddress: "Address", companyPhone: "Phone",
    invoiceHeader: "Invoice Header", invoiceFooter: "Invoice Footer", printFormat: "Print Format",
    shopTheme: "Shop Background Theme", businessType: "Business Type", shopDescription: "Shop Description (shown on storefront)", shopDescPlaceholder: "e.g. Fresh produce daily", shopPreview: "Shop Link Preview",
    themeSupermarket: "Supermarket", themeRestaurant: "Restaurant", themeDepartment: "Department Store", themePharmacy: "Pharmacy", themeBakery: "Bakery", themeClothing: "Clothing", themeElectronics: "Electronics", themeButcher: "Butcher Shop", themeGeneral: "General", themeCustom: "Custom Image",
    uploadBackground: "Upload background (recommended 1920x800, max 5MB)", selectImage: "Select Image", uploadSuccess: "Uploaded successfully",
    autoPrint: "Auto Print", printSuccess: "Sent to printer", receiptCopies: "Copies", scannerEnabled: "Barcode Scanner",
    printerConfig: "Printer Options", posReceiptPrinter: "POS Receipt Printer", reportPrinter: "Report Printer", fiscalPrinter: "Fiscal Printer",
    printerName: "Printer Name", printerModel: "Printer Model", connectionPort: "Connection Port", paperSize: "Paper Size",
    thermal: "Thermal", enableCashDrawer: "Enable Cash Drawer", printItemCode: "Print Item Code (fiscal only)",
    silentPrintTip: "Silent Printing Setup (no print dialog)", setDefaultPrinter: "Set POS receipt printer as Windows default printer", downloadShortcut: "Download shortcut file, place on desktop and double-click to open", closeAllBrowserFirst: "Uses independent process, no need to close other browser windows",
    chromeKioskTip: "Add --kiosk-printing to Chrome shortcut target, e.g.:", autoPrintTip: "System auto-prints after payment, no manual action needed",
    reportPrinterDesc: "For printing sales reports, inventory reports and other A4 documents", testPrint: "Test Print",
    qzNotConnected: "Silent printing not connected - Install QZ Tray for auto-print", download: "Download",
    wholesaleEnabled: "Wholesale", wholesaleMinQty: "Min Qty", wholesaleDiscount: "Wholesale Discount",
    refund: "Refund", refundReason: "Refund Reason", holdOrder: "Hold", recallOrder: "Recall",
    dailySettlement: "Daily Settlement", grossProfit: "Gross Profit", netSales: "Net Sales",
    permission: "Permission", canDiscount: "Can Discount", canRefund: "Can Refund", maxDiscount: "Max Discount",
    wholesale: "Wholesale", retailMode: "Retail", wholesaleMode: "Wholesale",
    receipt80mm: "80mm Receipt", receiptA4: "A4 Invoice", printReceipt: "Print", reprintReceipt: "Reprint Receipt", receiptDetail: "Receipt Detail",
    bestSellers: "Best Sellers", slowSellers: "Slow Sellers", actualQty: "Actual Qty", systemQty: "System Qty",
    difference: "Difference", enterQty: "Enter Qty",
    systemRates: "System Rates", categoryRates: "Category Rates",
    categoryRateDesc: "Configure exchange rate for each category",
    usdPricingMode: "USD Pricing Mode",
    originalUsd: "USD price as entered (default)",
    bsToUsd: "Bs shelf price ÷ rate (stores pricing shelves in Bs)",
    originalUsdDesc: "POS USD checkout uses the original product USD price",
    bsToUsdDesc: "POS USD checkout uses Bs selling price ÷ BCV rate",
    productRate: "Product Rate", productRateDesc: "Rate for converting $ product prices to Bs",
    salesExchangeRate: "Sales Rate", salesExchangeRateDesc: "POS/receipt display rate (BCV auto-sync)",
    salesRate: "Sales Rate", salesRateDesc: "When billing in $, calculates the USD amount to charge (Formula: Price × Sales Rate ÷ Product Rate)",
    noSalesRates: "No sales rates added. Click Add to create one.",
    localSymbol: "Local Symbol", saveRates: "Save Rates", ratesUpdated: "Rates Updated",
    quickConverter: "Quick Converter", example: "Example",
    bankTransfer: "Bank Transfer", mobilePay: "Mobile Payment",
    bankName: "Bank Name", accountNumber: "Account Number",
    accountHolder: "Account Holder", idNumber: "ID Number",
    selectBank: "Select Bank", saveSettings: "Save Settings", settingsSaved: "Settings Saved",
    saveFailed: "Save Failed", preview: "Preview",
    transferData: "Transfer Info", mobilePayData: "Mobile Pay Info",
    bank: "Bank", account: "Account", holder: "Holder",
    whatsappContact: "WhatsApp Contact",
    whatsappNumber: "WhatsApp Number",
    whatsappHint: "Enter number with country code, no + or spaces",
    whatsappEnabled: "Customers can contact you via WhatsApp after ordering",
    casheaBNPL: "Buy now, pay later", casheaDesc: "Customer pays in interest-free installments via Cashea",
    casheaCedula: "Customer ID number", casheaAmount: "Cashea Amount",
    casheaProcessing: "Processing with Cashea...", casheaSettingsDesc: "Buy now, pay later - interest-free installments",
    casheaKeyHint: "Without API Key runs in demo mode. Request at soporte@cashea.com",
    casheaDemoMode: "Demo mode - payments auto-approved", casheaLiveMode: "Live mode - connected to Cashea",
    saving: "Saving...",
    notes: "Notes",
    printReceipt80mm: "Print Receipt", printInvoiceA4: "Print Invoice",
    printPriceLabels: "Price Labels", printPreview: "Print Preview",
    labelDisplayMode: "Label display", labelModeP1: "Price 1 (Retail)", labelModeP3: "Price 3 (Wholesale)", labelModeWholesale: "Box Price (Wholesale)", labelModeP1P3: "Price 1 + Price 3", labelModeP1W: "Price 1 + Box Price", labelModeUsdP1: "USD Price 1 (Retail)", labelShowForeign: "Show USD ($)", labelNoDecimals: "No decimals", labelShowBarcode: "Show barcode", labelPaperSize: "Paper", labelSize80mm: "80mm Thermal", labelSize50x30: "50x30mm Sticker", labelBilingual: "Bilingual (ES+CN)",
    selectProducts: "Select Products", selectAll: "Select All",
    deselectAll: "Deselect All", selectedCount: "Selected",
    printSelected: "Print Selected", time: "Time",
    connectPrinter: "Connect Printer", printerReady: "Connected", printerConnected: "Printer connected", printerConnectFailed: "Connection failed", directPrintFailed: "Direct print failed", printing: "Printing...",
    pricingMode: "Foreign Currency Pricing",
    pricingLocalBased: "Calculate from local price",
    pricingLocalDesc: "Bs.=Cost×Dept.Rate, USD=Bs.÷Sales Rate (black market rate)",
    pricingForeignDirect: "Use direct foreign price",
    pricingForeignDesc: "Use stored USD prices directly (central bank rate)",
    dailySettlement: "Daily Settlement", grossProfit: "Gross Profit",
    refundHistory: "Refund History", refundReason: "Reason", expenseManagement: "Expenses", addExpense: "Add Expense", totalExpenses: "Total Expenses", expenseCount: "Records", expenseByStore: "By Store", avgOrder: "Avg. Order", expenseDesc: "Description", expense_rent: "Rent", expense_utilities: "Utilities", expense_salary: "Salary", expense_supplies: "Supplies", expense_maintenance: "Maintenance", expense_transport: "Transport", expense_food: "Food", expense_tax: "Tax", expense_other: "Other", selectStore: "Select Store", categoryManagement: "Categories",
    profitAnalysis: "Profit Analysis", revenue: "Revenue", cost: "Cost", profit: "Profit",
    profitMargin: "Margin", overallMargin: "Overall Margin", totalRevenue: "Total Revenue",
    totalCost: "Total Cost", totalProfit: "Total Profit",
    categoryAnalysis: "Category/Rate Analysis", categoryBreakdown: "By Category", dailyBreakdown: "Daily Breakdown",
    govtGoods: "Govt Rate Goods", blackMarketGoods: "Black Market Goods", rateLabel: "Rate:", blackMarket: "Black Market",
    salesUsd: "Sales ($)", salesBs: "Sales (Bs)", costUsd: "Cost ($)", profitUsd: "Profit ($)",
    pricingMode: "Pricing Mode", margin: "Margin", totalSales: "Total Sales",
    thisWeek: "This Week", thisMonth: "This Month", lastMonth: "Last Month",
    today: "Today", allStores: "All Stores", categoryName: "Category", exchangeRate: "Rate",
    orders: "Orders", sales: "Sales", items: "Items",
    grossProfit: "Gross Profit", netProfit: "Net Profit", expenses: "Expenses", stockLoss: "Damage/Loss",
    expenseBreakdown: "Expense Breakdown", lossBreakdown: "Damage/Loss Breakdown",
    damage: "Damage", expired: "Expired", personalUse: "Personal Use", sample: "Sample", other: "Other",
    rateType: "Rate", selectedRate: "Selected Rate", usdEquivalent: "USD Equivalent",
    expenseRent: "Rent", expenseUtilities: "Utilities", expenseSalary: "Salary", expenseSupplies: "Supplies",
    expenseMaintenance: "Maintenance", expenseTransport: "Transport", expenseFood: "Food", expenseTax: "Tax",
    exchangeProfit: "Exchange Profit", buyUsdCash: "Buy USD Cash", cardToCash: "Card to Cash",
    usdAmount: "USD Amount", buyRate: "Buy Rate", sellRate: "Sell Rate",
    cardAmount: "Card Amount(Bs)", cashGiven: "Cash Given(Bs)", bsCost: "Bs Cost", bsValue: "Bs Value",
    profitBs: "Profit(Bs)", profitUsd: "Profit($)", commissionPct: "Commission",
    todayProfitBs: "Today Profit(Bs)", todayProfitUsd: "Today Profit($)",
    exchangeProfitDetail: "Exchange Profit Detail", cashMustBeLess: "Cash must be less than card amount",
    note: "Note", details: "Details", type: "Type",
    purchaseHistory: "Purchase History", totalSpent: "Total Spent", orderCount: "Orders",
    addPoints: "Add Points", redeemPoints: "Redeem Points", topupBalance: "Top Up", pointsLog: "Points Log",
    balanceLog: "Balance Log", earn: "Earn", redeem: "Redeem", topup: "Top Up",
    auditLog: "Audit Log", action: "Action", targetType: "Target Type", targetId: "Target ID",
    detail: "Detail", operator: "Operator",
    promotions: "Promotions", promoName: "Name", promoType: "Type",
    discount_promo: "Discount", fullReduction: "Spend & Save", buyGet: "Buy & Get", flashSale: "Flash Sale",
    startDate: "Start Date", endDate: "End Date", minAmount: "Min Amount",
    discountValue: "Discount Value", addPromotion: "Add Promotion",
    accountsReceivable: "Accounts Receivable", accountsPayable: "Accounts Payable",
    receivable: "Receivable", payable: "Payable", creditor: "Creditor",
    dueDate: "Due Date", paidAmount: "Paid", remainingAmount: "Remaining",
    markPaid: "Mark Paid", addReceivable: "Add Receivable", addPayable: "Add Payable",
    partialPaid: "Partial",
    dataBackup: "Data Backup", exportBackup: "Export Backup", backupDesc: "Export all data as JSON",
    salesTrend: "Sales Trend", last7Days: "Last 7 Days", last30Days: "Last 30 Days",
    rolePermissions: "Permissions", admin: "Admin", manager: "Manager", store_manager: "Store Manager", cashier: "Cashier", order_taker: "Order taker (no payments)", staff: "Staff", warehouse: "Warehouse", finance: "Finance", price_checker: "Price Checker", stock_viewer: "Stock Viewer", wholesale_clerk: "Wholesale Clerk",
    discountAboveCostOnly: "Above cost only", discountAboveCostDesc: "Discount cannot go below product cost price",
    marketing: "Marketing",
    mktDesc: "Email, SMS & push notification campaigns",
    mktNewCampaign: "New Campaign",
    mktCreateCampaign: "Create Campaign",
    mktCampaigns: "Campaigns",
    mktNoCampaigns: "No campaigns created yet",
    mktNameRequired: "Name and message are required",
    mktCampaignCreated: "Campaign created",
    mktSentTo: "Sent to {count} customers",
    mktSendError: "Failed to send",
    mktDeleted: "Deleted",
    mktName: "Name",
    mktType: "Type",
    mktSegment: "Segment",
    mktSubject: "Subject",
    mktMessage: "Message",
    mktVariablesHint: "Variables: {nombre}, {telefono}, {puntos}",
    mktSend: "Send",
    mktRecipients: "recipients",
    mktAllCustomers: "All Customers",
    mktVipCustomers: "VIP Customers",
    mktInactiveCustomers: "Inactive (30+ days)",
    mktBirthdayToday: "Birthday Today",
    mktNamePlaceholder: "Weekend Promo",
    mktSubjectPlaceholder: "Special offer for you",
    mktMessagePlaceholder: "Hi {nombre}, we have a special offer...",
    mktEmail: "Email",
    mktSms: "SMS",
    mktWhatsapp: "WhatsApp",
    mpLoginRequired: "Please log in",
    mpSearchPlaceholder: "Search...",
    mpAllCategories: "All",
    mpLoading: "Loading...",
    mpNoResults: "No results",
    mpItems: "items",
    mpTotal: "Total",
    mpEmpty: "Empty",
    mpCharge: "Checkout",
    mpPaymentTitle: "Payment",
    mpCash: "Cash",
    mpCard: "Card",
    mpTransfer: "Transfer",
    mpZelle: "Zelle",
    mpPagoMovil: "Pago Movil",
    mpConfirm: "Confirm",
    mpSaleComplete: "Sale completed",
    exportSalesReport: "Export Sales", exportInventoryReport: "Export Inventory",
    exporting: "Exporting...",
    usePoints: "Use Points", pointsAvailable: "Available", pointsEarned: "Points Earned",
    pointsDiscount: "Points Discount", pointsIssued: "Points Issued", pointsRecon: "Points Reconciliation", pointsMonthly: "Points Monthly Report", pointsVoidClaw: "Void Claw-back", pointsRefundClaw: "Refund Claw-back", pointsRestoreUsed: "Used Points Returned", pointsManualAdjust: "Manual Adjust", last6Months: "Last 6 Months", pointsRate: "Points Rate", noCustomerNoPoints: "Select customer to use points",
    clerkLimitTitle: "Online Shop AI Clerk Daily Limit", clerkLimitDesc: "Prevents visitors from draining your credits; over the limit customers are sent to WhatsApp (0 = unlimited)", featBgRemove: "Background Removal", featBeautify: "Photo Beautify Pro", featRetouch: "Photo Retouch Pro", featPoster: "AI Poster", featBanner: "AI Banner", featLegalChat: "Legal Advisor", featPayroll: "Payroll AI",
    vipRules: "VIP Rules", autoUpgrade: "Auto Upgrade", minSpent: "Min Spent", pointsMultiplier: "Points Multiplier",
    silver: "Silver", gold: "Gold", vip: "VIP", normal: "Normal",
    wholesale: "Wholesale", wholesaleOrder: "Wholesale Order", createWholesaleOrder: "Create Wholesale Order",
    wholesaleStats: "Wholesale Stats", pendingOrders: "Pending Orders", totalRevenue: "Total Revenue",
    totalPaid: "Total Paid", totalItems: "Total Items", orderDetail: "Order Detail",
    deliveryAddress: "Delivery Address", deliveryDate: "Delivery Date", orderNotes: "Notes",
    markCompleted: "Mark Completed", markDelivered: "Mark Delivered", cancelOrder: "Cancel Order",
    wholesalePrice: "Wholesale Price", retailPrice: "Retail Price", paidAmount: "Paid",
    unpaidAmount: "Unpaid", recordPayment: "Record Payment", paymentAmount: "Payment Amount",
    orderCancelled: "Order Cancelled", statusPending: "Pending", statusCompleted: "Completed",
    statusDelivered: "Delivered", statusCancelled: "Cancelled", printOrder: "Print Order",
    wholesaleCustomer: "Wholesale Customer", itemCount: "Items",
    attendance: "Attendance", clockIn: "Clock In", clockOut: "Clock Out", hours: "Hours", present: "Present",
    salesTarget: "Sales Target", targetAmount: "Target Amount", actual: "Actual", progress: "Progress",
    setTarget: "Set Target", monthly: "Monthly", quarterly: "Quarterly",
    purchaseReturn: "Purchase Return", returnReason: "Reason", approve: "Approve",
    bundles: "Bundles", bundleName: "Bundle Name", bundlePrice: "Bundle Price", originalPrice: "Original Price",
    fixedItems: "Fixed Items", optionalGroups: "Optional Addons", addGroup: "Add Group",
    addOptionalGroup: "Add Optional Group", groupName: "Group Name", defaultOption: "Default",
    optGroupHint: "Add at least 2 options. Customer picks one per group.",
    optGroupNeedTwoOptions: "Need at least 2 options",
    addBundleHint: "Create combos to boost average order value",
    comboAnalytics: "Combo Sales Analytics", comboOrders: "Combo Orders", comboRevenue: "Combo Revenue",
    comboOrderRatio: "of total orders", activeCombos: "Active Combos", avgComboValue: "Avg Combo Value",
    comboRanking: "Combo Sales Ranking", comboSalesDistribution: "Combo Sales Distribution",
    comboTrend: "Combo Sales Trend", optionStats: "Option Selection Stats",
    comboRankingTable: "Combo Sales Detail", noComboSalesYet: "No combo sales data yet",
    createComboHint: "Sales data will appear here after creating combos",
    addToCart: "Add to Cart", saving: "Save", options: " opts",
    noItems: "No fixed items yet", noOptGroups: "No optional groups",
    costHistory: "Cost History", notifications: "Notifications", stockLow: "Low Stock",
    overdueAccount: "Overdue Account", pendingOrdersNotif: "Pending Orders",
    uploadImage: "Upload Image", deleteImage: "Delete Image", restoreBackup: "Restore Backup",
    restoreDesc: "Restore data from JSON backup", restoreWarning: "Restore will overwrite current data",
    commission: "Commission", commissionRules: "Commission Rules", commissionReport: "Commission Report",
    baseTier: "Base", standardTier: "Standard", excellentTier: "Excellent",
    commissionRate: "Rate", estimatedCommission: "Est. Commission",
    totalCommission: "Total Commission", tier: "Tier", selectMonth: "Select Month",
    addEmployee: "Add Employee", editEmployee: "Edit Employee",
    role: "Role", deleteEmployeeConfirm: "Delete this employee?",
    rolePresetHint: "Role (click to apply preset)",
    permPOS: "POS", permDiscount: "Discount", permSwitchPrice: "Switch price 1/2/box", permRefund: "Refund", permVoid: "Void",
    permProducts: "Products", permInventory: "Inventory", permPurchases: "Purchases",
    permCustomers: "Customers", permReports: "Reports", permExport: "Export",
    permCostPrice: "Cost Price", permEmployees: "Employees", permSettings: "Settings",
    permPromotions: "Promotions",
    permEditOrders: "Edit Orders", permDescEditOrders: "Modify items on completed orders (audited)",
    permTakeOnline: "Take Online Orders", permDescTakeOnline: "Accept webshop/wholesale orders, confirm, print docs and ship from the POS",
    permDescPOS: "Use POS register", permDescDiscount: "Apply discounts", permDescSwitchPrice: "Switch price 1/2/box at POS", permDescRefund: "Process refunds",
    permDescVoid: "Void transactions", permDescProducts: "Add/edit products, add stock", permDeleteProducts: "Delete / lower stock", permDescDeleteProducts: "Delete or deactivate products, lower stock, losses — without it only adding is allowed",
    permDescInventory: "Manage stock & transfers", permDescPurchases: "Create purchase orders",
    permDescCustomers: "Manage customer data", permDescReports: "View sales reports",
    permDescExport: "Export data to Excel", permDescCostPrice: "View product cost prices",
    permDescEmployees: "Manage employees", permDescSettings: "System settings", permDescPromotions: "Manage promotions",
    permGroupWholesale: "🏭 Wholesale", permWsEditPrice: "Edit wholesale price", permWsCredit: "Sell on credit", permWsCreditLimit: "Set credit limit", permWsEditOrders: "Edit/cancel wholesale orders", permWsReturns: "Wholesale returns", wsMaxDiscountPercent: "Wholesale max discount",
    permDescWsEditPrice: "May raise price above list; off = list price only", permDescWsCredit: "May sell on credit", permDescWsCreditLimit: "May change customer credit limit/terms", permDescWsEditOrders: "Edit/cancel orders without manager QR (default off)", permDescWsReturns: "May process wholesale returns",
    permGroupPOS: "POS", permGroupCatalog: "Catalog", permGroupCRM: "CRM",
    permGroupReports: "Reports", permGroupSystem: "System",
    passwordKeepHint: "leave empty to keep",
    enabledCount: "enabled",
    maxDiscountPercent: "Max Discount",
    superAdmin: "Super Admin",
    shops: "Shops",
    shop: "Shop",
    changePassword: "Change Password",
    oldPassword: "Old Password",
    newPassword: "New Password",
    confirmNewPassword: "Confirm Password",
    passwordChanged: "Password changed",
    passwordMismatch: "Passwords do not match",
    taxReport: "Tax Report",
    // Analytics Center
    analyticsCenter: "Analytics Center",
    acOverview: "Overview",
    acCustomerAnalysis: "Customer Analysis",
    acCategoryAnalysis: "Category Analysis",
    acTrendAnalysis: "Trend Analysis",
    acRevenue: "Revenue",
    acOrders: "Orders",
    acAvgOrder: "Avg. Order",
    acCustomers: "Customers",
    acRevenueTrend: "Revenue Trend",
    acTotalCustomers: "Total Customers",
    acActiveCustomers: "Active Customers",
    acActivityRate: "Activity Rate",
    acTopCustomersChart: "Top 10 Customers by Spend",
    acCustomerRanking: "Customer Ranking",
    acTotalRevenue: "Total Revenue",
    acCategoryCount: "Categories",
    acTopCategory: "Top Category",
    acCategoryShare: "Category Share",
    acCategoryRevenue: "Category Revenue",
    acCategoryDetail: "Category Detail",
    acProductCount: "Products",
    acShare: "Share",
    acPeakHour: "Peak Hour",
    acPeakDay: "Peak Day",
    acHourlySales: "Hourly Sales Distribution",
    acWeekdaySales: "Weekly Sales Distribution",
    acExportProfit: "Export Profit Report",
    ac_week: "This Week",
    ac_month: "This Month",
    ac_year: "This Year",
    acDayUnit: "d",
    acDays: "days",
    acLast: "Last",
    // Shift Reports
    shiftReports: "Shift Reports",
    shiftReport: "Shift Report",
    shiftStart: "Start Time",
    shiftEnd: "End Time",
    shiftDuration: "Duration",
    shiftCount: "Shifts",
    shiftActive: "Active",
    shiftEnded: "Ended",
    shiftTxCount: "Transactions",
    shiftTxCount2: "transactions",
    shiftSalesDetail: "Sales Detail",
    shiftReconciliationPrint: "Itemized Reconciliation (POS terminal/cash)",
    printA4: "Print A4",
    printTicket: "Print Ticket",
    exportExcel: "Export Excel",
    poInvoiceNo: "Supplier invoice / delivery no. (optional)",
    shiftNetTotal: "Net Total",
    shiftEndConfirmMsg: "A detailed reconciliation report will be generated",
    shiftGenerateReport: "Generate Report",
    // Stock Alerts
    saTotal: "Total Alerts",
    saCritical: "Critical",
    saWarning: "Warning",
    saOutOfStock: "Out of Stock",
    saLowStock: "Low Stock",
    saValueAtRisk: "Value at Risk",
    saCurrentStock: "Current Stock",
    saMinStock: "Min Stock",
    saShortage: "Shortage",
    saSuggestedOrder: "Suggested Order",
    saOrderCost: "Order Cost",
    saLevel: "Level",
    saItemsAffected: "items need attention",
    saTotalSuggestedCost: "Total Suggested Cost",
    saBatchThreshold: "Batch Thresholds",
    saBatchThresholdDesc: "Adjust min stock thresholds. Items below this value trigger alerts.",
    saUpdated: "Updated",
    saAllGood: "All Clear",
    saAllGoodDesc: "All products are well stocked",
    saAlertBanner: "Stock Alert",
    saAutoReorder: "Auto Reorder",
    saAutoReorderDesc: "Select supplier and warehouse. System will generate a purchase order from suggested quantities.",
    saSelectSupplier: "Select Supplier",
    saSelectWarehouse: "Select Warehouse",
    saSelectSupplierWarehouse: "Please select supplier and warehouse",
    saGeneratePO: "Generate PO",
    saPoGenerated: "Purchase order generated:",
    supplier: "Supplier",
    // Dashboard customization
    dbCustomize: "Customize",
    dbEditing: "Editing",
    dbResetLayout: "Reset Layout",
    dbDragHint: "Drag cards to reposition, drag corners to resize",
    // Email Reports
    emailReports: "Email Reports",
    erSmtpConfig: "Email Settings",
    erSmtpHost: "SMTP Server",
    erSmtpPort: "Port",
    erSmtpUser: "Username",
    erSmtpPassword: "Password",
    erSenderEmail: "Sender Email",
    erSenderName: "Sender Name",
    erTestEmail: "Send Test",
    erTestSent: "Test email sent",
    erConfigSaved: "Email config saved",
    erConfigured: "Email Configured",
    erNotConfigured: "Email Not Configured",
    erConfigHint: "Configure SMTP settings to enable email reports",
    erAddSchedule: "Add Schedule",
    erReportType: "Report Type",
    erFrequency: "Frequency",
    erRecipients: "Recipients",
    erAddRecipient: "Add Recipient",
    erDaily: "Daily",
    erWeekly: "Weekly",
    erMonthly: "Monthly",
    erDailySales: "Daily Sales Summary",
    erProfitSummary: "Profit Summary",
    erSendNow: "Send Now",
    erSentTo: "Sent to",
    erLastSent: "Last Sent",
    erDisabled: "Disabled",
    erNoSchedules: "No Schedules",
    erNoSchedulesDesc: "Add email schedules to auto-send reports",
    // Mobile POS
    mobilePOS: "Mobile POS",
    mpSelectStore: "Select a store to start",
    mpViewCart: "View Cart",
    mpCart: "Cart",
    mpEmptyCart: "Cart is empty",
    mpCheckout: "Checkout",
    mpPayment: "Payment",
    mpConfirmPay: "Confirm Payment",
    backToAdmin: "Back to Admin",
    transfer: "Transfer",
    clearCart: "Clear",
    // Store Comparison
    acStoreComparison: "Store Comparison",
    acStoreCount: "Stores",
    acTopStore: "Top Store",
    acStoreRevenue: "Store Revenue Comparison",
    acStoreDetail: "Store Detail",
    // POS Shortcuts
    editQty: "Edit Qty",
    editPrice: "Edit Price",
    uiThemeTitle: "UI Theme",
    uiThemeHint: "Store-wide: applies to all POS terminals and admin",
    accentColorLabel: "Accent color (buttons / highlights)",
    defaultColor: "Default green",
    customColor: "Custom color",
    uiThemeSaveHint: "👆 Click to preview. Don't forget to Save to apply store-wide",
    aiLegalAdvisor: "AI Legal Advisor",
    editPriceNeedAuth: "Authorization required to change price (QR or password)",
    usdPriceHint: "USD price (Bs ÷ rate)",
    bsPriceLabel: "Bs. price",
    usdPriceLabel: "$ USD price",
    priceBelowCostConfirm: "Price is below cost! Continue anyway?",
    shortcutHint: "Arrow Up/Down to select, F5 edit qty, F6 edit price",
    splitPayment: "Split Payment", addNote: "Note", itemNote: "Item Note", orderNote: "Order Note",
    enterNote: "Enter note...", enterOrderNote: "Enter order note...", clearNote: "Clear",
    noSugar: "No Sugar", lessIce: "Less Ice", extraHot: "Extra Hot", noOnion: "No Onion", takeaway: "Takeaway", urgent: "Rush",
    exact: "Exact", addPaymentMethod: "Add Payment Method",
    // Loyalty Program
    loyaltyProgram: "Loyalty Program",
    loyaltyDesc: "Manage member tiers, point rules and rewards",
    loyaltyTiers: "Member Tiers",
    loyaltyMembers: "Total Members",
    loyaltyTotalPoints: "Total Points",
    loyaltyIssued30d: "Points Issued (30d)",
    loyaltyRedeemed30d: "Points Redeemed (30d)",
    loyaltyLevelDist: "Tier Distribution",
    loyaltyTopMembers: "Points Leaderboard",
    loyaltyRecentActivity: "Recent Points Activity",
    loyaltyAddTier: "Add Tier",
    loyaltyTierColor: "Tier Color",
    loyaltyPointsConfig: "Points Rules",
    loyaltyEarnRate: "Earn Rate",
    loyaltyPtsPerDollar: "pts/$",
    loyaltyRedeemRate: "Redeem Rate",
    loyaltyPtsEqDollar: "pts = $1",
    loyaltyBonusConfig: "Bonus Settings",
    loyaltyWelcomeBonus: "Welcome Bonus",
    loyaltyWelcomeBonusDesc: "Award points on new customer registration",
    loyaltyBirthdayBonus: "Birthday Bonus",
    loyaltyBirthdayBonusDesc: "Award points on customer birthday",
    loyaltyReferralBonus: "Referral Bonus",
    loyaltyReferralBonusDesc: "Award points for customer referrals",
    // Sales Channels
    salesChannels: "Sales Channels",
    salesChannelsDesc: "View performance and trends across sales channels",
    channel_pos: "POS Retail",
    channel_online: "Online Store",
    channel_wholesale: "Wholesale",
    channelGrandTotal: "Grand Total",
    channelShare: "Channel Share",
    channelRevenue: "Channel Revenue",
    channelTrend: "Channel Trend",
    channelDetails: "Channel Details",
    channelName: "Channel",
    // Member Lookup QR
    loyaltyQrCode: "Lookup QR Code",
    loyaltyQrCodeDesc: "Print this QR code for your counter so customers can check their points",
    loyaltyQrLink: "Lookup Link",
    loyaltyQrPrint: "Screenshot and print for counter display",
    loyaltyNoTenant: "Please create a tenant first",
    selectTenant: "Select Tenant",
    copied: "Copied",
    // Points Mall
    pointsMall: "Points Mall",
    pointsMallDesc: "Manage redeemable items and redemption orders",
    mallItems: "Items",
    mallOrders: "Orders",
    mallAddItem: "Add Item",
    mallEditItem: "Edit Item",
    mallNoItems: "No items yet, click to add",
    mallType_coupon: "Coupon",
    mallType_gift: "Gift",
    mallType_balance: "Balance Top-up",
    mallStock: "Stock",
    mallUnlimited: "Unlimited",
    mallRedeemed: "Redeemed",
    mallFillRequired: "Please fill in item name and points cost",
    mallPerLimit: "Per-customer limit",
    mallCouponSettings: "Coupon Settings",
    mallCouponType: "Coupon Type",
    mallDiscountAmount: "Discount Amount",
    mallDiscountPercent: "Discount Percent",
    mallMinOrder: "Min Order",
    mallValidDays: "Valid Days",
    mallBalanceSettings: "Balance Top-up Settings",
    mallBalanceAmount: "Top-up Amount",
    mallGiftSettings: "Gift Settings",
    mallGiftInfo: "Gift Description",
    mallGiftInfoPlaceholder: "e.g. Collect gift at store",
    mallItemName: "Item Name",
    mallComplete: "Complete",
    mallStatus_pending: "Pending",
    mallStatus_completed: "Completed",
    mallStatus_cancelled: "Cancelled",
    active: "Active",
    inactive: "Inactive",
    mallTimed: "Timed",
    mallTimedSale: "Flash Sale",
    mallStartTime: "Start Time",
    mallEndTime: "End Time",
    mallUploadImage: "Upload Image",
    mallPendingUpload: "Upload on save",
    mallImageHint: "JPG/PNG/WebP, square recommended",
    // Member Lookup Page
    memberNormal: "Member", memberSilver: "Silver", memberGold: "Gold", memberVip: "VIP",
    memberPhonePlaceholder: "Enter phone number", memberCodePlaceholder: "Enter member code",
    memberInvalidLink: "Invalid lookup link", memberNotFound: "Member not found", memberSearchFailed: "Search failed, please retry",
    memberRedeemSuccess: "Redeemed successfully!", memberRedeemFail: "Redeem failed",
    memberInsufficient: "Insufficient points", memberSoldOut: "Sold out", memberLimitReached: "Redeem limit reached",
    memberMyProfile: "Profile", memberMallTab: "Points Mall", memberOrdersTab: "Redeem History",
    memberPointsEarn: "Points earned", memberPointsRedeem: "Points redeemed",
    memberTimedEnded: "Ended", memberTimedNotStarted: "Not started", memberRedeemBtn: "Redeem",
    memberTrialExpired: "Expired", memberTrialDays: "Trial {days}d",
    memberTrialRemaining: "{days} days left",
    memberUpgradeProgress: "Upgrade Progress", memberNeedSpend: "Need to spend", memberMaxLevel: "Max level reached",
    mallFlashSale: "Flash Sale", couponCode: "Coupon Code",
    // Video Tutorials Page
    vidCatPos: "POS", vidCatProducts: "Products", vidCatInventory: "Inventory",
    vidCatSales: "Sales", vidCatCustomers: "Customers", vidCatReports: "Reports",
    vidCatSettings: "Settings", vidCatGeneral: "Other",
    vidRecStart: "Recording started! Click stop when done", vidRecFail: "Cannot start recording",
    vidUploadSuccess: "Video uploaded!", vidUploadFail: "Upload failed",
    vidDeleteConfirm: "Delete this video?", vidDeleted: "Deleted", vidDeleteFail: "Delete failed",
    vidUpdated: "Updated", vidUpdateFail: "Update failed",
    vidUploadBtn: "Upload Video", vidUploading: "Uploading...",
    vidRecHint: "Perform the actions you want to demo, then click Stop",
    vidNoData: "Click Start Recording to record a tutorial, or Upload Video to upload",
    vidTitleLabel: "Title", vidDefaultTitle: "Tutorial", vidVideoTitle: "Video Title",
    vidSaveUpload: "Save & Upload",
    startRecording: "Start Recording", stopRecording: "Stop Recording", recording: "Recording",
    vidPreviewTitle: "Recording Preview",
    vidGenerating: "Generating tutorial videos...",
    vidGenerateBtn: "Generate Tutorials",
    vidGeneratingBtn: "Generating...",
    vidGenerateSuccess: "Tutorials generated!",
    vidGenerateFail: "Generation failed",
    vidGenerateDesc: "Automatically recording operations and generating narrated tutorial videos.",
    vidProgress: "Progress",
    vidGenerateComplete: "Recording complete!",
    done: "Done", close: "Close",
    // Tenant Management & Subscription
    tenantManagement: "Tenant Management",
    addTenant: "Add Tenant",
    totalTenants: "Total Tenants",
    activeTenants: "Active Tenants",
    inactiveTenants: "Inactive Tenants",
    tenantName: "Tenant Name",
    tenantBusinessName: "Business Name",
    contactPerson: "Contact Person",
    details: "Details",
    plan: "Plan",
    subSubscription: "Subscription",
    subAlerts: "Subscription Alerts",
    subExpired: "Expired",
    subExpiringSoon: "Expiring Soon",
    subActive: "Active",
    subNone: "Not Set",
    subExpiringSoonList: "Expiring Soon",
    subExpiredList: "Expired Tenants",
    subDaysLeft: " left",
    subExpiryDate: "Expiry Date",
    subRenew: "Renew",
    subSuspend: "Suspend",
    subActivate: "Activate",
    subAnnualRevenue: "Annual Revenue",
    subStartDate: "Start Date",
    subYears: "Subscription Years",
    subYear: "yr",
    subAnnualFee: "Annual Fee",
    subNote: "Note",
    subNotePlaceholder: "Subscription notes...",
    subTrialAccount: "Trial Account",
    subTrialDays: "Trial Days",
    subAdminAccount: "Admin Account",
    subStatus: "Subscription Status",
    subCurrentExpiry: "Current Expiry",
    subRenewYears: "Renewal Years",
    subConfirmRenew: "Confirm Renewal",
    subTrial: "Trial",
    subDashExpiring: "Expiring Soon Alert",
    subDashDesc: "The following tenants are expiring or have expired",
    subCopyReminder: "Copy Reminder",
    subReminderCopied: "Reminder message copied to clipboard",
    subRenewReminder: "Renewal Reminder",
    subLastReminded: "Last Reminded",
    superAdmin: "Super Admin",
    // Trial Conversion
    trialTitle: "Trial Ending Soon",
    trialSubTitle: "Subscription Expiring",
    trialExpiredBadge: "Expired",
    trialRemaining: " remaining",
    trialOverdue: " overdue",
    trialExpiredMsg: "Your access has expired. Please contact the admin to renew and continue using all features.",
    trialExpiringMsg: "Please renew in time to ensure uninterrupted service. All your data will be safely preserved.",
    trialProducts: "Products",
    trialCustomers: "Customers",
    trialSales: "Orders",
    trialRevenue: "Revenue",
    trialStores: "Stores",
    trialSeeValue: "See your business achievements",
    trialValueTitle: "Your Achievements",
    trialValueMsg: "You have {products} products, served {customers} customers, completed {sales} transactions, with total revenue of ${revenue}. All this valuable data will continue to serve you after renewal.",
    trialAnnualFee: "Annual Fee",
    trialContactAdmin: "Contact your admin to renew. All features will be available immediately after renewal. Your data is safe!",
    // Self-Registration
    regTitle: "Try Sellox Free",
    regSubtitle: "7-day free trial, no credit card required",
    regCompanyName: "Company / Store Name",
    regCompanyPlaceholder: "Enter your company or store name",
    regContactPerson: "Contact Person",
    regContactPlaceholder: "Your name",
    regContactPhone: "Phone",
    regPhonePlaceholder: "Phone number",
    regAccountSection: "Set up your admin login",
    regAdminUsername: "Admin Username",
    regUsernamePlaceholder: "At least 3 characters",
    regPassword: "Password",
    regConfirmPassword: "Confirm Password",
    regPasswordMismatch: "Passwords do not match",
    regPasswordTooShort: "Password must be at least 6 characters",
    regTrialNote: "Register for a 7-day free trial with full access to all features. Contact us to upgrade after the trial ends.",
    regSubmit: "Register Now",
    regBackToLogin: "Already have an account? Back to login",
    regFreeTrialLink: "No account yet? Try free for 14 days",
    regSuccess: "Registration successful!",
    regSuccessTitle: "Registration Complete",
    regSuccessDesc: "Your trial account is ready. Please save the following login info",
    regTrialPeriod: "Trial Period",
    regDays: "days",
    regSaveCredentials: "Please remember your Tenant ID and username - you'll need them to log in. We recommend taking a screenshot or copying them.",
    regGoLogin: "Go to Login",
    regCopied: "Copied to clipboard",
    creditManagement: "Credit Management",
    referralRewards: "Referral Rewards",
    categoryImportSuccess: "Departments imported successfully",
    enterCategoryName: "Please enter category name",
    addCategory: "Add Category",
    catCode: "Code",
    catNameRequired: "Name",
    catRateLabel: "Exchange Rate",
    catNote: "Notes",
    systemRate: "System Rate",
    usdByRate: "USD (Rate",
    receiptSentEmail: "Receipt sent to email",
    sendFailed: "Send failed",
    changeFailed: "Change failed",
    confirmChange: "Confirm Change",
    importDepartments: "Import Categories",
    downloadDeptTemplate: "Download Category Template",
    editWarehouse: "Edit Warehouse",
    deleteWarehouseConfirm: "Confirm delete this warehouse?",
    cannotDeleteMainWarehouse: "Cannot delete main warehouse",
    warehouseHasStock: "Warehouse has stock, cannot delete",
    credit: "Credit",
    creditPayment: "Credit",
    selectCustomerForCredit: "Must select a customer for credit payment",
    creditRecorded: "Credit recorded",
    paymentCurrencyLabel: "Payment Currency",
    bsPayment: "Pay in Bs",
    usdPayment: "Pay in $",
    selectPrinter: "Select printer:",
    scanQrReceipt: "Customer scan QR for digital receipt",
    emailSendReceipt: "Email receipt",
    bsPaid: "Bs payment",
    usdPaid: "$ payment",
    invalidLink: "Invalid link",
    receiptNotFound: "Receipt not found or expired",
    paymentSuccess: "Payment successful",
    orderNoLabel: "Order #",
    customerLabel: "Customer",
    discountLabel: "Discount",
    subtotalLabel: "Total",
    bsReference: "Bs. ref.",
    paymentMethodLabel: "Payment method",
    thankYou: "Thank you for your purchase",
    pmCash: "Cash",
    pmCard: "Card",
    pmTransfer: "Transfer",
    pmMixed: "Mixed",
    creditManage: "Credit Management",
    newCredit: "New Credit",
    totalCreditAmount: "Total Credit",
    creditRecovered: "Recovered",
    creditOutstanding: "Outstanding",
    creditPendingCount: "Pending",
    debtRanking: "Debt Ranking",
    creditCount: "entries",
    searchCustomerName: "Search customer...",
    creditStatusPending: "Unpaid",
    creditStatusPartial: "Partial",
    creditStatusPaid: "Paid",
    creditCustomer: "Customer",
    creditAmount: "Credit Amount",
    creditPaid: "Repaid",
    creditBalance: "Balance",
    creditDate: "Date",
    creditStatus: "Status",
    creditAction: "Actions",
    repayment: "Repayment",
    repaymentRecord: "Payment history:",
    noCreditRecord: "No credit records",
    selectCustomerRequired: "Please select a customer",
    enterAmount: "Please enter amount",
    creditAdded: "Credit record added",
    enterRepayAmount: "Please enter repayment amount",
    repaySuccess: "Repayment successful",
    repayAmount: "Repayment Amount",
    repayMethod: "Payment Method",
    remarkLabel: "Notes",
    remarkPlaceholder: "Optional...",
    monthlyGoods: "e.g. March goods...",
    selectedLabel: "Selected",
    importDemoData: "Import Demo Data",
    demoDataImported: "Demo data imported",
    copyCatalogLink: "Copy Catalog Link",
    catalogLinkCopied: "Catalog link copied",
    extraBarcodes: "Extra Barcodes",
    importProductsLabel: "Import Products",
    deptIdAsRate: "Category ID as Rate",
    deptIdAsRateDesc: "Use category ID column as exchange rate, auto-convert Bs price to $ ($ = Bs / rate)",
    deptImportFormat: "Category format: code, name, rate, sort",
    deptImportExample: "e.g. C001, Phone Case, 600, 1",
    allOrders: "All Orders",
    normalView: "Normal View",
    adminVerify: "Admin Verification",
    enterPinToView: "Enter admin PIN to view all orders",
    showAllOrders: "Show all orders",
    pinError: "PIN error",
    refundAmountLabel: "Refund Amount",
    refundReasonPlaceholder: "Refund reason (optional)",
    enterOrderNumber: "Enter order number to search",
    refundOnlyManagers: "Only managers/admins can process refunds",
    refundSearchHint: "Or search order history by filters",
    refundKeywordPlaceholder: "Order #, product, customer...",
    refundSearchOrders: "Search Orders",
    refundResultsFound: "orders found",
    refundClickToSelect: "click to select for refund",
    refundSearchTip: "Enter order number directly, or search by product name, date, etc.",
    back: "Back",
    promoDiscount: "Discount",
    promoFullReduction: "Spend & Save",
    promoBuyGet: "Buy & Get",
    promoFlashSale: "Flash Sale",
    promoStatusInactive: "Inactive",
    promoStatusEnded: "Ended",
    promoStatusPending: "Upcoming",
    promoStatusActive: "Active",
    promoEnabled: "Enabled",
    promoDisabled: "Disabled",
    promoAllActivities: "All Promotions",
    promoActiveCount: "Active",
    promoUpcomingCount: "Upcoming",
    promoName: "Promotion Name",
    promoType: "Type",
    promoContent: "Offer Details",
    promoScope: "Applies To",
    promoTime: "Duration",
    promoDiscountTitle: "Discount Promotion",
    promoDiscountDesc: "Apply percentage discount to products. e.g. 20% off storewide",
    promoDiscountFieldVal: "Discount (%)",
    promoDiscountFieldValHint: "Enter discount percentage. e.g. 20 means 20% off",
    promoDiscountFieldMin: "Min. Amount ($)",
    promoDiscountFieldMinHint: "Min. order amount required. 0 = no minimum",
    promoDiscountExample: "Example: 20% off → Discount=20, Min=0",
    promoFullRedTitle: "Spend & Save",
    promoFullRedDesc: "Spend minimum amount, get fixed reduction. e.g. Spend $100 save $10",
    promoFullRedFieldAmt: "Savings ($)",
    promoFullRedFieldAmtHint: "Amount to reduce in dollars",
    promoFullRedFieldMin: "Min. Spend ($)",
    promoFullRedFieldMinHint: "Minimum spending required",
    promoFullRedExample: "Example: Spend $50 save $5 → Savings=5, Min=50",
    promoBuyGetTitle: "Buy & Get Free",
    promoBuyGetDesc: "Buy specified quantity, get free items. e.g. Buy 2 Get 1",
    promoBuyQty: "Buy Quantity",
    promoBuyQtyHint: "Quantity customer must purchase",
    promoGetQty: "Free Quantity",
    promoGetQtyHint: "Quantity given for free",
    promoBuyGetExample: "Example: Buy 3 Get 1 → Buy=3, Free=1",
    promoFlashTitle: "Flash Sale",
    promoFlashDesc: "Special pricing during promotion period. Must set dates",
    promoFlashPrice: "Sale Price ($)",
    promoFlashPriceHint: "Price during promotion period",
    promoFlashMinHint: "N/A, leave 0",
    promoFlashExample: "Example: $65 headphones → Sale=39.9",
    promoNamePlaceholder: "e.g. 20% Off, Spend $100 Save $10...",
    promoDiscountValLabel: "Discount (%)",
    promoPayPercent: "Pay",
    promoMinSpendLabel: "Min. Spend ($)",
    promoMinAmtLabel: "Min. Amount ($)",
    promoReductionAmtLabel: "Savings ($)",
    promoOrigPriceRef: "Original Price ($)",
    promoOptionalDisplay: "Optional, display only",
    promoStartDate: "Start Date",
    promoEndDate: "End Date",
    promoApplyScope: "Applies To",
    promoAllProducts: "All Products",
    promoByCategory: "By Category",
    promoByProduct: "By Product",
    promoSelectCategories: "Select categories:",
    promoMinOneCategory: "Select at least one category",
    promoSelectProducts: "Select products:",
    promoSearchProduct: "Search by name or code",
    promoSelectedProducts: "Selected",
    promoProducts: "products",
    promoMinOneProduct: "Select at least one product",
    promoDescription: "Description (optional)",
    promoDescPlaceholder: "Additional notes for staff or customers...",
    promoPreview: "Preview:",
    promoFullDiscountLabel: "Storewide",
    promoLimitedOffer: "Flash Sale",
    promoCategories: "categories",
    enterPromoName: "Please enter promotion name",
    setPromoDate: "Please set start and end dates",
    endBeforeStart: "End date cannot be before start date",
    discountRange: "Discount must be between 1-100",
    fullRedMinRequired: "Spend & Save requires minimum amount",
    enterReductionAmt: "Please enter savings amount",
    setFlashPrice: "Please set sale price",
    editPromotion: "Edit Promotion",
    addPromotionDialog: "Add Promotion",
    fullRedLabel: "Spend $",
    fullRedOff: "Save $",
    buyLabel: "Buy",
    getLabel: "Get",
    specifiedCats: "By Category",
    merchantId: "Merchant ID",
    barcode: "Barcode",
    specification: "Spec / Weight",
    specPlaceholder: "e.g. 500g, 1L, XL...",
    currentId: "Current ID",
    merchantIdDesc: "Used for online catalog links, online store, etc. You must re-login after changing.",
    changeMerchantId: "Change Merchant ID",
    newId: "New ID",
    merchantIdRule: "4-20 characters, lowercase letters, numbers, hyphens, underscores only",
    changeIdWarning: "You must re-login after changing. Online store and catalog links will also change.",
    merchantIdPlaceholder: "e.g. my-shop-001",
    // B2B / Franchise HQ
    b2bPortal: "B2B Wholesale", franchiseHQ: "Franchise HQ", franchiseOverview: "Franchise Overview",
    crossStoreInventory: "Cross-Store Inventory", pushPrices: "Push Prices", topProducts: "Top Products",
    b2bCustomers: "B2B Customers", creditLimit: "Credit Limit", paymentTerms: "Payment Terms",
    outstanding: "Outstanding", customerType: "Customer Type", discountRate: "Discount Rate",
    retailCustomer: "Retail", wholesaleCustomer: "Wholesale", vipCustomer: "VIP",
    totalStores: "Total Stores", todaySalesAll: "Today Sales", weekSalesAll: "Week Sales",
    monthSalesAll: "Month Sales", storePerformance: "Store Performance", storeName: "Store Name",
    storeAddress: "Address", noStoresYet: "No stores yet",
    pushPriceSuccess: "Prices pushed", selectProductsFirst: "Select products first",
    batchPriceUpdate: "Batch Price Update", retailPrice: "Retail Price", wholesalePrice: "Wholesale Price",
    applyPriceChanges: "Apply Changes", priceUpdated: "Prices updated",
    allWarehouses: "All Warehouses", totalQuantity: "Total Qty", headquarters: "HQ",
    // Smart Restock
    smartRestock: "Smart Restock", restockSuggestions: "Restock Suggestions", salesVelocity: "Sales Velocity",
    dailyAvgSales: "Daily Avg", weeklyAvgSales: "Weekly Avg", daysUntilStockout: "Days to Stockout",
    suggestedQty: "Suggested Qty", suggestedCost: "Suggested Cost", urgencyLevel: "Urgency",
    urgencyCritical: "Out of Stock", urgencyUrgent: "Urgent", urgencyWarning: "Warning", urgencyLow: "Low",
    urgencyOk: "OK", analysisPeriod: "Period", days30: "30 Days", days60: "60 Days", days90: "90 Days",
    totalRestockCost: "Total Restock Cost", restockItems: "Items to Restock",
    salesTrend: "Trend", trendUp: "Up", trendDown: "Down", trendFlat: "Flat",
    speedFast: "Fast", speedMedium: "Medium", speedSlow: "Slow", speedDead: "Dead Stock",
    generatePO: "Generate PO", exportRestockList: "Export List",
    currentStock: "Current Stock", minStockLevel: "Min Stock",
    periodSold: "Sold in Period",
    importToCategory: "Import to Category", importSelectCategory: "Select Category", importCategoryHint: "All imported products will be assigned to this category", noCategoryAssign: "None (use file categories)",
    importFieldSelect: "Select Import Fields", importFieldHint: "Basic info (code, name, spec) always imported", allCategories: "All Categories",
    storeManagerPanel: "Store Manager", dailySummary: "Daily Summary", viewInventory: "Inventory",
    printDailySummary: "Print Daily Summary", viewOrderDetail: "View Order Details",
    transferManagement: "Transfer Management", newTransferOrder: "New Transfer Order", transferOrderNo: "Transfer No.",
    fromWarehouse: "From Warehouse", toWarehouse: "To Warehouse", totalQuantity: "Total Qty",
    pendingReceive: "Pending", transferReceived: "Received", receiveTransfer: "Receive Transfer",
    sentQuantity: "Sent Qty", receivedQuantity: "Received Qty", confirmReceive: "Confirm Receipt",
    receiveSuccess: "Received", createAndPrint: "Create & Print", selectWarehouse: "Select Warehouse",
    addProducts: "Add Products", searchProduct: "Search product...",

    accountNumber: "Account Number",
    accountsPayable: "Accounts Payable",
    action: "Action",
    activeCombos: "Active Combos",
    actual: "Actual",
    actualQty: "Actual Qty",
    add: "Add",
    addCustomer: "Add Customer",
    addExpense: "Add Expense",
    addGroup: "Add Group",
    addNote: "Add Note",
    addPayable: "Add Payable",
    addPaymentMethod: "Add Payment Method",
    addPromotion: "Add Promotion",
    addReceivable: "Add Receivable",
    addStore: "Add Store",
    addSuccess: "Added successfully",
    addSupplier: "Add Supplier",
    addWarehouse: "Add Warehouse",
    address: "Address",
    adminManual: "Admin Manual",
    all: "All",
    allCategories: "All Categories",
    allReasons: "All Reasons",
    amount: "Amount",
    amountRequired: "Amount required",
    analysisPeriod: "Analysis Period",
    approve: "Approve",
    associatedWarehouse: "Associated Warehouse",
    availableQty: "Available Qty",
    avgComboValue: "Avg Combo Value",
    avgOrder: "Avg Order",
    backupDesc: "Backup Description",
    balance: "Balance",
    batchDelete: "Batch Delete",
    bundleName: "Bundle Name",
    bundlePrice: "Bundle Price",
    businessType: "Business Type",
    cancel: "Cancel",
    cancelOrder: "Cancel Order",
    cancelled: "Cancelled",
    card: "Card",
    cash: "Cash",
    casheaAmount: "Cashea Amount",
    casheaDesc: "Cashea Installments",
    casheaLiveMode: "Cashea Live Mode - Connected",
    casheaSettingsDesc: "Buy now, pay later - interest free installments",
    category: "Category",
    categoryManagement: "Category Management",
    categoryRates: "Category Rates",
    change: "Change",
    checkoutTitle: "Checkout",
    clearNote: "Clear Note",
    cleared: "Cleared",
    clockIn: "Clock In",
    clockOut: "Clock Out",
    close: "Close",
    closeAllBrowserFirst: "Close all browser windows first",
    code: "Code",
    comboOrders: "Combo Orders",
    comboRevenue: "Combo Revenue",
    comboSalesDistribution: "Combo Sales Distribution",
    commissionReport: "Commission Report",
    commissionRules: "Commission Rules",
    companyAddress: "Company Address",
    companyPhone: "Company Phone",
    completed: "Completed",
    completedStatus: "Completed",
    confirm: "Confirm",
    confirmClearPending: "Confirm clear pending orders?",
    confirmDelete: "Confirm Delete",
    confirmPayment: "Confirm Payment",
    confirmReceive: "Confirm Receive",
    confirmStockLoss: "Confirm Stock Loss",
    connectionPort: "Connection Port",
    cost: "Cost",
    costLoss: "Cost Loss",
    costPrice: "Cost Price",
    couponCode: "Coupon Code",
    createAndPrint: "Create & Print",
    createSuccess: "Created successfully",
    createTime: "Created At",
    createWholesaleOrder: "Create Wholesale Order",
    creditLimit: "Credit Limit",
    creditor: "Creditor",
    currency: "Currency",
    customerName: "Customer Name",
    customerType: "Customer Type",
    dailySummary: "Daily Summary",
    date: "Date",
    dateTo: "To",
    days30: "30 Days",
    days60: "60 Days",
    days90: "90 Days",
    daysUntilStockout: "Days Until Stockout",
    defaultOption: "Default Option",
    defaultWarehouse: "Default Warehouse",
    delete: "Delete",
    deleteEmployeeConfirm: "Confirm delete this employee?",
    deleteFailed: "Delete failed",
    deleteImage: "Delete Image",
    deleteSelected: "Delete Selected",
    description: "Description",
    directPrintFailed: "Direct print failed",
    discountAboveCostDesc: "Discount price below cost",
    downloadShortcut: "Download Shortcut",
    downloadTemplate: "Download Template",
    edit: "Edit",
    editEmployee: "Edit Employee",
    editProduct: "Edit Product",
    email: "Email",
    employees: "Employees",
    enableCashDrawer: "Enable Cash Drawer",
    endShift: "End Shift",
    enterOrderNote: "Enter order note",
    enterPos: "Enter POS",
    estimatedCommission: "Estimated Commission",
    example: "Example",
    excellentTier: "Excellent Tier",
    exchangeRates: "Exchange Rates",
    expenseByStore: "Expense by Store",
    expenseCount: "Expense Count",
    expenseDesc: "Expense Description",
    expenseDescPlaceholder: "Enter expense description",
    expenseManagement: "Expense Management",
    export: "Export",
    exportBackup: "Export Backup",
    exportInventoryReport: "Export Inventory Report",
    exportRestockList: "Export Restock List",
    extraHot: "Extra Hot",
    failed: "Failed",
    fillCompleteInfo: "Please fill complete info",
    fiscalPrinter: "Fiscal Printer",
    franchiseHQ: "Headquarters",
    franchiseOverview: "Franchise Overview",
    generateReport: "Generate Report",
    gold: "Gold",
    grossProfit: "Gross Profit",
    groupName: "Group Name",
    headquarters: "Headquarters",
    holdOrder: "Hold Order",
    hours: "Hours",
    html2canvas: "html2canvas",
    idNumber: "ID Number",
    iframe: "iframe",
    importCategoryHint: "Import to category",
    importFieldHint: "Select import fields",
    importResult: "Import Result",
    importSelectCategory: "Select import category",
    importSuccess: "Import successful",
    inventoryList: "Inventory List",
    inventoryQty: "Inventory Qty",
    invoiceFooter: "Invoice Footer",
    itemCount: "Item Count",
    itemNote: "Item Note",
    items: "items",
    jspdf: "jspdf",
    labelModeP1: "Price 1 (Retail)",
    labelModeP1P3: "Price 1 + Price 3",
    labelModeP1W: "Price 1 + Wholesale",
    labelModeP3: "Price 3 (Wholesale)",
    labelModeUsdP1: "USD Price 1 (Retail)",
    labelModeWholesale: "Box Price (Wholesale)",
    labelNoDecimals: "No Decimals",
    labelShowBarcode: "Show Barcode",
    labelShowForeign: "Show Foreign Currency ($)",
    labelShowBs: "Show Bs.",
    labelPaperSize: "Paper",
    labelSize80mm: "80mm Thermal",
    labelSize50x30: "50x30mm Sticker",
    labelBilingual: "Bilingual (ES+CN)",
    last30Days: "Last 30 Days",
    last7Days: "Last 7 Days",
    lessIce: "Less Ice",
    loadFailed: "Load failed",
    loading: "Loading...",
    loginExpired: "Session expired, please re-login",
    login: "Login",
    logout: "Logout",
    loyaltyTierBenefits: "Tier Benefits",
    mainWarehouse: "Main Warehouse",
    margin: "Margin",
    markDelivered: "Mark Delivered",
    maxDiscount: "Max Discount",
    memberCodePlaceholder: "Enter member code",
    memberGold: "Gold Member",
    memberLimitReached: "Member limit reached",
    memberMallTab: "Points Mall",
    memberMaxLevel: "Max Level",
    memberNeedSpend: "Need to spend",
    memberNotFound: "Member not found",
    memberOrdersTab: "Order History",
    memberPointsRedeem: "Redeem Points",
    memberRedeemBtn: "Redeem",
    memberRedeemFail: "Redeem failed",
    memberSearchFailed: "Search failed",
    memberSilver: "Silver Member",
    memberSoldOut: "Sold Out",
    memberTimedNotStarted: "Event not started",
    memberTrialDays: "Trial Days",
    memberVip: "VIP Member",
    minSpent: "Min Spent",
    minStockLevel: "Min Stock Level",
    mixed: "Mixed",
    mobilePay: "Mobile Pay",
    monthly: "Monthly",
    newStockLoss: "New Stock Loss",
    newTransferOrder: "New Transfer Order",
    noCategoryAssign: "No category assigned",
    noComboSalesYet: "No combo sales yet",
    noCustomerNoPoints: "No customer, no points",
    noData: "No data",
    noOnion: "No Onion",
    noOptGroups: "No option groups",
    noShift: "No shift",
    noStoresYet: "No stores yet",
    note: "Note",
    notifications: "Notifications",
    offline: "Offline",
    offlineCacheMode: "Offline Cache Mode",
    offlineMode: "Offline Mode",
    onlineOrderTotal: "Online Order Total",
    onlineStore: "Online Store",
    operator: "Operator",
    optionStats: "Option Stats",
    optionalGroups: "Optional Groups",
    options: "Options",
    orderComplete: "Order Complete",
    orderCount: "Order Count",
    orderDetail: "Order Detail",
    orderNo: "Order No.",
    orderNote: "Order Note",
    orderNotes: "Order Notes",
    originalPrice: "Original Price",
    overallMargin: "Overall Margin",
    overwriteDuplicate: "Overwrite Duplicates",
    paidAmount: "Paid Amount",
    paperSize: "Paper Size",
    password: "Password",
    payable: "Payable",
    paymentAmount: "Payment Amount",
    paymentInfo: "Payment Info",
    pending: "Pending",
    pendingOrdersNotif: "Pending Orders Notification",
    pendingStatus: "Pending",
    phone: "Phone",
    pieces: "pcs",
    plan_enterprise: "Enterprise",
    plan_pro: "Professional",
    points: "Points",
    pointsAvailable: "Points Available",
    pointsEarned: "Points Earned",
    pointsHistory: "Points History",
    pointsMultiplier: "Points Multiplier",
    pointsRate: "Points Rate",
    posLogin: "POS Login",
    posLoginHint: "Cashier login",
    posMode: "POS Mode",
    posReceiptPrinter: "POS Receipt Printer",
    present: "Present",
    price: "Price",
    price2: "Price 2",
    price3Box: "Price 3/Box",
    priceSettings: "Price Settings",
    priceType: "Price Type",
    pricing: "Pricing",
    printFormat: "Print Format",
    printInvoiceA4: "Print A4 Invoice",
    printItemCode: "Print Item Code",
    printMethod: "Print Method",
    printOrder: "Print Order",
    printReceipt: "Print Receipt",
    printSuccess: "Print successful",
    printTime: "Print Time",
    printerConnectFailed: "Printer connection failed",
    printerConnected: "Printer connected",
    printerGuide: "Printer Guide",
    printerModel: "Printer Model",
    printerReady: "Printer Ready",
    printing: "Printing...",
    processing: "Processing...",
    product: "Product",
    productName: "Product Name",
    profit: "Profit",
    progress: "Progress",
    providedByAdmin: "Provided by admin",
    pushPrices: "Push Prices",
    qty: "Qty",
    quantity: "Quantity",
    quarterly: "Quarterly",
    quickActions: "Quick Actions",
    ratesUpdated: "Rates updated",
    recallOrder: "Recall Order",
    receiptCopies: "Receipt Copies",
    receiptDetail: "Receipt Detail",
    receiveTransfer: "Receive Transfer",
    receivedQuantity: "Received Qty",
    receivedStatus: "Received",
    recordPayment: "Record Payment",
    recording: "Recording",
    records: "Records",
    redeemPoints: "Redeem Points",
    ref: "Ref",
    refundReason: "Refund Reason",
    remaining: "Remaining",
    remainingAmount: "Remaining Amount",
    reportPrinter: "Report Printer",
    reports: "Reports",
    reprintReceipt: "Reprint Receipt",
    restockItems: "Restock Items",
    restockSuggestions: "Restock Suggestions",
    restoreBackup: "Restore Backup",
    restoreWarning: "Restore will overwrite current data",
    retailPrice: "Retail Price",
    returnReason: "Return Reason",
    revenue: "Revenue",
    rightClickClear: "Right-click to clear",
    salesExchangeRateDesc: "Sales Exchange Rate Description",
    salesManagement: "Sales Management",
    salesOrder: "Sales Order",
    salesRateDesc: "Sales Rate Description",
    salesVelocity: "Sales Velocity",
    save: "Save",
    saveRates: "Save Rates",
    saveSettings: "Save Settings",
    scale: "Scale",
    scanOrSearch: "Scan or search",
    scannerEnabled: "Scanner enabled",
    searchProducts: "Search products",
    selectAll: "Select All",
    selectCustomer: "Select Customer",
    selectImage: "Select Image",
    selectProduct: "Select Product",
    selectProductsFirst: "Select products first",
    selectStore: "Select Store",
    selectedCount: "selected",
    setDefaultPrinter: "Set as default printer",
    settingsSaved: "Settings saved",
    shipped: "Shipped",
    shopDescPlaceholder: "e.g., Fresh produce, daily delivery",
    shopDescription: "Shop Description",
    shopPreview: "Shop Preview",
    skip: "Skip",
    skipDuplicate: "Skip Duplicates",
    skipped: "Skipped",
    soldQuantity: "Sold Qty",
    staleDataInfo: "Data may be outdated",
    staleDataWarning: "Stale data warning",
    standardTier: "Standard Tier",
    startImport: "Start Import",
    status: "Status",
    statusCancelled: "Cancelled",
    statusCompleted: "Completed",
    statusPending: "Pending",
    stockAlerts: "Stock Alerts",
    stockLossCostEstimate: "Stock Loss Cost Estimate",
    stockLossManagement: "Stock Loss Management",
    stockLossQty: "Stock Loss Qty",
    stockLossReason: "Stock Loss Reason",
    stockLossSuccess: "Stock loss recorded",
    stockLow: "Low Stock",
    stockTaking: "Stock Taking",
    stopRecording: "Stop Recording",
    storeFilter: "Store Filter",
    storeManagement: "Store Management",
    storeName: "Store Name",
    storePerformance: "Store Performance",
    stores: "Stores",
    suggestedCost: "Suggested Cost",
    supplierManagement: "Supplier Management",
    supplierName: "Supplier Name",
    syncPending: "Sync Pending",
    systemQty: "System Qty",
    takeaway: "Takeaway",
    targetAmount: "Target Amount",
    targetType: "Target Type",
    taxId: "Tax ID / RIF",
    tenantIdLabel: "Tenant ID",
    tenantLogin: "Merchant Login",
    testPrint: "Test Print",
    themeBakery: "Bakery",
    themeButcher: "Butcher",
    themeClothing: "Clothing",
    themeCustom: "Custom",
    themeDepartment: "Department Store",
    themeElectronics: "Electronics",
    themeGeneral: "General",
    themePharmacy: "Pharmacy",
    themeRestaurant: "Restaurant",
    tier: "Tier",
    time: "Time",
    toWarehouse: "To Warehouse",
    todaySalesAll: "Today's Total Sales",
    topProducts: "Top Products",
    topupBalance: "Top Up Balance",
    total: "Total",
    totalExpenses: "Total Expenses",
    totalLossQty: "Total Loss Qty",
    totalLossRecords: "Total Loss Records",
    totalOrders: "Total Orders",
    totalProducts: "Total Products",
    totalProfit: "Total Profit",
    totalQuantity: "Total Quantity",
    totalRevenue: "Total Revenue",
    totalSales: "Total Sales",
    totalSpent: "Total Spent",
    transferOrderNo: "Transfer Order No.",
    trendFlat: "Flat",
    type: "Type",
    updateSuccess: "Updated successfully",
    updated: "Updated",
    uploadSuccess: "Upload successful",
    urgencyLevel: "Urgency Level",
    urgencyLow: "Low",
    urgencyUrgent: "Urgent",
    urgencyWarning: "Warning",
    urgent: "Urgent",
    userManual: "User Manual",
    vidDefaultTitle: "Tutorial Video",
    vidDeleteFail: "Delete video failed",
    vidDeleted: "Video deleted",
    vidRecFail: "Recording failed",
    vidUpdateFail: "Update video failed",
    vidUploadFail: "Upload video failed",
    vidUploading: "Uploading...",
    vidVideoTitle: "Video Title",
    videoTutorials: "Video Tutorials",
    viewInventory: "View Inventory",
    viewOrderDetail: "View Order Detail",
    vip: "VIP",
    vipCustomer: "VIP Customer",
    warehouse: "Warehouse",
    warehouseManagement: "Warehouse Management",
    warehouseName: "Warehouse Name",
    weekSalesAll: "Week's Total Sales",
    weeklyAvgSales: "Weekly Avg Sales",
    wholesaleDiscount: "Wholesale Discount",
    wholesaleMinQty: "Wholesale Min Qty",
    wholesaleOrder: "Wholesale Order",
    cashBalance: "Cash Balance",
    cashUsd: "USD Cash",
    cashVes: "VES Cash",
    cashTransaction: "Cash Transaction",
    cashDeposit: "Deposit",
    cashWithdraw: "Withdraw",
    cashHandover: "Handover",
    cashAdjustment: "Adjustment",
    recentRecords: "Recent Records",
    employeeAccounts: "Employee Accounts",
    employee: "Employee",
    newEmpTransaction: "New Employee Transaction",
    selectEmployee: "Select Employee",
    loanToEmployee: "Loan to Employee",
    goodsCreditToEmployee: "Goods Credit",
    employeeRepayment: "Employee Repayment",
    salaryDeduction: "Salary Deduction",
    transactionHistory: "Transaction History",
    productInfo: "Product Info",
    productInfoPlaceholder: "Goods credit details...",
    noEmployeeDebt: "No employee debt records",
    notePlaceholder: "Note...",
    owes: "Owes",
    loans: "Loans",
    goodsCredit: "Goods Credit",
    repaid: "Repaid",
    sale: "Sale",
    exchange: "Exchange",
    addEmployee: "Add Employee",
    idCard: "ID Card",
    employeeStatement: "Employee Statement",
    currentBalance: "Current Balance",
    orderNoLookup: "Enter order number to auto-fill",
    date: "Date",
    staff: "Staff",
    cashier: "Cashier",
    byCashier: "By Cashier",
    filterByCashier: "Filter by Cashier",
    storeManager: "Store Manager",
    employeeCredit: "Employee Credit",
    printTime: "Print Time",
    paySalary: "Pay Salary",
    grossSalary: "Gross Salary",
    deductFromSalary: "Deduct from salary",
    netPay: "Net Pay",
    deductMax: "Max Deduct",
    noDeduct: "No deduct (all cash)",
    repayByBs: "Repay in Bs →",
    repayByBsHint: "Employee repays in Bs → auto-convert to USD deduction",
    rateManagerCustom: "Manager: custom rate",
    rateStaffBcv: "Staff: BCV rate",
    balance: "Balance",
    employeeReceivables: "Employee Receivables",
    employeeReceivablesNote: "Outstanding",
    totalOwed: "Total Owed",
    absencePenalty: "Absence Penalty",
    creditLimit: "Credit Limit",
    creditLimitWarning: "Credit limit exceeded!",
    currentOwed: "Current Owed",
    afterTxn: "After",
    overBy: "Over by",
    todayAttendance: "Today's Attendance",
    clockIn: "Clock In",
    clockOut: "Clock Out",
    onDuty: "On Duty",
    offDuty: "Off Duty",
    notClockedIn: "Not Clocked In",
    fullDay: "Full Day",
    halfDay: "Half Day",
    absent: "Absent",
    dailyRate: "Daily Rate",
    fullDays: "Full Days",
    halfDays: "Half Days",
    absentDays: "Absent",
    currentDebt: "Debt",
    salaryCalcMode: "Calc Mode",
    autoCalc: "Auto",
    manualInput: "Manual",
    autoAdjustable: "Auto+Adjust",
    salaryAmount: "Salary Amount",
    payCycle: "Pay Cycle",
    weekly: "Weekly",
    biweekly: "Biweekly",
    monthly: "Monthly",
    siteMonitor: "Site Monitor",
    monitorCheckNow: "Check Now",
    monitorCurrentStatus: "Current Status",
    monitorUptime24h: "Uptime (24h)",
    monitorTotalChecks: "Total Checks",
    monitorAlertConfig: "Alert Configuration",
    monitorAlertEmail: "Alert Email",
    monitorEmailRequired: "Please enter alert email",
    monitorKeyRequired: "Please enter Resend API key",
    monitorSettingsSaved: "Monitor settings saved",
    monitorConfigured: "Configured",
    monitorResendHelp: "Get your free API key at",
    monitorResendHelp2: "to receive downtime alerts.",
    monitorSendTest: "Send Test Alert",
    monitorRecentLogs: "Recent Health Checks",
    monitorNoLogs: "No logs yet. The system checks every 5 minutes.",
    storeReceiptInfo: "Invoice / Receipt Info",
    storeReceiptInfoHint: "If set, receipts for this store will use this info instead of the company default.",
    storeReceiptName: "Business Name (Invoice)",
    storeReceiptNamePlaceholder: "e.g. ALFONZO SHOP C.A.",
    storeReceiptAddress: "Receipt Address 1",
    storeReceiptAddress2: "Receipt Address 2",
    storeReceiptPhone: "Receipt Phone",
    inventoryDownloadTemplate: "Download Template",
    inventoryImport: "Import Inventory",
    inventoryTemplateDownloaded: "Template downloaded",
    inventoryImportSuccess: "Import completed",
    importing: "Importing...",
    created: "created",
    updated: "updated",
    skipped: "skipped",
    allStores: "All Stores",
    allowedHours: "Allowed Hours (empty=no limit)",
    allowedHoursHint: "Venezuela time (UTC-4). E.g. 07:00 ~ 22:00",
    allowedIPs: "IP Whitelist (empty=no limit)",
    allowedIPsHint: "Separate IPs with commas. Admin/Manager exempt.",
    attendanceHistory: "Attendance History",
    avgPerOrder: "Avg per Order",
    bsCashGiven: "USD Cash Given ($)",
    bsCost: "Bs Cost",
    bsValue: "Bs Value",
    buyRate: "Buy Rate",
    byCurrency: "By Currency",
    byPaymentMethod: "By Payment Method",
    cashGiven: "Cash Given",
    categoryBreakdown: "Category Breakdown",
    categoryName: "Category Name",
    clockedIn: "Clocked In",
    costUsd: "Cost (USD)",
    dailyBreakdown: "Daily Breakdown",
    days: "days",
    downloadFailed: "Download failed",
    exchangeRate: "Exchange Rate",
    expenses: "Expenses",
    expenseFood: "Food",
    expenseSalary: "Salary",
    expenseSupplies: "Supplies",
    expenseTax: "Tax",
    expenseTransport: "Transport",
    expenseUtilities: "Utilities",
    expired: "Expired",
    lastDays: "Last Days",
    lastMonth: "Last Month",
    loadingData: "Connecting to server and loading data",
    lossBreakdown: "Loss Breakdown",
    mixedPayment: "Mixed Payment",
    netProfit: "Net Profit",
    nextPage: "Next",
    noSearchResult: "No results found",
    prevPage: "Previous",
    print: "Print",
    profitUsd: "Profit (USD)",
    rateLabel: "Rate",
    sales: "Sales",
    salesBs: "Sales (Bs)",
    schedule: "Schedule",
    sellRate: "Sell Rate",
    showing: "Showing",
    split: "Split",
    store: "Store",
    subtotal: "Subtotal",
    thisMonth: "This Month",
    todayProfitUsd: "Today Profit (USD)",
    totalDue: "Total Due",
    totalEmployees: "Total Employees",
    unassignedStore: "Unassigned",
    usdCashGiven: "USD Cash Given ($)",
    usdEquivalent: "USD Equivalent",
    selectedRate: "Selected Rate",
    sample: "Sample",
    other: "Other",
    personalUse: "Personal Use",
    blackMarket: "Black Market",
    blackMarketGoods: "Black Market Goods",
    buyUsdCash: "Buy USD Cash",
    cardToCash: "Card to Cash",
    cashMustBeLess: "Cash must be less than total",
    commissionPct: "Commission %",
    installApp: "Install App",
    installAppHint: "Open in Chrome to install as App",
    // AI Feature
    aiFeatures: "AI Features",
    aiEnabled: "AI Enabled",
    aiDisabled: "AI Disabled",
    aiToggle: "AI Toggle",
    aiSubscriptionFee: "AI Monthly Fee",
    aiFeatureNote: "AI features require extra fee",
    aiRegDisclaimer: "AI features (smart assistant, payment receipt verification, etc.) require an additional subscription and are not included in the base plan.",
    aiCostPerMsg: "per message",
    aiCostPerImg: "per image verification",
    aiMonthlyFee: "AI Monthly Fee ($)",
    aiToggleOn: "Enable AI",
    aiToggleOff: "Disable AI",
    // Auth Scan
    authRequired: "Authorization Required",
    authAction: "Action",
    authScanHint: "Ask manager to scan their auth QR code",
    authScanPlaceholder: "Scan code or enter auth code...",
    verify: "Verify",
    verifying: "Verifying...",
    authSuccess: "Authorized",
    authFailed: "Authorization Failed",
    authorizer: "Authorized by",
    authCodeGenerate: "Generate Auth Code",
    authCodeRegenerate: "Regenerate",
    authCodePrint: "Print QR Code",
    noAuthCode: "No auth code generated",
    authCodeGenerated: "Auth code generated",
    priceSwitchNeedAuth: "Price switch requires manager authorization",
    refundNeedAuth: "Refund requires manager authorization",
    onlyManagerCanSwitch: "Only manager/admin can switch price",
    boxModeNoStock: "Not enough stock for a full box",
    // Payment methods
    totalDue: "Total Due",
    totalPaid: "Total Paid",
    remaining: "Remaining",
    // Credit overdue
    creditOverdue: "Overdue",
    creditDueSoon: "Due Soon",
    creditDueDate: "Due Date",
    creditAlerts: "Credit Due Alerts",
    creditOverdaysDays: "Overdue",
    creditDueSoonDays: "Remaining",
    days: "days",
    noOverdueCredits: "No overdue credits",
    // Price check
    priceCheck: "Price Check",
    priceCheckSearch: "Enter product name/barcode...",
    canViewPrices: "View Prices",
    // Wholesale order
    wholesaleOrder: "Wholesale Order",
    selectCustomer: "Select Customer",
    addCustomer: "Add Customer",
    addProductsFirst: "Search and add products to order",
    orderSummary: "Order Summary",
    confirmOrder: "Confirm Order",
    orderCreated: "Order Created",
    orderNotes: "Notes",
    creditLimit: "Credit Limit",
    creditLimitExceeded: "Credit limit exceeded",
    amountWarning: "Unusual Amount",
    largeAmountHint: "The received amount is much larger than the total. Please verify.",
    correctAmount: "Correct",
    confirmCorrect: "Yes, it's correct",
    salesContacts: "Sales Contacts",
    addContact: "Add",
    noContacts: "No contacts",
    contactName: "Name",
    contactPhone: "Phone",
    editSupplier: "Edit Supplier",
    printReceipt: "Print Receipt",
    refundSuccess: "Refund successful",
    salesperson: "Salesperson",
    selectSalesperson: "Select salesperson",
    salespersonName: "Salesperson name (optional)",
    noSalesperson: "No salesperson",
    filterBy: "Filtered by",
    clearFilter: "Clear filter",
    voidOrder: "Void Order",
    voided: "Voided",
    voidReason: "Reason for voiding",
    voidReasonPlaceholder: "E.g.: Wrong amount, duplicate order...",
    voidWarning: "Voiding will restore inventory. This cannot be undone.",
    confirmVoid: "Confirm Void",
    voidSuccess: "voided",
    // === HQ Monitor Center (StoreOverviewPage) ===
    hqTitle: "HQ Monitor Center",
    hqAutoRefresh: "Auto refresh 60s",
    hqRefresh: "Refresh",
    hqLoading: "Loading...",
    hqNoData: "No data",
    hqLoadFailed: "Load failed",
    hqAiAnalysisFailed: "AI analysis failed",
    hqTotalSales: "Total Sales",
    hqToday: "Today",
    hqEmployeeDebt: "Employee Debt",
    hqOnDutyCount: "On Duty",
    hqActiveShifts: "active shifts",
    hqStockWarning: "Stock Warning",
    hqLowStockItems: "Low stock items",
    hqAiAssistant: "AI Assistant",
    hqStoreMonitor: "Stores",
    hqEmployeeStatus: "Employees",
    hqShiftHandover: "Shifts",
    hqSalesDetail: "Sales",
    hqAlerts: "Alerts",
    hqCashFlow: "Cash Flow",
    hqAiHqAssistant: "AI HQ Assistant",
    hqAnalyzing: "Analyzing...",
    hqReAnalyze: "Re-analyze",
    hqStartAnalysis: "Start Analysis",
    hqAiClickToAnalyze: "Click \"Start Analysis\" to let AI analyze all store data",
    hqAiWillCheck: "AI will check sales trends, stock, employee issues and provide suggestions",
    hqAiAnalyzingData: "AI is analyzing all store data...",
    hqAiAnalyzingIncludes: "Including sales comparison, stock check, employee debts, shift differences, etc.",
    hqViewRawData: "View raw data summary",
    hqOperating: "Open",
    hqOrders: "orders",
    hqCurrentOnDuty: "Currently on duty",
    hqSince: "Since ",
    hqCashBalanceUsd: "Cash Balance USD",
    hqCashBalanceBs: "Cash Balance Bs",
    hqTransactionCount: "Transactions",
    hqProductLowStock: "products low stock",
    hqCollapseDetails: "Collapse",
    hqExpandDetails: "Expand Details",
    hqUsdIn: "USD In",
    hqUsdOut: "USD Out",
    hqBsIn: "Bs In",
    hqBsOut: "Bs Out",
    hqTodayPayments: "Today by payment",
    hqStoreStaff: "Staff",
    hqOnDuty: "On duty",
    hqOwes: "Owes ",
    hqOffline: "Offline",
    hqBranch: "Branch",
    hqClockIn: "Clock In",
    hqIdCard: "ID Card",
    hqPhone: "Phone",
    hqLoans: "Loans",
    hqGoodsCredit: "Credit",
    hqRepaid: "Repaid",
    hqDebt: "Debt",
    hqSalaryPaid: "Salary Paid",
    hqCurrentActiveShifts: "Current Active Shifts",
    hqRecentShiftRecords: "Recent Shift Records",
    hqNoShiftRecords: "No shift records yet",
    hqManager: "Manager",
    hqDiscrepancy: "Diff",
    hqAllStoresSalesSummary: "All Stores Sales Summary",
    hqRefund: "Refunds",
    hqTodayDetails: "Today Details",
    hqLowStockWarning: "Low Stock Warning",
    hqAllStockOk: "All products sufficiently stocked",
    hqStock: "Stock",
    hqOutOfStock: "Out of stock",
    hqHeadquarters: "HQ",
    hqBorrow: "Loan ",
    hqCreditShort: "Credit ",
    hqRepaidShort: "Repaid ",
    hqShiftDiscrepancyWarning: "Shift Discrepancy Warning",
    hqCrossStoreTransfer: "Cross-Store Transfer Suggestions",
    hqTransferSuggestionDesc: "These products are out of stock at one store but available at another",
    hqStockIsZero: "stock is 0",
    hqTransfer: "Transfer",
    hqTime: "Time",
    hqType: "Type",
    hqDirection: "Direction",
    hqIn: "In",
    hqOut: "Out",
    hqHas: "Has",
    hqUnits: "units",
    hqPaymentWay: "Payment Method",
    hqTransferNoCash: "Transfer does not affect store cash balance",
    hqHolidayCalendar: "Holiday Calendar",
    hqHolidayTip: "Click a date to mark/unmark as holiday. Working on holidays = 1.5x pay (LOTTT)",
    hqHolidaysThisMonth: "Holidays this month",
    hqHolidaySet: "Set as holiday (1.5x pay)",
    hqHolidayRemoved: "Holiday removed",
    hqPrefillHolidays: "Pre-fill 2026 Official Holidays",
    hqHolidaysPrefilled: "Official holidays pre-filled",
    hqNew: "new",
    price3: "Price 3",
    boxPrice: "Box",
    shopQRPoster: "Shop QR Poster",
    shopQRPosterDesc: "Generate a promotional poster with QR code for your online store",
    shopQRUrl: "Shop URL",
    managerAuth: "Manager Auth",
    managerApproved: "Manager Approved",
    managerAuthRequired: "Manager authorization required to end shift",
    actualCashCount: "Actual Cash Count",
    cashReconciliation: "Cash Reconciliation",
    shiftNotes: "Notes (explain any discrepancies)",
    expected: "Expected",
    actual: "Actual",
    pendingShiftFound: "Unclosed shift found, please close it first",
    shiftEndAuthHint: "Shift handover requires manager scan or password",
    passwordAuth: "Password Auth",
    scanCode: "Scan Code",
    authorize: "Authorize",
    clearInventory: "Clear Inventory",
    copyFromMain: "Copy from Main",
    editQty: "Edit Qty",
    saveQty: "Save",
    onlyWithStock: "Only with stock",
    noStock: "No Stock",
    action: "Action",
    legacyDebt: "Import Legacy Debt",
    legacyDebtHint: "Record debt only, no cash deduction",
    netCash: "Net Cash",
    currentShift: "Current Shift",
    dailySummary: "Daily Summary",
    noActiveShift: "No active shift",
    addProductHint: "Product added to all stores, only this store will have stock",
    initStock: "Initial Stock",
    overdue: "Overdue",
    partial: "Partial",
    paymentVerify: "Verify Payment",
    priceRequired: "Please enter a price",
    productNameRequired: "Please enter product name",
    quickExchange: "Quick Exchange",
    quickExchangeDesc: "Convert currency quickly",
    reconciliation: "Reconciliation",
    scanBarcode: "Scan or type barcode then press Enter",
    scanOrType: "Scan or type",
    selectCategory: "Select Category",
    totalChange: "Total Change",
    totalReceived: "Total Received",
    goExchange: "Go to Exchange",
    cashReconciliationNote: "Reconciliation note",
    rptTitle: "Shift Report",
    rptCashier: "Cashier",
    rptStore: "Store",
    rptStart: "Start",
    rptClose: "Close",
    rptManager: "Manager",
    rptRate: "Rate",
    rptSalesByMethod: "Sales by Method",
    rptCashRecon: "Reconciliation",
    rptSummary: "Summary",
    rptCashUsd: "Cash USD",
    rptCashBs: "Cash Bs",
    rptCard: "Card",
    rptTransfer: "Transfer",
    rptTotalOrders: "Total Orders",
    rptTotalBs: "Total Bs",
    rptGrandTotal: "Total Sales",
    rptNet: "Net",
    rptRefunds: "Refunds",
    rptExpected: "Expected",
    rptActual: "Actual",
    rptDiff: "Diff",
    rptNote: "Note",
    rptMethod: "Method",
    rptUsdReceived: "USD Received",
    rptBsReceived: "Bs Received",
    chkFillShipping: "Please fill in shipping info",
    chkRefOrProof: "Please enter payment reference or upload proof",
    chkSelectBank: "Please select bank",
    chkOrderPlaced: "Order placed!",
    chkTransferencia: "Bank Transfer",
    chkPagoMovil: "Pago Movil",
    chkCashea: "Cashea Layaway",
    chkCasheaSub: "Buy now, pay later",
    chkCredit: "Credit",
    chkCredit7or15: "7 or 15 days",
    chkWhatsappPay: "Contact seller to pay",
    chkConfirmPedido: "Confirm Order",
    chkSending: "Sending...",
    chkCancel: "Cancel",
    chkReference: "Reference",
    chkProof: "Payment Proof (photo)",
    chkUploadProof: "Upload proof",

    // ===== Super Admin · Multi-Country & Industry Switch =====
    scTitle: "🌍 Global Tenant Control",
    scTitleSub: "Multi-Country / Super Admin",
    scTotalTenants: "Total Tenants",
    scCountries: "Countries Covered",
    scMonthRevenue: "Monthly Global Revenue (USD)",
    scPluginsLive: "{total} plugins · {live} live",
    scMapTitle: "🗺 Global Tenant Map",
    scMapHint: "Circle size = Monthly revenue (USD equivalent)",
    scTenantsUnit: "tenants",
    scOrdersUnit: "orders",
    scThisMonth: "this month",
    scCurrency: "Currency",
    scTimezone: "Timezone",
    scPluginsTitle: "💳 Payment Plugin Registry",
    scCountriesLabel: "Countries",
    scByCountryTitle: "Tenants by Country",
    scRefresh: "Refresh",
    scThTenant: "Tenant",
    scThStatus: "Status",
    scIndustryPlaceholder: "⚡ Switch industry…",
    scIndustryTitle: "Switch industry template",
    scIndustryConfirm: "Switch this tenant to \"{industry}\"?\nWill seed categories + enable industry features (restaurant also creates 10 tables). Existing data is preserved.",
    scIndustryOk: "✅ {tenant} → {industry} (added {cats} categories, {tables} tables)",
    scIndustryFail: "Industry switch failed",
    scCountryConfirm: "Switch tenant country to \"{country}\"?\nWill sync currency / timezone / tax rate / FX",
    scCountryOk: "Switched · New FX: {fx}",
    scCountryFail: "Country switch failed",
    scFxRefreshed: "FX refreshed",
    scFxRefreshFail: "Refresh failed",
    scLoadFail: "Load failed",

    // ===== Industry templates =====
    tplProductsRestaurant: "🍽️ Menu items",
    tplProductsFastFood: "🥡 Menu items",
    tplProductsClothing: "👕 Styles",
    tplProductsPharmacy: "💊 Medications",
    tplProductsBeauty: "💅 Services",
    tplCategoriesRestaurant: "📋 Menu categories",
    tplCategoriesClothing: "🏷️ Seasons",
    tplCategoriesBeauty: "🏷️ Service categories",
    tplSalesRestaurant: "🧾 Table bills",
    tplSalesBeauty: "🧾 Service bills",
    tplMenuTables: "🍽️ Tables",
    tplMenuKds: "👨‍🍳 Kitchen display",
    tplMenuAppointments: "💅 Appointments",
    tplMenuGiftCards: "🎫 Gift Vouchers",

    // Dashboard cards
    dashRestoTitle: "Today's Tables",
    dashRestoRevenue: "Dine-in revenue",
    dashRestoAvgTicket: "avg ticket",
    dashRestoScanRate: "📱 QR scan rate",
    dashRestoOnlineCount: "online",
    dashRestoWalkinCount: "POS dine-in",
    dashRestoTopTables: "🏆 Top 5 tables",
    dashRestoNoData: "No data today yet",
    dashRestoPeak: "⏰ Peak hours",
    dashRestoUnit: "orders",
    dashRestoLoading: "Loading restaurant data...",

    dashExpiryTitle: "💊 Expiring / Expired",
    dashExpiryLoading: "Loading expiry data...",
    dashExpiryAllGood: "✅ All products in good shelf life",
    dashExpiryAllGoodSub: "Nothing expires in the next 30 days",
    dashExpiryExpired: "Expired",
    dashExpiryCritical: "≤ 7 days",
    dashExpiryWarning: "≤ 30 days",
    dashExpiryStock: "stock",
    dashExpiryDays: "days",
    dashExpiryExpiredDays: "Expired {n}d",
    dashExpiryMore: "+ {n} more... go to /admin/products to act",

    dashApptsTitle: "💅 Today's appointments",
    dashApptsLoading: "Loading appointments...",
    dashApptsNone: "No appointments today",
    dashApptsGoto: "Add one →",
    dashApptsScheduled: "Scheduled",
    dashApptsDone: "Done",
    dashApptsNoShow: "No show",
    dashApptsCancelled: "Cancelled",

    dashLoyalTitle: "🔄 Loyal customers · ≥2 visits in 30d",
    dashLoyalLoading: "Loading...",
    dashLoyalEmpty: "No loyal customers yet — ask customers for their phone!",
    dashLoyalReturning: "returning · total",
    dashLoyalVisits: "visits",
    dashLoyalAvg: "avg",

    dashLeaderTitle: "🏆 Vouchers redeemed · 30d",
    dashLeaderLoading: "Loading...",
    dashLeaderEmpty: "No vouchers redeemed in 30 days",
    dashLeaderTotal: "vouchers · total applied",
    dashLeaderIssue: "redeemed",
    dashLeaderTopup: "topup",

    // Appointments page
    apptPageTitle: "💅 Appointments",
    apptPrevWeek: "← Previous week",
    apptThisWeek: "This week",
    apptNextWeek: "Next week →",
    apptNew: "New appt.",
    apptTotal: "{n} appointments",
    apptToday: "Today",
    apptAddSlot: "+ Add appt.",
    apptCustomer: "Customer name",
    apptCustomerPhone: "Phone",
    apptService: "Service",
    apptStaff: "Staff (optional)",
    apptStart: "Start time",
    apptDuration: "Duration (min)",
    apptPrice: "Price ($)",
    apptNote: "Note",
    apptCreate: "Create",
    apptCancel: "Cancel",
    apptStatusScheduled: "Scheduled",
    apptStatusDone: "Done",
    apptStatusNoShow: "No show",
    apptStatusCancelled: "Cancelled",
    apptCommissions: "Staff Commissions",
    apptServicesDone: "Services",
    apptRevenue: "Revenue",
    apptCommission: "Commission",
    apptToPay: "To Pay",
    apptNoCommissionData: "No completed appointments this month",
    apptCommissionHint: "Edit the % and it saves automatically. Only 'done' appointments count.",
    apptMarkDone: "Done",
    apptMarkNoShow: "No show",
    apptMarkCancelled: "Cancel",
    apptDelete: "Delete",
    apptUnassigned: "Unassigned",
    apptMin: "min",
    apptCurrentStatus: "Current status:",
    apptErrFill: "Please fill in customer name and service",
    apptOk: "✅ Appointment created",
    apptDelConfirm: "Delete this appointment?",

    // ===== Online shop =====
    shopErrPickTable: "Pick your table",
    shopErrNamePhone: "Enter name and phone",
    shopBannerDineIn: "Dine-in · {table}",
    shopBannerDineInUnset: "Dine-in · no table",
    shopBannerTakeout: "Takeout / Pickup",
    shopBannerDelivery: "Delivery",
    shopPickTable: "pick table",
    shopTablePrefix: "Table {n}",
    shopChange: "change",
    shopChkDineInTitle: "{table} · Details",
    shopChkTakeoutTitle: "Pickup at restaurant",
    shopOrderTypeTitle: "How would you like to order?",
    shopOrderTypeDineIn: "🍽️ Dine-in",
    shopOrderTypeDineInSub: "Eat at a table in the restaurant",
    shopOrderTypeTakeout: "🥡 Takeout / Pickup",
    shopOrderTypeTakeoutSub: "Pick up at the restaurant",
    shopOrderTypeDelivery: "🛵 Delivery",
    shopOrderTypeDeliverySub: "We'll deliver to your address",
    shopRetailModeTitle: "How would you like to get your order?",
    shopRetailPickup: "🏪 Pick up in store",
    shopRetailPickupSub: "Order now, pick up at the store, no shipping fee",
    shopRetailDeliverySub: "We deliver to your address",

    // 📦 Lot / batch tracking + FIFO
    lotsMenuLabel: "📦 Lots/Batches (FIFO)",
    lotsPageTitle: "📦 Lot/Batch Tracking (FIFO out)",
    lotAdd: "Add lot",
    lotEdit: "Edit lot",
    lotNo: "Lot No.",
    lotNoAutoGen: "Leave blank to auto-generate",
    lotQtyRemaining: "Remaining",
    lotQtyUsed: "Used",
    lotActive: "Active lots",
    lotExpired: "Expired",
    lotCritical: "≤ 7 days",
    lotWarning: "≤ 30 days",
    lotOk: "OK",
    lotExpiringSoon: "Expiring soon (30d)",
    lotProductsTracked: "Products tracked",
    lotRecalled: "Recall",
    lotRecallConfirm: "Recall this lot? Quantity will be set to 0 and lot disabled.",
    lotTraceability: "Recall traceability",
    lotNoSales: "No sales used this lot yet.",
    lotSearchPlaceholder: "Search product / lot no...",
    lotEmpty: "No lots yet. Add manually or receive a PO with lot/expiry data.",
    lotFieldsRequired: "Product, warehouse, qty are required",
    lotCreated: "Lot created",
    warehouseAll: "All warehouses",
    expiry: "Expiry",

    // 🎯 RFM + WhatsApp broadcast
    rfmMenuLabel: "🎯 RFM + Broadcast",
    rfmTitle: "🎯 RFM Segmentation + One-click WhatsApp Broadcast",
    rfmSegment: "Segment",
    rfmRecency: "Recency",
    rfmFrequency: "Visits",
    rfmMonetary: "Spent",
    rfmAllSegments: "All segments",
    rfmSegmentHint: "Click any segment card to select all its customers and auto-fill a promo template.",
    rfmSearchPlaceholder: "Search name / phone...",
    rfmEmpty: "No customers with sales in this window.",
    rfmShowingFirst: "Showing first 500 — narrow filter to see more.",
    rfmBroadcast: "WhatsApp Broadcast",
    rfmSelectFirst: "Please select customers first",
    rfmWaNotReady: "WhatsApp Web not connected — go to settings.",
    rfmWaWarning: "WhatsApp Web is not connected. Scan the QR in [📱 WhatsApp Auto-connect] before broadcasting.",
    rfmComposeMessage: "Compose broadcast",
    rfmRecipientCount: "Recipients",
    rfmTemplateHint: "Tip: use {name} to insert the customer’s first name automatically.",
    rfmPlaceholder: "Hi {name}! 20% OFF this weekend 🎉",
    rfmPreview: "Preview (using María):",
    rfmSendNow: "Send now",
    rfmJobRunning: "Broadcast in progress...",
    rfmBroadcastStarted: "🚀 Broadcast started",
    rfmBroadcastDone: "✅ Broadcast complete",
    rfmMessageRequired: "Message is empty",
    rfmWindow30: "Last 30 days",
    rfmWindow60: "Last 60 days",
    rfmWindow90: "Last 90 days",
    rfmWindow180: "Last 180 days",
    rfmWindow365: "Last year",
    rfmAiTitle: "✨ AI Copy Generator (GPT-5.2)",
    rfmAiSubtitle: "Based on your industry + selected segment + their buying behaviour, generates 3 WhatsApp copy variants",
    rfmAiHintPlaceholder: "Optional: Mother's Day promo / new arrivals / weekend special...",
    rfmAiGenerate: "Generate",
    rfmAiInsightsLabel: "AI saw",
    rfmAvgSpend: "avg spend",
    rfmAvgVisits: "avg visits",
    rfmAiNoVariants: "AI returned no variants — try again",
    rfmAiError: "AI failed — check your Universal Key balance",
    rfmAiVariantPicked: "Picked",
    rfmSegChampions: "👑 Champions",
    rfmSegLoyal: "❤️ Loyal",
    rfmSegPotentialLoyalists: "📈 Potential Loyalists",
    rfmSegNewCustomers: "🆕 New Customers",
    rfmSegPromising: "✨ Promising",
    rfmSegNeedAttention: "⚠️ Need Attention",
    rfmSegAtRisk: "🚨 At Risk",
    rfmSegHibernating: "🌙 Hibernating",
    rfmSegOthers: "👥 Others",
    grossSales: "Gross sales",
    shiftReconcile: "🔧 Reconcile (from order log)",
    shiftReconcileConfirm: "Recompute this shift's totals from the order log?",
    shiftReconcileForceClose: "Also force-close the shift?",
    shiftReconcileDone: "✅ Reconciled",
    orphanCreditsMenu: "🔧 Orphan credits",
    orphanCreditsTitle: "🔧 Orphan credit repair",
    orphanCreditsFound: "Found orphan credits",
    orphanCreditsHint: "Cashier hit Credit but skipped picking a customer/employee — click Assign to attach them.",
    orphanCreditsNone: "✅ No orphan credits — every credit sale is properly attached.",
    orphanCreditsEmpty: "No matching orphan credits",
    orphanAssign: "Assign",
    orphanAssigned: "✅ Assigned",
    orphanPickTitle: "Assign to...",
    orphanPickEmployee: "👤 Employee",
    orphanPickCustomer: "🧑‍🤝‍🧑 Customer",
    orphanSearchPlaceholder: "Search order / item / cashier...",
    orphanSearchEmp: "Search employee...",
    orphanSearchCust: "Search customer / phone...",
    cashier: "Cashier",
    outOfStock: "This product is sold out",
    currentStock: "Current stock",
    agotadoHint: "Restock first or have a manager enable 'allow negative stock' to proceed",
    understood: "✓ Understood",

    // 🏆 Staff Performance (detail report)
    staffPerfMenu: "🏆 Staff performance",
    staffPerfTitle: "🏆 Staff performance detail",
    staffPerfEmployees: "Employees",
    staffPerfOrders: "Orders",
    staffPerfGross: "Gross sales",
    staffPerfRefunds: "Refunds",
    staffPerfNet: "Net sales",
    staffPerfAvg: "Avg ticket",
    staffPerfRate: "Rate %",
    staffPerfEarnings: "Earnings",
    staffPerfCommission: "Commission",
    staffPerfTopProducts: "Top 3 sold",
    staffPerfEmpty: "No sales in this period.",
    allStores: "All stores",
    from: "From",
    to: "To",
  pleaseConnectPrinter: "Please Connect Printer",
  connectPrinterHint: "Click ⚡ to connect USB thermal printer",
  printError: "Print Error",
  labelPrinted: "Label Printed",
  labelsPrinted: "Labels Printed",
  popupBlocked: "Popup Blocked",
  printerCheckConnection: "Check printer connection",
  selectProducts: "Select products",

  // E1_POS_I18N_V1
  pmVerifyTitle: 'Verify payment',
  pmRefPlaceholder: 'Reference # (min 4 digits)',
  pmRefMin4: 'Minimum 4 digits',
  pmVerifyBtn: 'Verify',
  pmMustVerify: '🔒 Verification required: payment must be confirmed and cover the total',
  pmReused: 'Reference ALREADY USED',
  pmVerdictOk: 'PAYMENT CONFIRMED',
  pmInfoBank: 'Bank',
  pmInfoTime: 'Time',
  pmInfoFrom: 'From',
  pmInfoRef: 'Reference',
  pmAmountShort: 'Amount below total:',
  pmNotFoundTitle: 'NOT FOUND',
  pmNotFound: 'Payment not received yet. If the customer just transferred, wait a few seconds and verify again.',
  pmMarkPendingBtn: '⚠️ No bank SMS — charge as PENDING verification',
  pmMarkPendingConfirm: "Bank SMS didn't arrive? The sale will be marked ⚠️ PENDING and the manager must verify it at shift close.",
  pmPendingToast: '⚠️ Sale marked PENDING verification',
  pmPendingBanner: 'You can charge; the manager must verify this payment at shift close.',
  pmBlockToast: 'Verify the payment or mark it PENDING first',
  pvTitle: 'payment(s) PENDING verification',
  pvHint: "Bank SMS didn't arrive at charge time. Verify the money actually arrived before closing the shift.",
  pvOk: 'Arrived',
  pvBad: 'Not arrived',
  pvBadConfirm: 'Confirm the payment did NOT arrive? It will be flagged for follow-up.',
  pvStillNo: '❌ Still NOT found',
  reconciliationMenu: 'Daily Reconciliation',
  apartadosMenu: 'Layaway',
  cameraBossMenu: 'Camera Boss',
  pointsQrMenu: 'Points QR',
  deliveryMenu: 'Delivery Riders',
  marketingBlastMenu: 'Marketing Blast',
  clothingVariantsMenu: 'Size/Color Variants',
  aiCreditsMenu: 'AI Credits',
  waOutboxMenu: 'WhatsApp Outbox',
  waConnectMenu: 'WhatsApp Connect + Holidays',
  syncQueueMenu: 'Sync Queue',
  fxAlertsMenu: 'FX Rate Alerts',
  bossPinMenu: 'Boss WhatsApp PIN',
  reportsHubMenu: 'Analytics Center',
  taxReportHint: 'Select a date range and generate the report',
  autoRefresh: 'Auto refresh',
  fixedQRTip: 'Fixed QR — print and stick at the counter',
  matched: 'Matched',
  noRef: 'No reference',
  paymentVerification: 'Pago Móvil verification',
  printFiscal: 'Print invoice',
  recentUploads: 'Recent uploads',
  saveSchedule: 'Save schedule',
  searchByOrderNo: 'Search order no.',
  verifyPayment: 'Verify payment',
  waitingCustomerUpload: 'Waiting for customer to scan and upload...',
  x_7b6a3713: 'without permission',
  x_930e724c: 'Please enter a valid price',
  x_58abd523: 'Cache cleared, reloading data...',
  x_567717bd: 'The data has been updated.',
  x_13284485: 'Error updating:',
  x_c67c3701: 'The network has been restored and data is being updated...',
  x_ec64f9ef: 'Connection restored',
  x_97249636: 'Offline mode',
  x_srv_down: '🔴 Sellox server not responding (your internet is fine). Offline mode: keep selling, syncs when back',
  x_de00636b: 'Wholesale price',
  x_3355b9c9: 'Synchronized shift',
  x_cdcb5470: 'The token has been automatically renewed',
  x_65deb2f1: 'Failed to log back in automatically, please log in manually',
  x_066dcc67: 'Your login has expired. Please log in again after the network is restored to sync orders.',
  x_05b73e1e: 'Forwarded to queue',
  x_4668b3da: 'Resend failed:',
  x_cfc81929: 'Are you sure you want to delete all pending orders?',
  x_59462c81: 'clear',
  x_769d88e4: 'complete',
  x_a3605cd3: 'An undelivered shift record has been detected. Please turn in your turn first.',
  x_d3ab821c: 'Login has expired, please log in again',
  x_904b6b66: 'USB printer connected (silent printing)',
  x_bfff47cd: 'The electronic scale is connected.',
  x_3b0e123b: 'Only the store administrator/manager can operate the loss report.',
  x_316b388f: '✅ The order has been placed (no new plates, no printed ones)',
  x_1c68b907: 'There are currently items in the shopping cart. Do you want to hang up first and then change tables?',
  x_bd2ec68d: 'Cannot find table order.',
  x_4a61c29a: 'Offline mode',
  x_87dc2a1a: 'Cannot log in in offline mode; first log in online',
  x_e4bb7fff: 'Offline mode – uses cached data',
  x_c8d270fe: '⚠️ ATTENTION / WARNING\\n\\n',
  x_428684a8: 'The server is not responding and the class may not load correctly. \\n\\n',
  x_990dd915: 'It has been temporarily saved on this machine. If the network is still offline while you continue to sell products, the sales team will be assigned to a temporary shift and the boss will be notified after work for verification.',
  x_d04b8716: '⚠️OFFLINE MODE\\n\\n',
  x_58f36ff7: 'Currently there is no network. Shifts will only be saved locally. \\n\\n',
  x_59875eda: 'If the network remains unavailable, today\'s sales will be relegated to a temporary shift and post-work reconciliation will take longer. \\n\\n',
  x_d1737caf: 'Tip: Wait 1 to 2 minutes for the network to recover before trying again. \\n\\n',
  x_05d979dc: 'Continue anyway? / Do you still want to continue?',
  x_3bddf726: 'Please start class first.',
  x_bec775e5: 'Reconciliation data could not be loaded',
  x_d31c6a37: '⚠️ There are no sales records for this shift yet! \\n',
  x_d8e2e78b: 'Are you sure you want to finish class? \\nConfirm your turn?\\n\\n',
  x_cc49e31b: '(Cancellation can continue business)',
  x_6d35a343: '✅ All orders have been uploaded to the server',
  x_ac03942e: '⚠ The shift API failed and was added to the queue to be synchronized. It will automatically try again after the network is restored.',
  x_86c1eb39: 'Change account',
  x_2767058e: 'Client successfully added',
  x_6452a055: 'Error adding',
  x_8b2a8a38: 'The data has been synchronized automatically.',
  x_d23f4e73: 'Invalid weight',
  x_b189550a: 'Added',
  x_a5366b92: 'Not reducible to cost',
  x_c0297a24: 'Previous shift expired — open a new shift / Previous flight has expired, start flight first',
  x_da71e1f7: 'Offline mode: class started automatically',
  x_0bb666b2: 'The order cannot be saved on this machine! Please immediately:\\n\\n',
  x_573ee6e2: '1) Photo to receipt / Take photos and save the receipt\\n',
  x_f474a85a: '3) Notify boss / Notify boss to make additional entries manually\\n\\n',
  x_5e8eda89: '⚠️ Offline saving error: Take a photo of the receipt and notify the boss!',
  x_fef4f558: '❌ REJECTED ORDER / Rejected Order\\n\\n',
  x_0eccf7aa: 'Reason/Reason:',
  x_4187e323: 'The order was not credited! The shopping cart has been reserved. Resolve the issue and collect payment again. \\n',
  x_1bc8b552: 'The server is not responding and the order cannot be saved locally! Immediately:\\n\\n',
  x_48449982: '3) Notify boss / Notify boss to make additional entries manually',
  x_8c837c19: '⚠️ Completely unable to save - take a receipt and notify the boss!',
  x_081947d7: 'Print error:',
  x_93fdb105: 'Sent to printer',
  x_a63bd9a0: 'Merchant ID',
  x_b5caf579: 'For example: 21da4d91',
  x_ca95bed3: 'Go to Admin Panel',
  x_bd0271ed: 'Loading...',
  x_e6e60286: 'Connection to the server and data upload',
  x_81960a3b: 'Go deep',
  x_3f685cd2: 'Clear customer',
  x_5e3d6f1e: 'Tables',
  x_c5b1fdb6: 'Split account',
  x_987d1310: 'Urgent sent',
  x_3e0187a0: 'Rush kitchen',
  x_4f9af33b: 'There are currently items in the shopping cart. Discard and clean the table? (It is recommended to press F4 to place an order first)',
  x_93a34d2b: 'clear table',
  x_2e0d8c60: 'Export error:',
  x_4429e2af: 'Manually enter today\'s USD→Bs exchange rate (e.g. 478)\\nManual rate for today:',
  x_496630eb: 'Invalid exchange rate',
  x_632d6847: 'The exchange rate has been synchronized with the server.',
  x_e1bbd792: '(Going up...)',
  x_a66048b8: '(Upload automatically after connecting to the Internet)',
  x_a5596eed: 'You cannot export orders to be synchronized',
  x_87bae330: 'USB export failed:',
  x_0d05c12d: 'Package orders to be synced into JSON files (you can take a USB flash drive to a PC with a network to upload)',
  x_483b3198: 'Sellox-usb-*.json files exported from other PCs are merged into the local queue to be synchronized.',
  x_d6c969fc: 'USB import failed:',
  x_0257f05e: 'Format error',
  x_97072b48: 'Camera scan',
  x_4aeb4434: 'Quick sale: directly enter the price (cigarettes/bags/bulk products)',
  x_c017be6f: 'shopping cart',
  x_9897d884: 'merchandise',
  x_5d7dbac5: 'service charge',
  x_e92b87e6: 'No pending sales, everything uploaded',
  x_ac05c6e0: 'Select a client',
  x_822d3b01: 'Error',
  x_ece89972: 'Forward',
  x_47c14729: 'Permanently delete?',
  x_c1d0ffe6: 'Quick Sale',
  x_703ccc54: 'Products without barcodes: cigarettes/bags/bulk goods, etc., enter the price directly to add to shopping cart',
  x_0e9fd989: 'Price',
  x_8d70d6cc: 'name (optional)',
  x_2ba4914f: 'For example: Cigarette/Cigar/Bag',
  x_62d36990: 'add to cart',
  x_c542cafa: 'This product is out of stock',
  x_cd14d6ac: 'Current inventory',
  x_f0f7c38e: 'Replenish the products first or ask the manager to activate "Allow negative inventory" before continuing with the sale.',
  x_b6fc6280: '✓ Got it (Got it)',
  x_5e3c50d7: 'Client:',
  x_79283113: 'Please confirm! It will be automatically deleted after you place the order.',
  x_3a4e7b4a: 'split the order',
  x_1a3e9cc8: 'urge vegetables',
  x_5a99b099: 'today is',
  x_69eccd2b: 'It\'s your birthday. Want a little birthday gift/present/discount? 🎁',
  x_d53b49d4: 'close',
  x_71e5e874: '📡 Offline',
  x_bf349b27: '— Cashier billing is normal, documents were saved locally and will be uploaded automatically after connecting to the Internet.',
  x_5326b4f3: '⚠️ Expired BCV exchange rate',
  x_1d5e15a6: 'Overdue/Late:',
  x_02117218: 'Soon / Expires soon:',
  x_c4d536c0: '📋Rules/Rules:',
  x_7f038370: '📱 Watch online / Watch online:',
  x_56c29a7f: 'Thank you! / Thanks for visiting',
  x_f59fbcc6: 'Bulk · Enter weight',
  x_75c7e478: 'Rejected orders',
  x_9b109b95: 'Not engraved',
  x_261d3371: '🔁 Resend',
  x_2300874f: '🗑 Delete',
  x_faf1993a: 'All processed ✅',
  x_76ddec31: 'Note: Removing products will affect all branches! Are you sure to remove this product?',
  x_69b0f684: 'Disabled',
  x_53ace430: 'Enabled',
  x_5fa802be: 'Failed operation',
  x_9424cd13: 'Print error: allow pop-ups',
  x_e80262e7: 'The printer is connected',
  x_ce79f0c8: 'Could not connect to printer',
  x_7aa71b32: 'Note: Removing products will affect all branches!',
  x_631cd220: 'Confirm deletion',
  x_35a7afeb: 'articles',
  x_0007d170: 'Delete successfully',
  x_7775d70e: 'No product with image',
  x_d34bd225: 'Insufficient AI Credits',
  x_54e5de42: 'Error uploading',
  x_7fb62b30: 'Batch Delete',
  x_56b318c4: 'Upload images in batches',
  x_06a90552: 'Are you sure you want to recode all products sorted by name? (01, 02, 03...)',
  x_9708fbed: 'Encoding reordering completed',
  x_d959452f: 'Coding reordering',
  x_7bf54e28: 'Selected',
  x_66eeacd9: 'Select all',
  x_a04144e4: 'Deselect all',
  x_cd0b9aca: 'Delete selected',
  x_3c237c07: 'Connect printer',
  x_c5ea9c6a: 'Connected',
  x_81ba5ea7: 'Printing...',
  x_de2bc1d2: 'Label display',
  x_693b926b: 'Show foreign currency ($)',
  x_3b64fbff: 'Show B',
  x_80806771: 'No decimals',
  x_ac837e75: 'Show barcode',
  x_55c475bb: 'label paper',
  x_b2a6f7ae: '80mm thermal',
  x_9e5dde5b: '50x30mm label',
  x_a7ad78bd: 'Bilingual (ES+CN)',
  x_5423e287: 'No photos',
  x_9460a7d0: 'Size × Color Variations',
  x_5b02e434: 'Discontinued (keep in stock)',
  x_7b6defeb: 'Re-enable',
  x_2f4aaddd: 'Delete',
  x_4d775d4c: 'show',
  x_f4f85316: 'Previous page',
  x_b4e1b508: 'Next page',
  x_8056acb6: 'in bulk',
  x_8fe35fdc: 'min',
  x_7d1f14ef: '0 = off',
  x_dc90fae8: 'inventory adjustment',
  x_a59299fc: 'Cargo transfer management',
  x_01dcb2bb: 'Image request failed, first set the boss number in /admin/whatsapp-settings',
  x_d5124910: 'Remove background with AI? (3 credits)',
  x_cfc6745d: 'Processing... (~15s)',
  x_57553dee: 'AI Trim Completed!',
  x_94c6b3ba: 'AI cut failed',
  x_b4168dc5: 'Use original image to re-crop image with AI? Subtract another 1 AI point',
  x_afcaa4ef: 'AI Reprocessing...',
  x_b6cd67bb: 'Trimming is complete!',
  x_164df077: 'Failed trim',
  x_48fde72b: 'Restore original image before AI cropping?',
  x_80145d31: 'The original image has been restored.',
  x_7bd43c80: 'Restoration failed',
  x_c74e4f1a: 'Select import category',
  x_5fcb1e4d: 'Select category',
  x_45e49ae9: 'Not specified (use file classification)',
  x_7c60e550: 'After selection, all imported products will be classified into this category.',
  x_e111f522: 'Select import fields',
  x_41e49b1c: 'Basic information (number, name, specifications) is always imported',
  x_020f1ecd: 'start going up',
  x_92cd554e: 'Going up...',
  x_794a4ecb: 'All products',
  x_abaff128: 'Example: 10 = cost increased by 10%',
  x_2fff577b: 'Please complete at least one item',
  x_9fce5962: 'Category:',
  x_2fb90b05: 'Processing...',
  x_2901ac42: 'Confirm price adjustment',
  x_727dc210: 'Batch AI Trimming',
  x_7385d670: 'Select all with photos',
  x_625fb26b: 'Cancel',
  x_a642d255: 'Store name:',
  x_04870124: 'Store label',
  x_d5acfdec: 'no label',
  x_6e41198f: 'HOT',
  x_46a742e3: 'NEW',
  x_e1179aa4: 'OFFER',
  x_47eddf7c: '🥬 In bulk / sold by grams and kilograms',
  x_7c88c892: '(The online store will display the label "Bulk" and customers can purchase decimals such as 0.5/1.8)',
  x_28b47633: 'Season',
  x_7c8d6872: 'No season —',
  x_2f1cc7f8: 'Spring',
  x_e87105bf: 'summer',
  x_dded849e: 'Autumn',
  x_7c7a55ef: 'winter',
  x_6047e490: 'all year round',
  x_89f7904f: 'For end of season discounts.',
  x_9966d712: 'Stage',
  x_61541067: 'Synchronized —',
  x_efd81299: 'Entry first',
  x_864dc4dc: 'Main course',
  x_125653fe: 'Accompaniment',
  x_c64f64c1: 'Drink',
  x_c63fb6f7: 'Dessert at the end',
  x_e091ce54: 'The kitchen will vote according to this group · Kitchen group by stage',
  x_58b439e0: 'Prep time',
  x_210974b9: 'It is used to order and place orders.',
  x_4a2ac468: 'Print in kitchen',
  x_88ca75d5: 'Orders placed after closing will not be sent to kitchen (suitable for outdoor drinks/shopping)',
  x_ee4e4b38: 'Lot',
  x_e7100153: 'Maturity',
  x_1ac5191c: 'Prescription product',
  x_52af7df5: 'The customer\'s identity will be compulsorily recorded during sales.',
  x_ae0b0527: 'Serial',
  x_89d8ab7a: 'Warranty (months)',
  x_b5e44315: 'Variants/flavor variations',
  x_5adfcd10: '(separated by commas)',
  x_72ee7c09: 'Auto Wholesale Qty',
  x_378c05db: '(ALFONZO SHOP main warehouse)',
  x_c852c3dc: 'Other warehouses (read only, use "Inventory Adjustment" or "Transfer Management" to modify)',
  x_5c0c578b: '📱WhatsApp photo please',
  x_a1773715: '✨AI Trimming',
  x_90f7259e: '🔄 Crop',
  x_e955fcb2: '↩️Restore original image',
  x_ae5ad52a: 'Upload product images in batches',
  x_7c5dc935: 'How to use:',
  x_eabafd4b: '1. Click on the image file',
  x_f9d8b163: 'Product code',
  x_25c971d2: 'Name',
  x_c2654942: 'For example: product code',
  x_d13c1bb8: '→The image is called',
  x_1aeffd84: '2. Select all image files and upload them at once.',
  x_3be0aaea: '3. The system automatically matches the code and updates the product image.',
  x_b226d05e: 'Supported formats: JPG, JPEG, PNG, WEBP',
  x_f08afd1f: 'Selected',
  x_6d03439d: 'file, click "Start Upload" to match the server encoding',
  x_7b9de9b7: 'No corresponding product found:',
  x_c4390da8: 'Error:',
  x_b15d9127: 'Close',
  x_ec74c566: 'Massive Adjustment',
  x_85f16ef9: 'Categories / Category (leave blank = all)',
  x_7f1fd8fd: 'all',
  x_ef7e66eb: 'Cost increase (%)',
  x_ebb263a8: 'New Margin / New Margin (%) — Leave blank and do not change',
  x_e93880f5: 'Benefit 1 (P1)',
  x_e105c7e7: 'Benefit 2 (P2)',
  x_af32ce55: 'Benefit 3 (P3)',
  x_3621e3c6: 'Formula: new selling price = new cost × (1 + profit margin%)',
  x_0d2f0cb5: 'Example: Cost $1 + Profit 30% = Sales price $1.30',
  x_fc51faec: 'Online store background theme',
  x_1dbb0d24: 'Store type',
  x_faeff5ef: 'supermarket',
  x_2580b405: 'restaurant',
  x_2ac97357: 'department stores',
  x_3972c872: 'pharmacy',
  x_94f1c5f0: 'bakery',
  x_d2fe24af: 'clothes',
  x_cdce861f: 'electronic products',
  x_4c745eb9: 'butcher shop',
  x_aa05fd09: 'Universal',
  x_b42f3d0b: 'custom image',
  x_470c8cb6: 'Upload a background image (recommended 1920x800, maximum 5 MB)',
  x_ba9fc45d: 'Select image',
  x_a7699ba7: 'Successful upload',
  x_97e448c5: 'Store Description (displayed on the online store home page)',
  x_e90f3dd4: 'placeholder={t(\'shopDescPlaceholder\') || \'For example: fresh fruits and vegetables delivered daily\'} data-testid=',
  x_e4de2708: 'Online store link preview',
  x_146c214c: '⚡ Fast checkout',
  x_847d3492: 'guest network',
  x_0d9614ed: 'Printer options',
  x_a305b265: 'Ordinary receipt printer (POS)',
  x_9d2ae79f: 'Printer name',
  x_37ba4d4d: 'Printing method',
  x_e3127cc1: 'Format',
  x_dc7ac037: 'Thermosensitive',
  x_8419e5a2: 'Automatic printing',
  x_b815bd61: 'Compact mode (font -40%)',
  x_0a50b98b: 'Number of copies to print',
  x_95a11756: 'Test print',
  x_08d73983: 'Report Printer',
  x_1822051b: 'paper size',
  x_086f6c26: 'Used to print A4 documents such as sales reports and inventory reports.',
  x_f6c5bb79: 'Tax Printer (Tax)',
  x_85fc7de8: 'Printer model',
  x_923f0558: 'connection port',
  x_9ec10f88: 'Enable cash drawer control',
  x_46886d25: 'Print item number (tax documents only)',
  x_0d1eb73c: 'Silent Print Settings (no print dialog appears)',
  x_c530a752: 'Set XP-80C as Windows Default Printer',
  x_f5dcc91d: 'Download the shortcut file below, place it on your desktop and double-click to open it.',
  x_34c425af: 'Use standalone process mode without closing other browser windows',
  x_1f439178: 'Allow 0 inventory/order when negative (Allow oversold)',
  x_d28ccc95: 'Example: 5 = minus 5%',
  x_89b146df: 'Example: 3 = minus 3%',
  x_3b108349: 'Saved successfully',
  x_6de920b4: 'Error saving',
  x_667519a7: 'Clearing cache...',
  x_715e78ba: 'Clean cache, reloading...',
  x_3d58a3f4: 'Error while cleaning',
  x_635d85ed: 'Costing method',
  x_9f3cdb13: 'Last cost',
  x_cdf4510f: 'Weighted average',
  x_a2361773: '✓ When receiving goods in mixed batches with two exchange rates, the profit will be calculated more accurately based on the average cost.',
  x_8c332c85: 'Minimum Legal Wage (Bs/month) Minimum wage',
  x_1f1cb126: 'When the government adjusts the minimum wage, change it here. Current default value: Bs. 130.00',
  x_fcf71823: 'WiFi clients scan QR code to connect to the Internet',
  x_a4162fc6: 'WiFi SSID (network name)',
  x_93952fec: 'WiFi Password',
  x_aea862e7: 'When customers pay with PagoMovil, a WiFi QR code will be displayed in the verification window for customers to scan the code to connect to the Internet.',
  x_764327eb: 'It is recommended to use the router\'s "guest network" (Guest Network) to set the automatic disconnection in 2 minutes.',
  x_d38fdd96: 'Kiosk (silent - recommended)',
  x_64ae72e7: 'USB direct connection (COM serial port)',
  x_3ac81273: 'Kiosk (quiet - shared with regular tickets)',
  x_a27aa9d2: 'Direct USB connection (COM serial port - independent Fiscal printer)',
  x_1fdcab60: '📦 Inventory rules',
  x_8c0b62d0: '⚠️ "Allow overselling" has been activated',
  x_0b98802c: '🛡 Strict mode (recommended)',
  x_3469dcde: '🏭 Wholesale Automatic Identification Threshold (Pieces)',
  x_abe9d5a5: 'Any single order ≥ this amount → automatically judged as a bulk order',
  x_66b516be: '🏭 Wholesale orders: points / $1',
  x_44cdb632: 'Use this ratio for wholesale orders (usually lower than retail to protect profits)',
  x_cad2cdb3: '📊 Refund calculation:',
  x_e9b42d03: 'Online Store Discount',
  x_c8ebef70: 'Cash discount',
  x_b315c033: '7 day credit discount',
  x_92f50a16: '15 day credit without discount. Discounts are automatically calculated during checkout in the online store.',
  x_6a46e901: 'Save discount settings',
  x_aecb318e: 'Current version:',
  x_fd044b72: 'Cleanup: Service Worker + Cache API + LocalStorage PWA flags',
  x_c3c63335: 'Check the card first',
  x_258b5e0a: 'Insufficient balance',
  x_6074ad12: 'Card charging error / Stored value card deduction error',
  x_4091e27c: 'Discount',
  x_952fe994: 'split payment',
  x_d9b8f7dc: 'Code (GC-XXXX...)',
  x_df635901: 'Enter code and PIN',
  x_44efeacf: 'invalid card',
  x_cd8992b6: 'check',
  x_fbb9242b: 'Fair',
  x_ac770469: 'Missing',
  x_855bfd60: 'cope with',
  x_a1b49020: 'It\'s not good enough',
  x_c993e001: 'change',
  x_450efd2f: 'total',
  x_23d0eed8: 'next',
  x_aaf7077a: 'days',
  x_249aba76: 'day',
  x_1ceaeb7c: 'Search for employee / Search for employees...',
  x_0c9d2b45: 'Payment method',
  x_e83a256e: 'Confirm',
  x_bf15f831: 'Subtotal',
  x_954a5f2c: 'Total to pay',
  x_a2e76886: '% percentage',
  x_4ca7ca2e: '$ less amount',
  x_62409e5c: '$ final price',
  x_4ea4474d: 'Choose any: Complete 3 → 97% off · or $1.57 off · or lose the final $50',
  x_f761deae: 'Select a client / Please select client first',
  x_719a6f48: 'Payment term / Number of days on credit',
  x_a2c1dba8: 'Select an employee / Please select an employee',
  x_203546f6: 'Price changed',
  x_2432b575: 'Observations',
  x_a8b0c204: 'all',
  x_4c37b31d: 'There are currently no products in this category.',
  x_d8318796: 'Please enter the product name',
  x_2d5bd318: 'Enter cost and margin P1',
  x_3fdaeadf: 'Successfully added',
  x_26983664: 'Please enter the refund amount',
  x_b58060b3: 'Payment saved offline',
  x_ae5a8a24: 'Successful payment',
  x_8b649901: 'Failed refund',
  x_d594b77a: 'Please enter the amount',
  x_305091bd: 'Please select an employee',
  x_e2079942: 'Please enter the salary amount',
  x_cdef21ee: 'Deductions cannot exceed wages.',
  x_43b972b2: 'The order was not found.',
  x_0d66ed02: 'Query failed',
  x_8093e392: 'Please enter name',
  x_08b1fa13: 'Please enter username',
  x_11524166: 'Password must be at least 4 digits',
  x_b5e12476: 'Employee successfully added',
  x_ea340b7c: 'borrow money',
  x_3f01df5b: 'goods on credit',
  x_4c95bf44: 'refund',
  x_79ef16e5: 'payroll deductions',
  x_ded3cdfb: 'pay salaries',
  x_029d48fa: 'Absence from work well',
  x_5ba2fb47: 'Historical delays',
  x_756048fc: 'Employee statement',
  x_4ff1e74e: 'Date',
  x_226b0912: 'Type',
  x_4cf24aba: 'Quantity',
  x_5a4fcfe2: 'Current amount owed',
  x_26068dad: 'printing time',
  x_d0de55dc: 'Successfully drilled',
  x_15ffd5c7: 'I signed in and left work successfully',
  x_20cdb977: 'Failed to check in',
  x_bd4357f9: 'all day',
  x_c31b1b99: 'half day',
  x_02efd8b1: 'absenteeism',
  x_95748d60: '✅ The debt owed due to absence on that day has been automatically cancelled.',
  x_40862774: 'Dialing error',
  x_b6838383: 'rent',
  x_0ee0c81c: 'Water and electricity',
  x_be11fc04: 'salary',
  x_1f4beff9: 'Consumables',
  x_324712a3: 'Repair',
  x_0f3a252a: 'transportation',
  x_2a0ad6ff: 'restoration',
  x_638e3280: 'taxes',
  x_0d98c747: 'Others',
  x_fdfd5d5f: 'Please select an employee first',
  x_50bcbd71: 'Payroll failed',
  x_36cb9c59: 'Saved shift schedule',
  x_57b08dd4: 'no staff',
  x_efafd9a3: 'The request failed',
  x_8f21b986: 'Please enter the template name',
  x_979b4faf: 'Deleted template',
  x_acf0664a: 'Delete error',
  x_1603b069: 'monday',
  x_b5a6a07e: 'tuesday',
  x_e60725e7: 'Wednesday',
  x_170fc8e2: 'Thursday',
  x_eb79cea6: 'friday',
  x_24575130: 'saturday',
  x_562d7476: 'sunday',
  x_f8fbeae1: 'tomorrow',
  x_e2eb289c: 'afternoon',
  x_51147c21: 'hugo',
  x_fbcf05da: 'title>',
  x_e1adc7de: 'h2><p class="sub">',
  x_ae2703cb: 'th><th>',
  x_e3e234b4: '<span><span class="box" style="background:#d4edda"></span> All day</span>',
  x_034dcc79: '<span><span class="box" style="background:#fff3cd"></span> Tomorrow</span>',
  x_ebdf24a9: '<span><span class="box" style="background:#ffeaa7"></span> Afternoon</span>',
  x_13db7d6d: '<span><span class="box" style="background:#f0f0f0"></span> Rest</span></div></body></html>',
  x_bd626c2f: 'Successfully signed',
  x_2bd5e2ab: 'Signing error',
  x_c10a6c00: 'Please complete the complete',
  x_1fbd718d: 'The cash must be less than the amount swiped with the card.',
  x_c31eabb4: 'magnetic card',
  x_acaf665f: 'transfer',
  x_b416b575: 'mobile payment',
  x_41ce131a: 'mix',
  x_3df74976: 'credit',
  x_0319bf13: 'Business summary of the day.',
  x_fbb493d0: 'Number of orders',
  x_8bd00685: 'Store admin panel',
  x_9c1d16fc: 'open today',
  x_cc1987ec: 'View inventory',
  x_78d078e8: 'expenses',
  x_29225555: 'Exchange gains',
  x_e7c0908c: 'cash',
  x_2f6805aa: 'employee account',
  x_d37a7de1: 'Programming',
  x_fa3aee98: 'Add product',
  x_848704b1: 'Transfer and receive goods.',
  x_94fea5cb: 'Summary of the whole day',
  x_843e649c: 'Current shift',
  x_19940592: 'There are no active flights',
  x_b1423de3: 'single average',
  x_5bc31fd0: 'By payment method',
  x_c2e5a8e2: 'Statistics by currency',
  x_b634ce2e: 'Bs open order',
  x_d0af2c40: '$ Open an order',
  x_83958d46: 'single',
  x_aded5d5b: 'receive',
  x_eddd9ee1: 'reconciliation',
  x_d97f0de8: 'total collection',
  x_be77abaa: 'Statistics by cashier',
  x_3960424f: 'Cash Exchange Reconciliation',
  x_2e8e048d: 'receive cash',
  x_043d5f39: 'total change',
  x_534097e9: 'net cash',
  x_22b91744: 'Only cash orders with recorded amounts received are counted.',
  x_21533faf: 'Print business summary',
  x_a8e76489: 'View order details',
  x_dc9b2ec5: 'cashier screen',
  x_bfdaebfd: 'cashier',
  x_654522d2: 'Currency',
  x_0bf60b32: 'Quantity',
  x_da4abd3e: 'unit price',
  x_f599fcd3: 'Subtotal',
  x_26922a58: 'received',
  x_56ae8659: 'All warehouses',
  x_adcd38b7: 'Search + Enter / Search product name/code...',
  x_0aaf10c2: 'No matching product found',
  x_d3bc58b6: 'exchange rate',
  x_f155c56c: 'Selected exchange rate',
  x_37a3f5ca: 'Converted to US dollars',
  x_ac502247: 'Buy USD in cash',
  x_2feedc17: 'Swipe card to get cash',
  x_2ddd1415: 'Amount in dollars ($)',
  x_735fcb9f: 'purchase rate',
  x_27cae7b2: 'sales rate',
  x_26431425: 'cost of bs',
  x_9aef4e3c: 'value in bs',
  x_cb340191: 'benefit',
  x_b58c7549: 'add',
  x_f58a32cd: 'Swiped credit card amount (Bs)',
  x_d5dd40af: 'Give Cash(Bs)',
  x_171cc7f8: 'Profit(Bs)',
  x_f2d612ee: 'Handling fee',
  x_524d7e11: 'Today\'s profit (Bs)',
  x_58add0bd: 'Today\'s profit ($)',
  x_19fcb9eb: 'time',
  x_f26225bd: 'Details',
  x_e052f520: 'Profit ($)',
  x_cbe408cd: 'buy dollars',
  x_a185dea2: 'Swipe your card to redeem cash',
  x_b9db8476: 'There is no registration yet',
  x_c966e6db: 'USD cash',
  x_d96c0531: 'Bs in cash',
  x_b7b3fa73: 'Fast currency exchange',
  x_1c927ecc: 'No need to go to the currency exchange tab, just do it here',
  x_b28432d4: 'Go and exchange currency',
  x_661f8852: 'cash operations',
  x_4cc6a2f6: 'Deposit',
  x_7be8ae3a: 'take out',
  x_474a556a: 'turn it around',
  x_1827f06e: 'adjust',
  x_0367ebd1: 'Observations...',
  x_abe2c5d2: 'Sending...',
  x_b66b2e82: 'recent records',
  x_676e5982: 'operator',
  x_7f0dc5e3: 'sales',
  x_774e1765: 'exchange',
  x_742440c4: 'Employee accounts',
  x_2ef46a5f: 'Add employee',
  x_60d0458a: 'name',
  x_32ffa250: 'identification number',
  x_5a93d3f7: 'phone',
  x_819767ad: 'Username',
  x_a8105204: 'Password',
  x_464f3d4e: 'paper',
  x_3887bfff: 'Ordinary employees',
  x_bbc407c7: 'price inspector',
  x_586a52f3: 'credit limit',
  x_eeb4d5b7: '0 = no limit',
  x_25cebe66: 'salary amount',
  x_b5ca1dd9: 'payment cycle',
  x_09b03b6d: 'weekly',
  x_93a158a9: 'every 15 days',
  x_aa3d57c0: 'monthly',
  x_5e3640e4: 'Confirm to add',
  x_4c998309: 'Print QR Card',
  x_8d7eb002: 'Receipt + QR',
  x_2dbf283b: 'Account statement',
  x_e8da0032: 'Arrears',
  x_bbdd42a0: 'settled',
  x_620610c0: 'has been returned',
  x_8577b01a: 'Deposit withdrawal',
  x_44ba3fed: 'Could not extract',
  x_7b1df363: 'Currently there is no record of employee debts.',
  x_7941da94: 'one',
  x_2d8be272: 'two',
  x_e662ff59: 'three',
  x_21716cf3: 'four',
  x_1fcc29d0: 'five',
  x_61b45352: 'six',
  x_3edddd85: 'day',
  x_93849f29: 'today\'s attendance',
  x_416b2ef6: 'already out of work',
  x_b767d98a: 'at work',
  x_6bc72d59: 'Not registered',
  x_b4f0388f: 'go to work',
  x_96ed60cd: 'leave work',
  x_7b6e413b: 'Add employee accounts',
  x_37c140e9: 'Select employees',
  x_99b437e5: 'Loans to employees',
  x_c06881f5: 'Give goods to employees on credit.',
  x_fbb40b61: 'Employee payment',
  x_783aaf86: 'Import historical debts',
  x_859e83a6: 'Only the amount owed is recorded, no cash balance is deducted.',
  x_83ba80ef: 'The transfer does not affect the store\'s cash balance.',
  x_27622285: 'total salary',
  x_a46225b3: 'Enter the order number to make the inquiry automatically',
  x_bee912d7: 'Consultation',
  x_b433e6c6: 'Product information',
  x_f87737b3: 'Credit product details...',
  x_2edddab1: 'daily wage',
  x_074eca2c: 'Deduction of salary arrears',
  x_20b7f99c: 'real hair',
  x_39ce9e78: 'No deduction (all in cash)',
  x_82a6f2f0: 'Employees pay with Bs → Automatically convert USD to compensate for arrears',
  x_162fe161: 'Store Manager: Fill in the exchange rate yourself',
  x_7e21332c: 'Personal: BCV exchange rate',
  x_767b82cb: 'Autocomplete',
  x_9e3eba91: 'Calculation mode',
  x_3aed2c11: 'automatic',
  x_2a3e7f5c: 'manuals',
  x_b4b4b75b: 'Automatically adjustable',
  x_0a61f1ae: 'Credit limit exceeded!',
  x_c6403f20: 'Fee',
  x_28b24262: 'After the operation',
  x_2e81e23d: 'beyond',
  x_07b42ee9: 'transaction history',
  x_2ed39222: 'employees',
  x_e05e6f34: 'balance',
  x_e25b7872: 'Add new product',
  x_1fd1d5c5: 'Product name',
  x_cc6c35a3: 'coding',
  x_d0771a42: 'Classification',
  x_2e2ce286: 'cost price',
  x_7a3da957: 'profit margin',
  x_2acbbffe: 'The system automatically calculates the price.',
  x_650f9201: 'whole box',
  x_3301f812: 'Quantity per box',
  x_2a79a737: 'tax rate',
  x_72993534: 'Incoming quantity',
  x_39f76a9b: 'barcode',
  x_257a8023: 'Scan/enter the barcode and press Enter',
  x_4347fc1c: 'The added products will be synchronized with all branches, but only our store has inventory.',
  x_ae1c4d7f: 'Search customer/order number...',
  x_322ade24: 'not paid',
  x_fa25eda2: 'expired',
  x_13992709: 'Partial amortization',
  x_480018e8: 'it paid off',
  x_4403fca0: 'Delete',
  x_c624290a: 'records',
  x_c75e2f5f: 'Awaiting collection',
  x_ff0b2077: 'Client',
  x_1e8dc255: 'Order number',
  x_6ffe81e2: 'total amount',
  x_57b642fc: 'Paid',
  x_499b9a62: 'expiration date',
  x_3fea7ca7: 'Status',
  x_2b6bc0f2: 'Operation',
  x_45274498: 'part',
  x_1611cbc7: 'To be returned',
  x_2722964b: 'No matching records',
  x_8e6adfe0: 'Refund amount',
  x_37fa12a4: 'Goods transfer order to receive',
  x_694fc5ef: 'Update',
  x_bf08ab13: 'There is no transfer order to receive',
  x_4933ca41: 'Awaiting receipt',
  x_04531587: 'Shipping',
  x_91bcfc81: 'main warehouse',
  x_8690efe6: 'Number of shipments',
  x_a8974abd: 'Actual receipts',
  x_a18a1f0c: 'Confirm receipt',
  x_29825420: 'The warehouse is not loaded, please try again later.',
  x_38bbc161: 'Warehouse not loaded',
  x_1ba301c3: 'Submitted for administrator approval / Submitted for administrator approval',
  x_72520580: 'this week',
  x_9c5f8689: 'Pay salaries to selected employees.',
  x_ba4c8037: 'Save schedule',
  x_f8dfedcd: 'bran',
  x_0963bb54: 'Shift template',
  x_cb86af8d: '{t(\'template name\') || \'template name\'}',
  x_eb347bdb: '+ New',
  x_26b5bd49: 'Loading...',
  x_69a69eb0: 'weekly salary estimate',
  x_85a77ddc: 'Click on the grid to scroll through it',
  x_80da96c6: 'Schedule',
  x_c59cae5e: 'Employee schedule',
  x_3a991a4c: 'rest',
  x_10627c90: 'How to calculate the number of entrances and exits.',
  x_955acdc0: 'Manual entry of cash sales.',
  x_cd06c6b3: 'Tank increase/manual adjustment',
  x_a9f5d26a: 'Take out/deliver/adjust manual reduction',
  x_a20bbe5d: 'Payment of salary/loan to employee',
  x_d13feaa2: 'Biopayment/swipe/transfer does not count towards cash balance (to bank)',
  x_aaa36041: 'VES amount = product price USD x BCV exchange rate',
  x_0e59b159: 'Working on vacation = 1.5 times salary (calculated automatically)',
  x_63686703: 'There are no holidays this month',
  x_362bb8be: 'Payment Receipt',
  x_79274ddb: 'Inventory / Inventory',
  x_5d855937: 'expired',
  x_dcc961ae: 'voided',
  x_a0bf20e8: 'To synchronize',
  x_c2c0df04: 'Saved on this PC',
  x_4650017d: 'No Network: Credit accounts have been saved locally and are displayed in the list (yellow to sync) and will be loaded automatically after connecting to the Internet.',
  x_eb3eae91: 'Payment saved on this PC',
  x_fa17371a: 'No network: The payment was recorded locally (yellow to sync) and will be charged automatically after connecting to the Internet.',
  x_1c97a7ce: 'Expires soon',
  x_a44f40d4: 'The boss\'s mobile phone number is not set, please go to WhatsApp settings to add it.',
  x_464208d1: 'Error sending',
  x_1cf1a230: 'Send a summary of overdue accounts to your boss\'s WhatsApp',
  x_24cc017a: 'Error submitting claim',
  x_6910a681: 'Automatically send WhatsApp reminders to every overdue or overdue customer',
  x_aab87728: 'Paid, no outstanding invoices',
  x_a48948bf: 'All stores',
  x_a7da9234: 'store',
  x_6b0cbe98: 'Look at the top right corner☁️',
  x_832af156: 'Automatically upload online',
  x_d2593e04: 'USD only',
  x_8e0be5e5: 'Payment upload is declined, click ☁️ in the top right corner to process',
  x_10efc391: 'Product details',
  x_1c40f543: 'Payment history',
  x_d88fb1dd: 'This credit must be paid in US dollars.',
  x_84857e3e: 'Credit expiration reminder',
  x_43b510ed: 'remaining',
  x_bfc2bc5a: 'No overdue/overdue credit accounts yet',
  x_f3737dbf: 'Order number',
  x_7c5f7ff6: '💵 USD not received',
  x_139bf01e: '🇻🇪 Bs not received (current value in USD)',
  x_23414073: '⚠️ USD and Bs do not add up: USD is the actual US dollar received; Bs is recorded as a US dollar value based on the day\'s instant exchange rate and Bs is converted using the day\'s real-time exchange rate upon receipt of payment.',
  x_7b7d5246: '⚠️ There is a default on payment',
  x_b3032ddd: '@that day',
  x_6845ced0: 'Total amount owed',
  x_1302a371: 'Payment history:',
  x_d7e9237c: 'The barcode does not match the product.',
  x_ef48633e: 'Please select a different warehouse',
  x_dd2124ee: 'Please add product',
  x_1fc560de: 'Saved offline',
  x_b56601bf: 'Then check to see if it appears in the list.',
  x_028e7279: 'Transfer order created successfully',
  x_861505e1: 'The transfer order has been canceled',
  x_8ae6036e: '⚠️ You have entered the actual quantity received of all products as 0. \\n\\nThis means that nothing will be added to MANUEL\'s warehouse. \\n\\nIf the products have not arrived, please click "OK" to continue. \\nIf it is an error, click "Cancel" to return and reload.',
  x_d2875199: 'Create a new transfer order',
  x_7c5e97eb: 'Signed by',
  x_cc1bacb5: 'Article',
  x_7031d352: 'Transfer order number',
  x_b683d031: 'Emissions warehouse',
  x_8dda8a9c: 'receiving warehouse',
  x_8887e33b: 'total amount',
  x_2111ccbb: 'Canceled',
  x_e699aa3c: 'Duplicate',
  x_ef091458: 'Cancel transfer order',
  x_f89fa9b6: 'Select warehouse',
  x_6b705e8c: 'Search products/scan QR code...',
  x_14545603: 'Camera scan code',
  x_b26107b6: 'Creating...',
  x_73de67b8: 'Create and print',
  x_a9aa4fae: 'Sign for delivery order',
  x_bf09ef8b: 'problem',
  x_15e9238b: 'receive',
  x_6edb92ec: 'Call quantity',
  x_7a6e939a: 'Actual amount received',
  x_7e28d689: 'The quantity has been automatically adjusted to the available quantity. Please confirm and submit again.',
  x_3e71abd0: 'transfer order',
  x_ea887bd0: 'Specifications',
  x_ebb67faf: 'Shipping Signature: _______________',
  x_6afdc8b0: 'Signature of receipt: _______________',
  x_4c271bd8: 'Transfer Order · Transfer Order',
  x_8d4312cd: 'From:',
  x_8a90ed66: 'To:',
  x_cd50b523: 'Creation date:',
  x_b5e8e5c3: 'Operator:',
  x_55bea7c5: 'Observations:',
  x_0a64548c: 'Product',
  x_50b98e79: 'Transfer amount',
  x_031a18b8: 'Issuer signature · Date',
  x_81cb422e: 'Recipient signature · Date',
  x_90d971c7: 'Insufficient stock',
  x_59d31a31: '/required',
  x_3cd9e10d: 'The origin warehouse will show negative inventory; remember to replenish the products later.',
  x_866b795e: 'Error loading',
  x_acc47889: '✅ Added',
  x_acd5cb84: 'failed',
  x_c4ebcdbf: 'Are you sure you want to delete this table?',
  x_cec8924c: '✅ Removed',
  x_fd691fb1: 'Are you sure to publish this table? (The linked pending order link will be deleted)',
  x_c77aedd7: '✅ Released',
  x_23f7319b: 'Error loading QR',
  x_65e200d3: 'Download failed',
  x_28d45b55: '✅ ZIP downloaded',
  x_b264a9b6: 'Download error:',
  x_d3a27772: 'Add tables first',
  x_16fca75d: '✅ ZIP downloaded / Downloaded',
  x_3317ce8e: 'Table number (leave blank for automatic)',
  x_f1e3f7fb: 'name (optional)',
  x_4af1e6c6: 'Number of seats',
  x_a7bac223: 'chinese',
  x_806c4388: 'green',
  x_d088e652: 'red',
  x_b990b42b: 'orange',
  x_2fc8da52: 'blue',
  x_34e66c72: 'purple',
  x_9cba5857: 'black',
  x_4207f36f: 'Tables',
  x_be5fbbe3: 'save',
  x_904614f6: 'There is no table yet',
  x_55fdd74d: 'First go to "⚡Industry Template" and select "🍽️Restaurant", the system will automatically create 10 tables',
  x_505fcefc: 'Or click the "Add Table" button above to add it manually',
  x_d07d6cdf: 'Free',
  x_29880b96: 'Usage:',
  x_45e716f0: 'The customer sits down → the waiter selects the product at the POS → presses "F4 to place an order"',
  x_362857a7: 'Please enter table number comments (such as "Table 3") when placing an order, or visit this page to associate',
  x_5abc3304: 'The customer wants to add dishes → POS retrieves the order → Adds new products → Replaces the order',
  x_d01b9612: 'The customer wants to pay → POS retrieves the order → collects payment → releases this table',
  x_a889dfa2: 'Scan the QR code to place orders at each table. Print or download the ZIP and paste it on your desktop.',
  x_56ba8da3: 'Sellox · Scan the QR code to order food',
  x_a6bcd7fd: 'Scan the QR code to automatically select a table number',
  x_bffc3306: 'There is no table yet; go to "Add table" on the left',
  x_22342357: 'Language',
  x_664bd4c3: 'Color',
  x_562afa20: 'Select language and colors to see preview',
  x_cdc8aa2a: 'Please enter a valid amount',
  x_a6be14ea: '🎉 The prepaid card has been generated',
  x_a889286a: 'Creation failed',
  x_d9217d95: 'Failed reload',
  x_73268407: 'Are you sure you want to deactivate this card? (The cardholder will no longer be able to use it)',
  x_174bdf89: 'Please enter the card number + PIN',
  x_6047d376: 'The popup has been blocked, please allow the popup and try again.',
  x_3671b15c: '4 digits',
  x_99c1801d: 'Find customer name/phone number/last card number',
  x_ad6b7038: 'Available',
  x_9c2b5257: 'Out of stock',
  x_5c56a889: 'deactivate',
  x_7779a6ac: 'Buy $50 and receive $5',
  x_81b5d9ee: 'Copied card number',
  x_a2fd009c: '🎁 Gift Card / Stored Value Card',
  x_cac30fb8: 'Card code/number',
  x_a93dac50: 'Balance / Balance',
  x_fa6c3ef4: 'Please keep this coupon in a safe place. Card number + PIN is required for consultation and use.',
  x_d4334477: 'Gift Cards',
  x_0e03f74c: 'Check balance',
  x_f9089b58: 'Card number (16 digits)',
  x_554b5f0d: 'Card queue number',
  x_3577a5ae: 'For sale',
  x_584cd195: 'Expired',
  x_8a6e6c55: 'No stored value card yet',
  x_11344dd6: '🎫 Release of stored value cards',
  x_39a058d6: 'Enter the amount and customer information to generate a new prepaid card.',
  x_5b90f4f9: 'Amount on the card ($)',
  x_a10e8516: 'Store gift ($)',
  x_8f876263: 'Customer name (optional)',
  x_b4a12819: 'Customer phone number (optional)',
  x_7430e2e0: 'Validity period (days, 0 = forever)',
  x_1ffb8483: 'generate card',
  x_f0ec8be7: '🎉 A prepaid card has been generated: write down the card number + PIN',
  x_76bd513c: 'Copy the newly generated card number and PIN to the physical card.',
  x_a614e73a: 'Code',
  x_308111f4: 'Important:',
  x_b3531d90: 'Card number and PIN',
  x_f2c00976: 'Show only this time',
  x_bd8ee68a: '🖨️Print',
  x_a6dada89: 'I have noticed ✓',
  x_c5b6c7ba: '💵 Recharge stored value card',
  x_7a8c087d: 'Add additional funds to stored value cards that have been issued.',
  x_74fbcc56: 'Card queue number:',
  x_204538f5: 'Current balance:',
  x_1f143c8d: 'Recharge amount ($)',
  x_7e410409: 'Active',
  x_eca18247: 'Completed',
  x_9809e6f2: 'Canceled',
  x_b7a2291a: 'Forfeit',
  x_5a08deaf: 'Error loading',
  x_63b8f2b2: 'Search order number/customer/phone number',
  x_e7784a34: 'Saved',
  x_712939e0: 'The quantity must be greater than 0',
  x_051e1c80: 'Recorded collection',
  x_3d1f2fcc: 'Error',
  x_22bbda1e: 'Allow popups',
  x_d6818f91: '<tr><td colspan="3" style="text-align:center;color:#999">No registration</td></tr>',
  x_dd139654: 'Canceled / Canceled (Inventory has been reverted)',
  x_5cbad596: '🟢Deposit',
  x_b5a103dc: '💵 Additional payment',
  x_d98fd798: 'Note/Note (optional)',
  x_5769b85a: 'Confirm subscription',
  x_a29d3fab: 'Reason',
  x_92b67f7b: 'Return of deposit to client',
  x_094590c4: 'Deposit goes to merchant (no refunds)',
  x_2a33020e: 'Saving...',
  x_0aa2fd58: 'Active',
  x_80e42329: 'Completed',
  x_443483c9: 'the entire state',
  x_fb852fc6: 'In progress',
  x_fad5222c: 'Completed',
  x_d6a3df8d: 'confiscated',
  x_08226a9b: 'Items',
  x_a015434e: 'Products',
  x_b9224f27: 'Amounts',
  x_0b68090c: 'Total',
  x_8ed12dec: 'Paid',
  x_f085817a: 'Balance',
  x_7220e4d5: 'path',
  x_edd98a05: 'No registration',
  x_21a22391: 'Client',
  x_9f796492: 'Items',
  x_3f1e93a5: 'Add fertilizer',
  x_9b7e9298: 'Today:',
  x_464ee460: '🔒 Creation Lock:',
  x_15e8601c: 'USD Cash',
  x_6aad3987: 'Bs in cash',
  x_3ed4a686: 'Transfer',
  x_25557e0c: 'Card',
  x_66a35235: '⚠️ Cancel order (stock will be restored automatically)',
  x_4253d249: 'separate rules',
  x_150978ed: 'Enable Apart functionality',
  x_db82dff0: 'Min. advance payment %',
  x_f411a870: 'Term (days)',
  x_bfa32868: 'days of grace',
  x_89d38266: 'Once this number of days has passed, the deposit will be returned to the merchant.',
  x_05e6cff3: 'Reminder (days before)',
  x_780eb764: 'I receive WhatsApp',
  x_ca0e7ab8: '🏭 Industry specific model',
  x_40a69a97: 'Select an industry to enable corresponding features + category presets with one click',
  x_ce198527: 'restaurant model',
  x_4457ca2a: 'Table management · KDS kitchen display · Service fee · Dish group printing · Dish emergency button',
  x_f3bede6c: 'clothing store',
  x_31638707: 'Size × color variant · Seasonal label · Automatic wholesale and retail price reduction · Inventory is counted independently by variant',
  x_4b94f7ca: 'fast food/pastry',
  x_e4ec5eb2: 'Meal ordering · Kitchen ticketing · 7 pre-established categories (bread/cake/coffee)',
  x_f62e3009: 'Supermarket/groceries',
  x_c6f34300: 'Top 10 categories Bulk/weighing enabled by default Whole case sales Cold chain distinction',
  x_629960fd: 'pharmacy',
  x_ba330da8: 'Classification with/without prescription · Batch number + expiration date notice · Recipe traceability',
  x_0f84be62: 'Hardware/Electronics',
  x_17b68710: 'Tools/Paint/Plumbing 7 Categories · Serial Number Traceability (Electronic) · Warranty Management',
  x_7bcbf628: '🛒 Cashier + Sales',
  x_79223063: 'Smart POS ATM',
  x_e5cbb127: 'Barcode scanning Multiple price levels Dual currency Bs/USD Shortcut keys Offline operation',
  x_ed4d7ae6: 'Offline PWA Mode',
  x_c8bc72c1: 'Billing will continue to be issued even if the network is disconnected · After restoration, the global queue will be automatically loaded synchronously',
  x_2e16c12a: 'Windows desktop application',
  x_44819336: 'Electron packaging · 90 day JWT long session · Silent updates · Out of the box',
  x_a6185298: 'Online shopping center + QR code',
  x_3ff0e9d1: 'The online store is automatically generated Customers scan the QR code to place an order Self-service ordering / door-to-door delivery / self-pickup',
  x_c6840e7e: 'Customer CRM + wholesale profit margin',
  x_c98fb10f: 'Membership Points/Level Credit Account Referral Refund Automatic Price Change for Wholesale Customers',
  x_3a44d260: 'Thermal printing',
  x_715e4b5e: '80mm Receipt Price Label ESC/POS Direct Connection Multi-Store Printer Setup',
  x_61ac4d4d: '🛵 Delivery + Marketing',
  x_c51eca4b: 'Passenger platform + automatic order submission',
  x_31439e52: 'Passenger registration · Real-time GPS tracking · Automatic order shipping based on distance + availability · 60-second order countdown',
  x_50e8efc4: 'Automatic WhatsApp Birthday Wishes',
  x_a8701246: 'Scan customers\' birthdays at 09:00 every day · Automatically send blessings + discount codes · Free repurchase',
  x_157c7c85: 'Christmas mass messaging + programming',
  x_abe4ae61: 'One-click bulk messaging for Christmas/Mother\'s Day/Valentine\'s Day Scheduled Hours List of National Holidays Historical Records',
  x_1eb970e4: 'promotions',
  x_aef63132: 'Discounts · Total discounts · Gift purchase · Limited-time flash sales · Configuration by category/single product',
  x_a1336484: 'points mall',
  x_193aa1e3: 'Customers use points to redeem coupons, gifts or top up their balance Limited time redemption',
  x_9a3ebc32: '💼Backend management',
  x_83d7870e: 'Multi-warehouse + transfer',
  x_5ca33875: 'Multiple warehouses · Assign and create automatic source warehouses · Automatically record differences in receipts and report losses · In-transit tracking',
  x_b3184a0c: 'P&L report (separate USD/Bs)',
  x_387e4ccd: 'Gross Profit · Expenses · Losses · Foreign Exchange Income · Each currency is displayed independently',
  x_41cdb401: 'Cash management in branches + foolproof',
  x_7c6e4907: 'USD/Bs balance in real time · Large amounts (>100,000 Bs / $1k) must be confirmed twice · Avoid accidental deposit',
  x_4bb41a3f: 'shift transfer',
  x_12e3a178: 'Cash counting · Client signature · List of denominations · Automatic WhatsApp sending to the boss',
  x_7be86c2c: 'Employee Accounts + Attendance + Payroll',
  x_50fa2355: 'Loan Credit Payment LOTTT Section 106 Compliance A4 Payroll',
  x_8ddf6808: 'Audit log + inventory audit',
  x_4d5169cd: 'Complete records of high-risk operations · CSV export · Automatic nightly comparison of product.stock vs actual warehouse',
  x_c97dba40: '🤖 Blessing of AI',
  x_6d06e53e: 'AI Product Image Beautification',
  x_8ed5fef6: 'Gemini Nano Banana removes backgrounds with one click + beautifies product images Batch processing Restores original images',
  x_b94b644f: 'AI chat assistant',
  x_df5fb097: 'GPT-5.2 Customer Service · Automatically respond to product/inventory/order status · 24/7 online',
  x_4ec4a23d: 'AI Mobile Payment Verification',
  x_56c6972a: 'AI screenshot automatically identifies quantity/date/reference number One-click review by cashier Anti-counterfeiting',
  x_32a15937: 'Barcode creates products automatically',
  x_875fae32: 'Scan or enter barcode · Automatically search global product database (Open Food Facts / UPCitemdb) · 0 manual entries',
  x_10899d94: '🌍 Multi-country adaptation',
  x_ee7818c0: '8 countries automatically configured',
  x_77a6000a: '🇻🇪VE · 🇨🇴CO · 🇧🇷BR · 🇿🇦ZA · 🇩🇴DO · 🇨🇷CR · 🇹🇹TT · 🇵🇦PA · Automatic exchange rate/language/payment channel',
  x_9dd027aa: '4 language switching',
  x_f6cbc1ec: 'Chinese/English/Spanish/Portuguese: One-click switching',
  x_e3c6859e: 'Dual currency settlement + real-time exchange rate',
  x_6cb9867e: 'Bs/USD exchange at will · Official BCV + black market exchange rate · Report currency exchange with one click',
  x_863683ad: 'Smart POS designed for retail',
  x_e1828ed2: 'Covering 7 major industries · 4 languages · 8 national markets',
  x_3665550b: 'Restaurant · Fast Food · Clothing · Bakery · Pharmacy · Beauty: industrial templates can be activated with one click · 7-day free trial',
  x_cd1ce731: 'Try it now for free',
  x_0d2a321f: 'Do you already have an account? Sign in',
  x_7bf86a2a: 'All features',
  x_e539f895: '30+ features covering cashier, inventory, distribution, marketing and artificial intelligence · Sign up to enjoy',
  x_6a4ab7b8: 'Register now',
  x_660d93f4: 'Experience all features free for 7 days without paying · Optional auto setup for 7 major industries',
  x_5a631c6c: 'new',
  x_402d19e5: 'Sign in',
  x_9ceb77bb: 'Trilingual support · Dual currency settlement · 7 days free',
  x_021782de: 'Language support',
  x_81ea4b71: 'Run in the cloud',
  x_1d3ba50c: 'Data security',
  x_2e525185: 'Supports any device',
  x_0ec9d3c3: 'It can be used on computers, tablets and mobile phones.',
  x_1cfc09aa: 'Sign up to enjoy all features',
  x_8e046e99: 'Created for various companies',
  x_d48f3735: 'retail store',
  x_926a9ffe: 'Suitable for supermarkets, convenience stores, grocery stores, clothing stores, etc.',
  x_cff3dc29: 'wholesale business',
  x_5087d5ee: 'Support to the wholesale pricing system, key account management, accounts receivable.',
  x_ce98716f: 'Store chain management.',
  x_320fd2de: 'The headquarters manages multiple branches in a unified manner, with interconnected and assigned product inventories, and each store has independent cashiers and reporting.',
  x_605629af: 'ordinary store',
  x_14079459: '✨ Automatically create 7 menu categories + 10 tables + 10% service fee',
  x_02d470b4: '✨ Automatically creates 8 clothing categories + size and color variants',
  x_19c60018: 'Universal retail model – no preset categories, create your own (suitable for 90% of businesses)',
  x_a93d885f: 'Reference code (optional)',
  x_fefc4fec: 'Sign up using the referral code to get an extra 30 days trial',
  x_87417e71: 'Business type',
  x_f134be36: 'Cannot log in offline; first log in online',
  x_80745991: 'Cashier at reception',
  x_29ee0354: 'Cashier only - log in and go directly to the cashier',
  x_2443e297: 'Enter the cashier',
  x_de094deb: 'Install app / Install app',
  x_ea90083b: 'Open in Chrome to install / Open with Chrome to install',
  x_11afe095: 'Scan product barcode',
  x_570e1531: 'Align the barcode completely with the green frame · Distance 10-20 cm',
  x_58faba06: 'Camera cannot be accessed, please check permissions',
  x_bec7e4d6: 'change',
  x_17e423b0: 'flash',
  x_a4c59470: 'Click on the screen to focus manually',
  x_3c43c899: '💡 Let the barcode fill the green frame and keep it stable · It will look blurry if it is too close',
  x_5f031153: '📵 This device does not support flash',
  x_22867dc5: 'Scan again',
  x_lbl_created: 'Created',
  x_lbl_rejected: 'Rejected',
  x_lbl_reason: 'Reason',
  x_lbl_operator: 'Operator',
  x_lbl_total: 'Total (units)',
  x_lbl_notes: 'Notes',
  x_80a36145: '✅ Automatically synced',
  x_1eec1e2e: 'End previous network outage operations',
  x_e85b2d54: 'Offline products have been synchronized.',
  x_8cc59319: 'Order Sync Successful',
  x_fad33691: 'Order sync failed:',
  x_1fa61c48: 'Zhang\'s rejected order history has been auto-resended/auto-recovered orders',
  x_73ae77ff: 'Offline mode: uses cached data (',
  x_8ae9eaca: 'update)',
  x_57fa0696: '- remembered (',
  x_49ae0e5e: 'articles)',
  x_4068bc35: '⬆️Upload before class ends',
  x_7b697750: 'Order to synchronize...',
  x_cdc0393e: '⚠️Also',
  x_960c577f: 'The order could not be uploaded (it was saved on this machine and will be uploaded automatically after connecting to the Internet)',
  x_4094833e: ', no more / sold out',
  x_b7b8517c: ', maximum / exhausted',
  x_6f630d34: '🥡 Pick up food #',
  x_edb823f2: '❌ Product not found:',
  x_45524982: 'The order has been exported to the downloads folder.',
  x_498458a5: '✅ Today\'s exchange rate has been set at Bs.',
  x_5ec06103: '(only this machine)',
  x_c6615916: 'days ago',
  x_bb39a0c6: 'hours ago',
  x_9021c675: '📤 Exported',
  x_1eab1ec2: 'Click to download folder (USB copyable)',
  x_634abe29: '✅ USB Import Completed:',
  x_b359a569: 'New ·',
  x_3af4ed2f: 'It already exists ·',
  x_7030ff64: 'error',
  x_c6e4b6a0: 'the class has started',
  x_e7a7a7e2: 'Hourly shifts not delivered: Submit shifts immediately to avoid confusion in reconciliation between days.',
  x_73559114: 'hours, it is recommended to turn in the shift as soon as possible / Shift open ago',
  x_e2efd3fa: '⬇️ New version v',
  x_2d455ce5: 'Downloading',
  x_51a8f63f: '🔄 New version v',
  x_c540ce8f: 'Done · Disable automatic software installation ·',
  x_4c4d6a98: '📡 Without internet -',
  x_922a9dca: 'The order has been saved securely and will be uploaded automatically after connecting to the Internet / Without network, they will be uploaded automatically',
  x_8d1c5588: '⬆️ Uploading',
  x_6479a0a7: 'Single... / Uploading',
  x_a53de3a7: '• After expiration, the deposit will return to the merchant',
  x_c0cd0f67: 'Exchange Credit Activated / Exchange Credit:',
  x_bc4e851c: 'Confirm to deactivate',
  x_9cd30436: '? \\nAfter deactivation, the products will disappear from the POS/online store, but the inventory and order history will be preserved and can be reactivated at any time.',
  x_47bf13b6: 'to',
  x_c9729ffc: 'If the AI cuts are made on a white background for each product, 1 AI point will be deducted for each product (a total of',
  x_69db7ae0: 'point). Continue?',
  x_c70a3c01: 'AI Slash Completed: Success',
  x_114d9700: '/fail',
  x_8cac6775: 'Matching Images Successfully',
  x_5d459d55: 'Processing',
  x_1e1445b3: 'Start trimming (',
  x_6242f731: ') · Buckle',
  x_be604f8b: 'point',
  x_2ecbd077: '📱 Link has been sent to the boss\'s WhatsApp...',
  x_3a17aa8e: 'Link sent!\\n\\n',
  x_fa407236: '\\n\\nPress OK to copy the link to the clipboard',
  x_cbcbd4e6: 'Confirm wholesale price adjustment?',
  x_1b92092d: 'updated',
  batchNoMatch: '⚠️ No products in the selected category — nothing was changed, pick another category',
  orderShift: 'Shift',
  viewShiftReport: 'View shift report',
  shiftOpenBadge: 'Open',
  shiftClosedBadge: 'Closed',
  batchAllSkipped: '⚠️ 0 updated: selected products have no cost price, set costs first',
  x_8c533c4a: '⚠️ The product already exists:',
  x_d8172b79: '✅ Preloaded:',
  x_162d92be: '— Fill in the price and save it',
  x_82978490: 'Stored value card deducted',
  x_955e88ca: '· Balance',
  x_d43bd196: 'Save offline:',
  x_eeb31a4e: '(Synchronized automatically after connecting)',
  x_41c5ecd6: 'exceed',
  x_ed87d0af: 'Safety threshold. \\n\\nPlease confirm again if the amount is correct.',
  x_94d22b13: '⚠️ Note:\\n\\nReal money:',
  x_741ca864: '(very small)\\nArrears deduction:',
  x_1a079931: '\\nAfter deductions, you still owe:',
  x_e93a7373: '\\n\\nAre you sure?\\n• Press [Confirm] → pay according to the above amount\\n• Press [Cancel] → pay full salary',
  x_4f2bb016: 'All arrears will be deducted (actual payment',
  x_6e11eb39: 'Reset: Deduction',
  x_9de6f844: ', real hair',
  x_8800e34b: '- Deduction',
  x_569ff68a: '= real hair',
  x_48eb726e: 'Successful salary payment: actual payment',
  x_4c117f20: 'Order',
  x_f6348db9: 'Order found:',
  x_692d69b4: 'articles,',
  x_3b5e93d8: 'Marked as [Full Day]\\n\\nSalary is calculated based on the full day. \\nAre you sure?',
  x_1f623127: 'Marked as [Half Day]\\n\\nSalary is calculated as half a day (50%), and absence will automatically be recorded late. \\nAre you sure?',
  x_0064a575: 'Marked as [Absenteeism]\\n\\nThe system will automatically record 1 day\'s late salary! \\nAre you sure?',
  x_dc49966b: '💰 Debt has been registered',
  x_e897afe2: 'Do you confirm paying the following employees? \\n\\n',
  x_87c3b869: '\\n\\nTotal',
  x_465afe3c: 'people',
  x_70e23b2c: 'Payroll -',
  x_a657f46f: 'week',
  x_247b6518: 'Salary has been paid',
  x_d051c48c: 'people fail',
  x_59cf15fe: 'Template',
  x_1463e88d: 'Applied',
  x_d846c018: 'the company must',
  x_b52d1753: 'Deposit balance:',
  x_6a34412a: '\\n\\nEnter the amount to spend (leave blank = All',
  x_5f3fd382: 'The amount must',
  x_f3221016: '0 and ≤',
  x_c66b7456: '✅ Paid',
  x_37186b95: 'give',
  x_92ff3137: 'Maximum deduction (= min(salary, arrears) =',
  x_ff06778b: 'single)',
  x_9d074fc7: '📱 Sent to',
  x_be509224: 'mobile phone · expired',
  x_e6c92b78: '· Expires soon',
  x_59359c92: 'Are you sure you want to send WhatsApp reminders to all overdue or overdue customers? \\n\\n(The same customer will only be sent once within 7 days and will not be bothered repeatedly)',
  x_03e25cc4: '✅ Sent',
  x_f6614467: 'customer reminders (skip',
  x_6eb87074: 'Article · Failed',
  x_feebfd78: 'article)',
  x_a80efbb5: 'Not sent (total',
  x_60c5bacd: 'records, jump',
  x_fcc7ee2d: ', failed',
  x_7e1fefa7: ')——Check if the customer has a mobile phone number + subscription',
  x_88fe7ca5: 'Full declaration A4 ·',
  x_fe78a84f: '80mm receipt · Payment summary only ·',
  x_758ec925: 'the majority',
  x_cf4a812f: 'Totals / Totals:',
  x_f7edf5ac: 'pieces',
  x_2c117f7f: '✓ Copied order',
  x_01d7aa49: 'of',
  x_4e4008f8: 'products, please select the destination store',
  x_53952782: 'Confirm to cancel the transfer order',
  x_26671096: '? \\n\\nAfter cancellation, inventory will be returned to the origin warehouse.',
  x_128b1e7c: 'table',
  x_2e3a36de: 'minutes ago',
  x_2de0d491: 'hours',
  x_73c826e5: '✅ Successful recharge · New balance',
  x_7e2720b4: 'Client/customer:',
  x_a423e73c: 'Date/Date:',
  x_1a608891: 'days to expire',
  x_182da4c4: '💳 Payment History / Payments (',
  x_24d9bec1: '⚠️ The exchange rate increased today',
  x_2e29f312: '% — The Bs payment is converted based on the current exchange rate (the amount is less than when it was blocked)',
  x_b1848125: '✅ The exchange rate fell today',
  x_be793e09: '% — The Bs payment is converted based on the current exchange rate (the amount is greater than when it was blocked)',
  x_d6420ec0: '— Last update',
  x_603f7892: '⬆️Upload now (',
  x_d6f5f3c9: '🚫Handle rejected orders (',
  x_365c6e84: '🔄 Exchange credit $',
  x_cd600b9e: '), the Bs conversion may have a large deviation',
  x_b61b86ae: 'Waiting for synchronization',
  x_4827c1f8: 'The request was rejected by the server (not credited)',
  x_ff503ba7: '(current Bs.',
  x_7d68b4e3: 'Current:',
  x_2be10f11: 'The quantity of this product in POS is ≥',
  x_41ae38b5: 'Successful match:',
  x_13ddc197: 'Selected · Consult only products with photos',
  x_bec8b787: 'Automatically change price 2 when',
  x_74714605: '🛒 Retail Retailer -',
  x_bb255d74: '🛒 Retail:',
  x_f84bb79f: '🏭 Wholesale:',
  x_530afc78: '% refund',
  x_30f580f1: 'Discount / Discount',
  x_06772a76: 'Point Deduction / Points (',
  x_66525fb9: 'Original price$',
  x_ae89baf7: '🛡️ most',
  x_f93a3192: '⚠️ Maximum discount reached (cost $',
  x_98e21b6a: 'Insufficient balance to pay $',
  x_f2c67994: '$ will be deducted',
  x_b682eb31: 'Maturity/Maturity:',
  x_dcbed21c: '% (cost protection)',
  x_9f93459b: ', you can\'t download it or you will lose money)',
  x_64e6defd: '· Balance/Balance:',
  x_2a7a6a6b: '→ Payable $',
  x_128029c2: '· $ remaining',
  x_eeedcd26: '💵 Withdraw Deposit / Withdraw $',
  x_aedc526b: 'buckle',
  x_41cbd47f: 'Payroll (',
  x_a71e4358: 'There is no template yet. After scheduling your shift, click "',
  x_0d2fb245: '"Save as template',
  x_4ce4ef96: 'information',
  x_b4ebe3f5: 'No',
  x_25aa5d7d: '/ Please add first',
  x_fbd2b1fb: 'total',
  x_2187d87a: 'Order · Received $',
  x_cc09dc10: 'Specifications:',
  x_a0d921b3: '(Shortage',
  x_c37f6a62: 'QR code of the table · Total',
  x_914e2a75: 'Download all ZIP table posters (',
  x_6499fc74: 'zhang',
  x_c2c92c19: 'Zhang)',
  x_e93c8f7b: 'Busy · Current total $',
  x_87ba5064: 'Recharge $',
  x_31180e95: 'Loading error:',
  x_36ea3e81: 'To collect $',
  x_fdf80fc9: 'Charge $',
  x_b34de51a: 'Paid $',
  x_0c6c45ae: 'Payment History / Payments (',
  x_e3bc8fa5: 'Converted to USD (Bs.',
  x_7f4bb1d6: 'days of grace',
  x_48b0dec0: '·Yu$',
  x_27720067: '✕ Delete',
  x_8decf585: '💱 Manually set today\'s exchange rate',
  x_80272374: '📥 Export today\'s offline summary',
  x_b2abad7a: '📤 USB export everything',
  x_68771e30: '📥 USB import',
  x_7ca39c26: 'Close shift',
  x_2ce5a620: 'These orders were rejected by the server during synchronization.',
  x_d8e901bc: 'When it is 0, use the black market; otherwise use BCV.',
  x_f47fc941: '— Click the button on the right to view the cause and fix it.',
  x_1faae5c2: 'Lot price change',
  x_ee2b9ce1: '📷 Scan QR code to add',
  x_d0c1006c: 'Mobile Payment/Transfer follow most of the verification. / Automatically print the receipt after payment and start the next order directly (except Mobile Payment/transfer)',
  x_f3131239: 'When charging in USD (cash/Zelle), the POS automatically adds 3% IGTF and prints it on the receipt. / When receiving US dollars, the 3% IGTF tax will be automatically added and printed on the receipt.',
  x_f09933aa: 'Don\'t you see the new button? Click here → The system will automatically clear the old cache → Upload the latest version immediately.',
  x_f40cbd21: 'Remind all employees that after clicking this button, all employees will automatically sync to the latest version within 5 seconds.',
  x_3a04c76e: '• POS can still make payment when inventory is 0 or negative',
  x_8250b510: '• Inventory will be converted to a negative number (e.g. -5 means 5 pieces are out of stock)',
  x_121b783a: '• Suitable for: The physical product is in the store but the system inventory is inaccurate, the wholesaler often sells in advance and new products have just been launched but the inventory is not recorded.',
  x_4fbdd3a8: '• ⚠️ NOTE: Go regularly',
  x_694ccb6b: '• POS refuses to place orders when inventory is insufficient',
  x_959932ab: '• Prevent overbooking and data chaos',
  x_f34c6c1f: 'Page counting, clearing negative numbers',
  x_59637fe6: 'Adjust the number of pages or temporarily activate this switch',
  x_684ee9b5: 'Force update',
  x_140d6e9a: 'Update now',
  x_32415951: 'Client',
  x_85fc0b89: 'Employee',
  x_vale_label: 'Gift voucher',
  x_vale_placeholder: 'Scan / type code, Enter',
  x_vale_apply: 'Apply',
  x_vale_applied_ok: 'applied',
  x_vale_forfeit: 'Voucher exceeds purchase; forfeited:',
  x_vale_earned_title: 'Customer earned a voucher!',
  x_vale_earned_rule: 'Spend ≥',
  x_vale_valid_until: 'Valid until',
  x_vale_later: 'Later',
  x_vale_print: 'Print voucher',
  x_f676b12b: 'Balance Card',
  x_d5109b1f: '📱 Summarize and send to boss',
  x_f6a5aaac: '🔔 Send reminders to each client',
  x_e87e3fba: '⏳ To sync',
  x_c66a65a3: '💵 You must pay in US dollars / USD only — Payment in Bs not available',
  x_4ef6283c: 'Failed Requires processing',
  x_7ab62e2e: 'The following products do not have enough inventory in the origin warehouse. Please choose how to handle:',
  x_f75eee5f: '✅ Continue adjusting merchandise / Continue (negative inventory allowed)',
  x_58c10a18: 'Adjust to available',
  x_9cc890a7: 'Cancel',
  x_c16cdc6d: '🎨 Beautify posters',
  x_cbdcabad: 'release',
  x_1b8de39d: '⚙️ Automatically integrate “Table Selection → Place Order” UI in the next round. Currently, use backorder notes to associate.',
  x_5b3aaade: 'ℹ️ After printing, cut and paste the protector on each board; Guests can scan to enter their own table\'s ordering page (table number is automatically selected)',
  x_7559ce8e: '🎨 Tabletop posters · Brand posters',
  x_2601cd44: 'ℹ️ A5 size poster (1240×1748 @ 200 DPI), which includes top bar with the store name + plate with the table number + large QR + slogan in several languages + bottom bar with contact information.',
  x_81567a16: 'Simply print it at the printing press, cut it, protect it and stick it on the table. The guest scans the QR code → automatically enters the order page → the table number has been filled.',
  x_7be49895: '📱 QR Table',
  x_727c86c9: 'Add a table',
  x_fbac2d7f: 'Print directly',
  x_c12a29c0: 'Download ZIP (each PNG separately)',
  x_46c8a671: 'Launch of new cards.',
  x_e50663b2: 'Recharge',
  x_79d3abe9: 'Copy',
  x_b1fe43e8: '. Write them on the physical card/print the receipt and give it to the customer. If the card is lost, the customer must show the card number + PIN to check/use it.',
  x_fd924ff0: '🏷️ Set aside',
  x_f20ccb10: 'No sections',
  x_e8606af7: 'Confirm cancellation',
  x_45f2c9a0: 'Expires:',
  x_616c68e6: 'Rule configuration',
  x_132c5cdc: 'try again',
  x_5c52b0fd: 'Expires 7d',
  x_12aabd94: 'Overdue',
  x_ad3cd23a: 'Print',
  x_1cb2b4b8: 'Cancel',
  x_fix_bulk_hint: '(The online shop will show a "Bulk" tag; customers can buy 0.5 / 1.8, etc.)',
  x_fix_otherwh_hint: 'Other warehouses (read-only; use Inventory Adjustment or Transfers to modify)',
  x_fix_upload_hint: 'files; click "Start upload" and the server will match them by code',
  x_fix_rejected_hint: 'Check the reason: delete duplicates; if it is a real sale press "Resend".',
  x_fix_guestwifi_tip: 'Tip: use the router Guest Network with 2-minute auto disconnect.',
  x_cd509648: 'Search products...',
  x_26b5bd49: 'Loading...',
  x_d5faf486: 'the store does not exist',
  x_a8b0c204: 'all',
  x_e3a7209e: 'There are no products yet',
  x_1bd84635: 'Daily selection of fresh foods.',
  x_663af409: 'Order delicious food online',
  x_c76203b6: 'Selection of department stores, everything you need',
  x_9450139e: 'Healthy life, careful care.',
  x_fb289d60: 'Freshly baked and fragrant',
  x_13f0b75a: 'Fashionable clothing savors life.',
  x_a6ef79b6: 'All the latest technological innovations are at your fingertips',
  x_a03f1a4b: 'Quality assurance of fresh meat',
  x_21f9dcf0: 'Online shopping Home delivery',
  x_54e5de42: 'Error uploading',
  x_18e80613: 'Merchant WhatsApp not configured',
  x_aed1dfbc: 'in',
  x_b71301e1: 'Choose / Select',
  x_0288e6a2: 'The browser does not support GPS',
  x_12cffd73: '📍Locating...',
  x_48b05582: '✅ Your location has been recorded so that the passenger can deliver you with greater precision',
  x_9ccbd711: 'Can\'t get location, fill in address manually',
  x_2f6911f3: 'My location has been registered ✓',
  x_1499f061: 'Use my current location (delivery is more accurate)',
  x_dc715bb8: 'Confirm order',
  x_0d0bc2bc: 'Copied / Copied',
  x_dac8225e: 'Choose option (size/color/flavor)',
  x_9f9cbc48: '1.8 OK)',
  x_7f6e80a6: 'Click "Confirm"',
  x_27c05b27: 'WhatsApp will automatically open with the order details already filled out and you can simply send the payment method to the merchant.',
  x_3a9be7db: 'Send payment to / Please transfer to:',
  x_f65ce56a: 'Issuing bank / bank',
  x_ed4ea468: 'Telephone number of the issuer/sender',
  x_bb58400a: 'Check price',
  x_619fd86c: 'Enter product name/barcode...',
  x_1d7a5330: 'Product not found',
  x_fb852fc6: 'In progress',
  x_cd8c77d3: 'Completed / Completed ✅',
  x_2111ccbb: 'Canceled',
  x_6a0abbb7: 'Expired / Confiscated ⚠️',
  x_1ea78d47: 'invoice',
  x_ff0b2077: 'Client',
  x_6ffe81e2: 'total amount',
  x_57b642fc: 'Paid',
  x_931f1f80: 'to pay',
  x_9897d884: 'merchandise',
  x_474cd02d: 'payment',
  x_b0fae043: 'rules',
  x_499b9a62: 'expiration date',
  x_8c1bc4ba: 'term',
  x_98ffc82c: 'Minimum deposit',
  x_82188307: 'If not paid within the deadline, the deposit will belong to the merchant.',
  x_e2eb6313: 'Please pay in store',
  x_6f83193b: 'Client signature',
  x_e9bd1d12: 'Accepted terms',
  x_c281ff84: 'Terms not accepted',
  x_affa4d0e: 'Loading... / Loading...',
  x_c6dd0ab3: '• If not paid within the deadline, the deposit will belong to the merchant.',
  x_8deff26f: 'Take pictures casually',
  x_866b795e: 'Error loading',
  x_7683487f: '✅ Completed, continue with the next.',
  x_82bae6ba: 'Search name/code/barcode',
  x_bbd24cc2: '📷 Take photos',
  x_2a3114f2: '🔄 Replacement',
  x_c0588fd1: 'You have denied camera permission. Allow the camera in your browser settings.',
  x_efb8ad19: 'Camera device not found',
  x_c9ece2f8: 'AI beautification fails, you can use the original image directly',
  x_d1f9b309: 'Could not save, original image preserved',
  x_8705e16b: 'Available only for bosses and managers/Administrator/individual manager',
  x_77dbf376: 'Camera Boss',
  x_42eae5c2: 'All products have photos!',
  x_d2a53af5: 'No products',
  x_3fe62d01: 'First find the product you want to replace',
  x_5fbe1b26: 'Taking pictures...',
  x_36152aa9: 'AI Beautification...',
  x_bfeacb2a: '~15 seconds',
  x_95d9b747: '📸 Original image',
  x_3fb7e372: '✨AI Beautification (white background)',
  x_3f981012: 'Recommended',
  x_997c7a5d: 'Function',
  x_6adafe27: 'Industry',
  x_a95dd3e1: 'technology',
  x_d38a089e: 'Contact',
  x_402d19e5: 'Sign in',
  x_248f81e2: 'Free trial',
  x_3ab22098: 'Cloud POS System',
  x_e06f69f5: 'do your business',
  x_cc15c20a: 'Go to the next level',
  x_2852a028: 'Take full control of your store, restaurant or pharmacy. USD/VES multi-currency, e-invoice, available offline.',
  x_dd88cfbf: 'Free trial for 7 days',
  x_8a81d8ca: 'See features',
  x_b52b8c1f: 'Safe and stable',
  x_d255512b: 'SEE',
  x_1d8d47a1: 'Automatic Mobile Payment Verification',
  x_84b0b2a1: 'Available offline',
  x_6fcc5a76: 'Cloud security',
  x_0cee3341: 'Active trader',
  x_55131659: 'daily trading volume',
  x_b67495ee: 'online rate',
  x_f0fbeece: 'Technical support',
  x_176ca494: 'A system for all needs',
  x_b4fa6629: 'From fast payments to smart reporting, Sellox has all the tools to help your business grow.',
  x_f1c5a568: 'Extremely fast payment',
  x_adc03f83: 'Smart search, barcode scanning, and keyboard shortcuts complete sales in seconds. It also works offline.',
  x_c0c97799: 'real time inventory',
  x_40483407: 'Real-time inventory, package combinations, low inventory warnings, and transfers between warehouses.',
  x_3c1a2842: 'smart report',
  x_1aa9589f: 'Sales, profits, best-selling products and package analysis, view with a single click.',
  x_ab572bf7: 'Pay in separate orders',
  x_c677e641: 'Multiple payment methods are accepted for one transaction: cash, bank card, transfer.',
  x_42081db9: 'customer loyalty',
  x_a1c08c39: 'Points programs, membership levels, special prices by type of client.',
  x_3f70a475: 'Ticket printing',
  x_f5fbde12: 'Compatible with conventional thermal printers (Bixolon, HKA) and supports dual printing of receipts and invoices.',
  x_47acae77: 'Chain headquarters management',
  x_ae346bda: 'Multi-store performance overview, cross-store inventory display, unified pricing, and B2B customer credit management.',
  x_9eb1059d: 'Smart replenishment',
  x_77e17012: 'Automatically analyze sales velocity, predict out-of-stock times, and generate a list of replenishment suggestions.',
  x_c14027b7: 'Adapt to your type of business',
  x_0c5bd351: 'retail',
  x_e37fda71: 'Shops and retail',
  x_1752dd18: 'Comprehensive inventory control: low inventory warning, barcode scanning, tiered customer pricing, price label printing, and supplier management.',
  x_9d39de37: 'barcode scanning',
  x_8bc3ace8: 'Tiered prices',
  x_a297a148: 'Inventory management of several warehouses.',
  x_9e4e8242: 'Packages and Promotions',
  x_37346312: 'Price tag printing',
  x_faeff5ef: 'supermarket',
  x_87dc671e: 'Supermarkets and convenience stores.',
  x_312dc180: 'Efficiently handle large volumes of transactions, integrating electronic scales, barcode scanning, multiple checkout parallelization, and shelf life management.',
  x_3e6c0601: 'High frequency transaction processing',
  x_73b2dfdf: 'Multiple ATMs in parallel',
  x_b4157847: 'Electronic scale integration',
  x_e9bb592c: 'Lifespan management',
  x_58936f4b: 'Wholesale and retail prices',
  x_2a0ad6ff: 'restoration',
  x_d2010d15: 'Restaurants and cafes',
  x_26b82bf3: 'Comprehensive platform for table management, kitchen receipts, dish notes, tips and separate billing.',
  x_450fec16: 'Desktop management',
  x_58adcc1a: 'Kitchen screen/print',
  x_8c1b8588: 'Separate billing',
  x_6c7083d9: 'Automatic dump',
  x_537efc66: 'order to take away',
  x_53b4b807: 'beauty',
  x_98a53972: 'Beauty and hair salons',
  x_24fbec85: 'Appointment management, customer service records, employee commissions and member loyalty programs.',
  x_220e22c6: 'Appointment management',
  x_9c4df083: 'Employee Commission',
  x_b78043c0: 'Customer profile',
  x_cc98eba1: 'Points program',
  x_cceccce5: 'Automatic reminder',
  x_068d9237: 'It can be used with or without an Internet connection.',
  x_495aee53: 'Designed for Venezuela. Even if the power and network goes out, the POS will continue to work.',
  x_f0527d8a: 'Data is automatically backed up and can be accessed at any time from any device.',
  x_4a61c29a: 'Offline mode',
  x_b5b0394e: 'Sales will continue as usual even if the network is disconnected and data will be automatically synchronized after the network is connected.',
  x_b0404c0b: 'Smart Sync',
  x_ad79d5c5: 'The data is saved in local IndexedDB and will not be lost even if the network is disconnected for several days.',
  x_30504e20: 'Support for multiple devices',
  x_6d6042f2: 'It can be used on computers, tablets and mobile phones, and the interface adapts perfectly to various screens.',
  x_f3de96c1: 'Computer as main cashier',
  x_a123f815: 'Check sales data at any time from your mobile phone',
  x_18e45612: 'Multiple terminals online at the same time',
  x_2ed39222: 'employees',
  x_9c7d7a67: 'unlimited',
  x_654522d2: 'Currency',
  x_97b835a4: 'Availability',
  x_17927e12: 'Full functionality',
  x_a8b6d749: 'More complete than any POS',
  x_ac84ee55: 'electronic invoice',
  x_bdb58c39: 'Automatic exchange rate updates',
  x_8242ec7e: 'Member loyalty program',
  x_3e751fda: 'Packages and combos',
  x_bb84d6ea: 'Order Notes',
  x_b612cf7a: 'Shift management',
  x_dbc12902: 'silent thermal printing',
  x_e81ee1fe: 'Multiple warehouse management',
  x_87821b0d: 'sales report',
  x_46756e70: 'profit analysis',
  x_c791eec3: 'Supplier management',
  x_f5a29430: 'Procurement control',
  x_8cca9955: 'online shopping center',
  x_93befa62: 'online order',
  x_9f08dc32: 'virtual store',
  x_be37ebc5: 'Returns and refunds',
  x_baa125c4: 'Interstore Inventory',
  x_42b52276: 'B2B customer management',
  x_b9ee7355: 'Smart replenishment suggestions',
  x_d4d37b95: 'Sales velocity analysis',
  x_46cf89f9: 'Exhausted prediction',
  x_ebff97ec: 'Management of loans/credits for employees',
  x_28d629c1: 'Attendance punch card system',
  x_67580600: 'Automatic payroll calculation',
  x_a4e9168d: 'Vacation schedule (1.5 times salary)',
  x_cb4588c2: 'AI Mobile Payment Verification',
  x_f348c3f7: 'Exchange management (buy US dollars/swipe cards to exchange them for cash)',
  x_4e3c5d06: 'Purchase order management',
  x_52f264a7: 'Shift Cash Counting',
  x_28f364b2: 'Multi-price model (retail/wholesale/full container)',
  x_7253b11c: 'Offline PWA Ordering',
  x_df5a934f: 'Get ready to do your business',
  x_47db59fb: 'Taking it to the next level?',
  x_267335fb: 'Join hundreds of merchants in Venezuela who trust Sellox.',
  x_2673904b: 'Get started for free',
  x_65300d22: 'No credit card required, sets up in 5 minutes.',
  x_1a69cc94: 'Start now',
  x_4d9b70e1: 'Improved efficiency',
  x_0e9fd989: 'Price',
  x_a7bac223: 'chinese',
  x_a132c42f: 'Download for Windows',
  x_a825a5b0: 'Do you have any questions? ask',
  x_92248c47: 'customer service or',
  x_c984d4fd: '✨ Latest AI features',
  x_01ff215e: 'AI helps you do business',
  x_f5299c8e: 'Nano Banana Beautiful Images',
  x_7fa9308c: 'Turn blurry product photos taken with your mobile phone into professional photos with just one click (Gemini Nano Banana)',
  x_e9a8de17: 'WhatsApp AI Marketing',
  x_ed2f6b2f: 'Automatic birthday greetings + Christmas marketing + responses in four languages (Chinese, English, Spanish and Portuguese)',
  x_576c046d: 'voice teller',
  x_8f395150: 'Say "Add 3 Cokes" to place your order (Whisper STT)',
  x_99d6e6c1: 'AI Butler',
  x_627f661f: 'Automatically analyze sales every night and provide stock suggestions for tomorrow',
  x_1f7b6ef8: 'Multinational exchange rate',
  x_d1529f52: 'BCV + Parallel + Frankfurter automatic updates in real time (compatible with 7 countries)',
  x_c0373da5: 'The annual fee includes cloud servers, automatic backups and system updates - the more stores, the greater the cloud usage.',
  x_3a80619c: 'Not sure which feature is right for you? ask',
  x_5d6e903d: 'customer service, or',
  x_423811c2: 'Simple package, all functions.',
  x_86cb3a40: 'No hidden fees, cancel anytime. Get started with a 7-day free trial.',
  x_55b728d1: 'most popular',
  x_890e3707: 'Basic version',
  x_f9205ad4: 'Commercial version',
  x_94ac1fb3: 'Enterprise Edition',
  x_5ad3f664: 'Cloud Year + Maintenance Fee',
  x_a3e93bd5: '✅ Automatically verify the arrival of the Mobile Payment account',
  x_8242103b: 'Multicurrency USD/VES + automatic exchange rate',
  x_b7815b8e: 'Available offline + cloud backup',
  x_af2ed285: 'WhatsApp customer support',
  x_dc65864a: '🛒 Includes online store (online shopping center)',
  x_01efcb04: 'Does not include online store',
  x_7a5eaa76: 'Do you need to activate or renew? Contact',
  x_49707f5f: 'Do you have questions?',
  x_b69517e9: 'customer service /',
  x_2f312b31: 'original$',
  x_c87b05f9: 'Store/store:',
  x_d6b71ccb: 'All / All stores',
  x_91c1ffb2: 'Bs/BCV (Government exchange rate purchase)',
  x_06510ba7: 'parts inventory',
  x_12448e37: 'Cost:',
  x_6c694f7b: 'Retail:',
  x_b0c1f4e6: 'Original $ (black market purchase)',
  x_450efd2f: 'total',
  x_f6f1d40b: 'Total cost:',
  x_724210ee: 'Total retail sales:',
  x_61406e63: 'Profit margin:',
  x_652be256: 'Classification details',
  x_d0771a42: 'Classification',
  x_f0789e79: 'mode',
  x_040dd10a: 'Number of items',
  x_0eac8802: 'inventory',
  x_671e045d: 'Cost$',
  x_4c5d80a5: 'Retail$',
  x_1fc64a84: 'Profit$',
  x_bd4357f9: 'all day',
  x_c31b1b99: 'half day',
  x_02efd8b1: 'absenteeism',
  x_3cdcbdf0: 'Festival canceled',
  x_15dd9319: 'Set as a holiday (double pay)',
  x_2a2338ae: 'Attendance management',
  x_583cc547: 'total employees',
  x_1c6f494e: 'Already registered',
  x_a7da9234: 'store',
  x_93849f29: 'today\'s attendance',
  x_87bd8d0d: 'vacation calendar',
  x_3ccfeac0: 'Punching log',
  x_464f3d4e: 'paper',
  x_b4f0388f: 'go to work',
  x_96ed60cd: 'leave work',
  x_3fea7ca7: 'Status',
  x_6bc72d59: 'Not registered',
  x_f5360872: 'Click on the date to mark/cancel the holiday and working during the holiday will be counted as 1.5 times salary (LOTTT)',
  x_8fb52fe0: 'Preloaded holidays',
  x_a7a9b5d0: 'new',
  x_9087937f: 'Prefill 2026 Legal Holidays',
  x_29a98994: 'holidays of the month',
  x_046c6233: 'recently',
  x_249aba76: 'day',
  x_4ff1e74e: 'Date',
  x_2b6bc0f2: 'Operation',
  x_19fcb9eb: 'time',
  x_676e5982: 'operator',
  x_b3755e33: 'Daily Branch',
  x_0c9d2b45: 'Payment method',
  x_c633a333: 'expected',
  x_06f26e9d: 'real',
  x_5fdfbade: 'difference',
  x_1f11f332: 'The PIN must be 4 or 6 digits',
  x_6a6dfeb1: 'Two entries are inconsistent',
  x_7a6d647f: 'Saved PIN',
  x_6de920b4: 'Error saving',
  x_175377c0: 'Change PIN',
  x_cbbd1f37: 'Set PIN',
  x_2a33020e: 'Saving...',
  x_fd7c0215: 'Please confirm with PIN',
  x_b070fd2b: 'Boss WhatsApp PIN / Boss WhatsApp Command PIN',
  x_66bff1f9: 'Used to confirm price changes, refunds, order deletions and other **dangerous operations** via WhatsApp',
  x_44e60789: 'Already configured',
  x_fe2d26a2: 'not established',
  x_e81c6450: 'blocked',
  x_ed6c2836: 'Failed attempts:',
  x_1b87b102: 'New PIN (4 or 6 digits)',
  x_df21533b: 'Confirm PIN',
  x_359986fb: 'Update PIN',
  x_6b08b3ce: 'Save PIN',
  x_8513ad10: 'How to use',
  x_32fa6a1b: '1. Send WhatsApp from the whitelisted boss number to the Meta number linked to Sellox.',
  x_cb43e349: '2. Respond directly to inquiries (today\'s sales, inventory, credit).',
  x_20f82d05: '3. For modifications (price change/refund/inventory adjustment/collection issue), "Confirm with PIN" will be replied.',
  x_8f4e84c9: '4. You only respond with a 4-digit PIN, which is valid within 5 minutes. The system will run and report.',
  x_1c3b9af4: 'All operations are written to the audit log (audit_logs) and 5 incorrect PINs are automatically blocked for 15 minutes.',
  x_61f6d70f: 'Cash',
  x_798d879e: 'Card',
  x_3ed4a686: 'Transfer',
  x_3dd2ecf9: 'Credit',
  x_b0559b3d: '✅ Preview generated',
  x_6a3a5ef0: 'Preview error',
  x_3bd0272f: 'Please enter the member\'s mobile phone number first.',
  x_9ca6a344: 'Failed shipment',
  x_ac52a991: '(no name)',
  x_b93fce3d: '📆 1 of each month',
  x_f493a608: '📅 Every day 21:00',
  x_11e80f95: 'all',
  x_ba1a3a35: 'Sending...',
  x_07d0b32a: 'Send',
  x_2b5c1e95: '✅ Saved',
  x_bec9ee92: 'Save',
  x_fe56e486: '🤝 AI sends accounts to co-director',
  x_1c2e02ce: 'Not yet enabled',
  x_2b05c552: 'Co-owner:',
  x_e6f32bcc: 'Frequency:',
  x_7b03c3e6: 'Filter by (only report these):',
  x_2a0331b4: 'Last sent:',
  x_6b4a51fc: 'AI message',
  x_4c117f20: 'Order',
  x_28866da4: 'total dollars',
  x_de742acb: 'Filter USD',
  x_3d9ffcbf: 'Co-owner',
  x_c716dbd4: 'Activate',
  x_149265c0: 'Co-owner name',
  x_0d0635b6: 'Your WhatsApp (including country code, format 58XXXXXXXXXX)',
  x_ba2b6eee: 'Frequency',
  x_6d5a3b51: 'Automatically sent at 9:00 p.m.',
  x_3253cde4: 'Automatically issued on day 1',
  x_79218550: 'Report only these payment methods (empty = all, both bosses see the details of these methods)',
  x_a41cf705: 'Tone',
  x_b19cbde8: 'Send to me too',
  x_55aa6366: 'Successful update',
  x_e2f2ba57: '✅ Enable',
  x_0031dd8b: '⛔ Disable',
  x_8ff8cf44: '🗑 Recycle Bin',
  x_47508121: 'cap$',
  x_7acbbda8: 'Retail',
  x_79c4a31e: 'Wholesaler',
  x_f17d31b7: 'Wholesale customers (automatic wholesale price P2 + 0.5pt/$1)',
  x_4c998309: 'Print QR Card',
  x_5fa802be: 'Failed operation',
  x_2ffea779: 'Deactivate client',
  x_b2cdaef5: 'Re-enable the client',
  x_5c56a889: 'deactivate',
  x_7854b52a: 'enable',
  x_e5323bab: 'Move to recycle bin (recoverable)',
  x_45f778d7: '✏️ Edit client',
  x_95e5011c: 'Example: 05-14',
  x_3df74976: 'credit',
  x_dd694c71: '🏭 Wholesale',
  x_36cd3fdb: '🎂 Birthday (MM-DD or YYYY-MM-DD)',
  x_e8228d38: '📱 WhatsApp (if different from phone)',
  x_84a6c65b: '📨 Subscribe to WhatsApp notifications (e-receipts + birthday wishes + marketing)',
  x_766084e7: '🏭 Wholesale customers (low points)',
  x_6f76107e: '👤 For employee\'s own use (low points)',
  x_193fd90d: '🏭 Wholesale / 👤 Employees → According to wholesale point ratio (0.5 pt/$1); unchecked = retail (1 pt/$1)',
  x_2e0d8c60: 'Export error:',
  x_080e4cdb: '\\nUse the Print button to save as PDF.',
  x_617fe407: 'Please allow popups, then try again',
  x_8b05bd24: 'Print failed:',
  x_402193e1: '\\nUse the "Download PNG" button to save and print.',
  x_d2f8e650: 'print',
  x_20b916e7: 'Close',
  x_1f1edd2f: 'Theme:',
  x_2c3a24c3: 'Earn points and enjoy discounts',
  x_9954e58a: 'Scan me to check your points balance',
  x_27210b8c: '🎯 How does it work?',
  x_70e4ea74: 'Open your cell phone camera',
  x_f486f0e3: 'Scan this QR',
  x_7baa65a2: 'Enter your phone',
  x_b624f658: 'See your points!',
  x_dfdc6590: '💡 Suggestions for use',
  x_5df80e61: 'Download PNG → Print it and stick it on **checkout counter/store entrance/store wall**',
  x_106fdc25: 'Send this link to regular customers and let them save it - check points anytime',
  x_56f67f86: 'You can also print it on a small A4 poster and stick it on the wall.',
  x_5972e86f: 'Customers scan the QR code and enter their **mobile phone number** or **customer number** (such as C123456) to verify',
  x_049346a3: '🤖 AI Credits',
  x_fa6ec9d1: '💳Monthly SaaS rental',
  x_90b1c915: '👑 Single purchase',
  x_712596c1: '🛠 Annual maintenance fee',
  x_52e6abbe: 'Copied',
  x_86516aa6: 'Payment currency',
  x_c1e2c9b2: '⚠️ Sandbox mode',
  x_ed25395f: 'Live production mode',
  x_4f0bae34: 'Already received (USD)',
  x_aeb63c16: 'Total invoices',
  x_fad5222c: 'Completed',
  x_072ece17: 'Waiting for payment',
  x_28efb5bd: 'Crypto Income',
  x_694fc5ef: 'Update',
  x_c459d386: 'By Type',
  x_21efd88b: 'There is no data yet',
  x_d071be88: 'Recent Invoices',
  x_4787d633: 'tenant',
  x_226b0912: 'Type',
  x_f9b45f5c: 'Amount(USD)',
  x_def802c1: 'Received (USDT)',
  x_4572d0ec: 'There is no invoice yet',
  x_50de5a30: 'I\'m here',
  x_74d3ba48: '= the state is',
  x_1dea3af7: 'and',
  x_92a99777: 'total invoices',
  x_bfa852da: '💡 It will automatically go to NowPayments 5-15 minutes after the customer makes the payment → it will automatically transfer it to your TRON wallet',
  x_730aa550: '💡 If you want to see the specific details of each transaction, go directly to',
  x_351912e9: 'check',
  x_8c25dee1: 'vibrant orange',
  x_3c683341: 'ocean blue green',
  x_a45a3ac7: 'fresh green',
  x_46341dc6: 'elegant violet gold',
  x_e64084df: 'modern black gold',
  x_db29972a: 'Online store promotion QR code',
  x_32a67e3c: 'Generate beautiful posters, print them and post them in stores to attract customers to scan the QR code and place orders.',
  x_e414473c: 'Print',
  x_0657ba7c: 'Online store link',
  x_6a9e5785: 'door to door delivery',
  x_0060e3d3: 'Place an order at any time',
  x_f973aa04: 'Exclusive offers',
  x_7864d864: 'arrive quickly',
  x_68d89d0b: 'Complete range of products',
  x_ee79ba4c: 'Multiple payments',
  x_72f59366: 'No need to go out, good products will be delivered to your doorstep!',
  x_ccb69e71: 'First order discount for new customers + earn points when you place an order!',
  x_dd35f3aa: 'QZ Tray is a free local printing service. After installation, the website can send printing instructions directly to the printer.',
  x_227b88f4: 'Print dialog box does not appear',
  x_ee173ce8: 'Steps:',
  x_e1eb333e: 'Click to download:',
  x_ff7bbf67: 'Download Windows (.exe), install',
  x_a3c49496: 'Click "Next" during installation',
  x_e0e27701: 'The QZ icon will appear in the system tray',
  x_0671c916: 'Remove security window:',
  x_ea015cf2: 'If the "Untrusted Website" window appears every time you print the QZ tray, follow the steps below to install the certificate:',
  x_e43c62e9: 'Download the certificate:',
  x_d3f866d8: '2. Put the downloaded',
  x_0457c44a: 'Copy the file to:',
  x_be76a70e: '3. Right click on the QZ icon in the system tray → Select',
  x_84b2bd4a: 'enter',
  x_1094f3fa: 'Management Background → System Configuration → Printer Options',
  x_f643af46: ', fill in the printer name.',
  x_ce1cca4a: 'POS Printer',
  x_1708461e: 'Used to print daily sales receipts (fake receipts/internal receipts)',
  x_b627c3dc: 'Example:',
  x_1bd554fc: 'Fiscal Printer',
  x_6f3305bc: 'Used to print official tax invoices (genuine/original)',
  x_17f83847: 'How to find the name?',
  x_69c9ff65: 'Windows Settings → Devices → Printers and scanners',
  x_b769e4ff: 'Do you only have one printer? Simply fill in both names the same way.',
  x_49e382b0: 'Tax Invoice',
  x_53299d30: 'Enter the amount',
  x_23ad596c: 'Print on tax printer | The order appears in the report.',
  x_0597a697: 'Internal Receipt',
  x_748da81b: 'Print on POS printer | Hidden order in report',
  x_43f28ccd: 'Just Register',
  x_f523f020: 'Do not print | Hidden order in report',
  x_339fbb54: 'Q: Is a gray "QZ" button displayed at the bottom of the POS?',
  x_850263a4: 'A: QZ Tray is not running. Check if there is a QZ icon in the system tray. Otherwise, reopen the QZ tray.',
  x_3c7cc6d8: 'Q: Does the "Allow/Block" dialog appear?',
  x_a008acbd: 'A: Check "Remember this decision" and click "Allow", and it will no longer appear.',
  x_5c8ae7a8: 'Q: Can\'t find the printer?',
  x_ed2b395c: 'A: Make sure the printer name in settings is exactly the same as in Windows. Go to Windows Settings → Devices → Printers to view.',
  x_60ca8330: 'Q: How to configure only one printer?',
  x_4042778b: 'A: Fill in the same name for both POS printer and tax printer (for example, fill in XP-80C).',
  x_d1b45389: 'Q: Can I print without installing the QZ tray?',
  x_0a468501: 'A: Yes, but a browser dialog box will appear every time you print. With the QZ tray installed, printing is completely silent.',
  x_231206dd: 'box',
  x_f7edf5ac: 'pieces',
  x_d3bc58b6: 'exchange rate',
  x_93a17a92: '🧾 Order receipt',
  x_79730766: '💰 Claim notice',
  x_3b380a1e: '🎂Birthday wishes',
  x_4438a544: '📢 Promotional ads',
  x_1a6b4e12: '⚠️ Boss alert',
  x_88a1edb1: '💬 Customize',
  x_5e89ee46: 'Marked sent',
  x_02c1633a: 'skipped',
  x_f2b4dbf5: 'No customer points ≥100, no VIP yet',
  x_490b3a34: 'No customers have placed orders in the last 30 days.',
  x_0ea30aad: 'No client has a birthday today',
  x_79eb3367: 'There is no customer, or the customer has not filled in the phone number',
  x_bc21bd22: 'There are no clients under the condition.',
  x_cc989ba6: 'Export failed',
  x_e73fb531: 'Outbox',
  x_1ce32b39: 'No pending messages',
  x_218e94e7: 'Orders/credit/birthdays will appear here automatically',
  x_a9550e64: '🚀 How to use the exported CSV:',
  x_e75ae49a: '1. Download',
  x_82190c17: 'Official APP (free, does not require RIF)',
  x_976bdc5e: '2. Settings → Tools →',
  x_c32cb069: 'Broadcast list',
  x_4d238b59: '→ New',
  x_df804a38: '3. Import CSV via Google Contacts/iCloud (or add contacts manually)',
  x_df02ca90: '4. Send messages to the broadcast list - everyone gets an individual chat (not a group chat)',
  x_f4d94d4b: '⚠️ A single broadcast list can have up to 256 people; if you have many clients, you can export it multiple times in batches',
  x_1603b069: 'monday',
  x_b5a6a07e: 'tuesday',
  x_e60725e7: 'Wednesday',
  x_170fc8e2: 'Thursday',
  x_eb79cea6: 'friday',
  x_24575130: 'saturday',
  x_562d7476: 'sunday',
  x_2e5d828a: 'No appointments completed this month / No bookings completed this month',
  x_89a676e4: 'Change the % and save automatically. Only appointments marked as completed count. / The modified percentage is saved automatically and only "full" reservations are counted',
  x_685f370b: '📴 Offline: The delivery order has been saved and will be automatically uploaded online.',
  x_d0c68f0b: '📴 Offline: The receipt has been recorded and will be automatically stored online.',
  x_93c4b017: 'Purchase order deleted',
  x_41722aa3: 'The purchase order has been archived and hidden',
  x_dbc210d6: 'Please fill in the code and name',
  x_a889286a: 'Creation failed',
  x_535bef11: 'The categories have been updated.',
  x_930442e2: 'Update failed',
  x_44e7120c: 'Hide completed',
  x_9779a11a: 'Show completed',
  x_1a750305: 'All categories',
  x_37c419ae: 'Attach barcode',
  x_f2996845: 'unit',
  x_ea887bd0: 'Specifications',
  x_c5855564: 'pricing',
  x_d0e857e9: 'Profit rate formula',
  x_cb340191: 'benefit',
  x_c6e41d42: 'FCL price',
  x_d4229e8a: 'Cash regulations',
  x_51829073: 'beginning inventory',
  x_a45686c0: 'Stock alert',
  x_dce5379c: 'hide',
  x_2f4aaddd: 'Delete',
  x_ecf7ebb5: 'Uncategorized',
  x_8ec0438a: 'Payment history',
  x_bce9f7d6: 'Add products quickly (purchases and storage)',
  x_625fb26b: 'Cancel',
  x_730bfc36: 'paid in full',
  x_8ec00711: 'The purchase order has been paid in full!',
  x_9698ab8c: 'Please choose how to process this purchase order:',
  x_83ef2b4d: 'Cash',
  x_90f94c19: 'Card',
  x_f1a5d025: 'Transfer',
  x_2fc44ed8: 'Credit',
  x_4fa3a2eb: 'The referral code has been generated.',
  x_7f7de8a2: 'Compilation error',
  x_10173e90: 'Reference code copied',
  x_a95b0fa6: 'Copied registration link',
  x_fe32def4: 'active',
  x_69b0f684: 'Disabled',
  x_5947a2a4: 'Referral Rewards',
  x_62ea3c2c: 'Politely recommended',
  x_838b386f: '1. Share the referral code',
  x_d6ade6c8: 'Share your unique referral code with other merchants',
  x_07cff2ae: '2. Friends registration',
  x_af47e408: 'Friends use referral code to sign up for a 44-day trial',
  x_6019e1c3: '3. Both parties win prizes',
  x_a250368b: 'You also get a free 30-day extension',
  x_c6c4ba10: 'You don\'t have a referral code yet, click to generate one',
  x_83e0c4f0: 'My referral code',
  x_6e1519ad: 'Number of people who have been recommended',
  x_2964d77d: 'Number of days to receive the bonus',
  x_f3ce8bc2: 'Recommended records',
  x_23733df5: 'There is no record of sales in the last 30 days and it cannot be calculated automatically.',
  x_0b1cc5f0: 'The calculation failed',
  x_0d667672: 'Calculating...',
  x_0868b4ed: 'Automatically set minimum inventory',
  x_88b16782: 'Failed repair',
  x_e596edd9: 'Applying...',
  x_5921137f: 'Automatically calculated results (based on last 30 days of sales + 7 days of safety stock)',
  x_b409f53c: 'Inventory and comparison',
  x_e7c0908c: 'cash',
  x_c31eabb4: 'magnetic card',
  x_acaf665f: 'transfer',
  x_2432b575: 'Observations',
  x_cd1cff20: 'Total sales (gross)',
  x_6b587c75: 'Reconcile this change (recalculate order library total)?',
  x_a8336884: 'Are classes required to end at the same time?',
  x_f0407e01: '✅ Reconciled',
  x_769a6bb0: '🔧Reconcile (from order database)',
  x_d342fac8: 'Reprint the report',
  x_a6240224: 'Employee performance details',
  x_a235c0c8: 'Grouping of RFM clients + group sending in one click of WhatsApp',
  x_0cd126ef: 'WhatsApp Web is not connected. Go to “📱 WhatsApp connects automatically” to scan the QR before transmitting.',
  x_1e664d6e: 'Click Group to quickly select all customers in the group → Pre-populate promotional copy with one click',
  x_c7b27363: 'whatsapp group messages',
  x_792f9eb2: '✨Generation of copywriting with AI (GPT-5.2)',
  x_1aa19423: 'Automatically write 3 WhatsApp texts based on your industry + selected segment + customer purchasing behavior',
  x_e4234194: 'Optional: Mother\'s Day Promotion / News / Weekend Specials...',
  x_4dfe7036: 'generate',
  x_48853792: 'Data seen by AI',
  x_baea39ef: 'per capita consumption',
  x_de4db8d2: 'Visits per capita',
  x_b6838383: 'rent',
  x_0ee0c81c: 'Water and electricity',
  x_be11fc04: 'salary',
  x_1f4beff9: 'Consumables',
  x_324712a3: 'Repair',
  x_0f3a252a: 'transportation',
  x_638e3280: 'taxes',
  x_0d98c747: 'Others',
  x_d594b77a: 'Please enter the amount',
  x_3fdaeadf: 'Successfully added',
  x_0719d4e5: 'Are you sure to delete?',
  x_3fef31de: 'expense management',
  x_e5d6c826: 'new expenses',
  x_07d77a1b: 'total expenses',
  x_3d2a964f: 'Number of pens',
  x_6b63c89c: 'Expenses of each store',
  x_3bdd08ad: 'Description',
  x_f9ac4b2a: 'operator',
  x_86c5708d: 'Select store',
  x_16a097d2: 'Water bills, electricity bills, logistics expenses, etc.',
  x_de5f6c72: 'equivalent',
  x_1e49734c: 'actual receipt',
  x_1993ed26: 'Summary',
  x_78d078e8: 'expenses',
  x_80170f62: 'net profit',
  x_e9caa1e9: 'Immediately scan all tenants for product, stock vs. inventory, quantity deviations and automatically correct them? \\n\\nAudit inventory bypass and self-heal?',
  x_3859c850: 'Zero inventory variance – everything aligns ✓',
  x_e6c2d5d3: 'Scanning...',
  x_8f7072ac: 'inventory audit',
  x_66411a09: 'test message',
  x_6e4f4b33: 'Please enter the mobile phone number',
  x_12020cd0: '✅ Enabled: Customers will automatically receive a WhatsApp receipt after placing an order',
  x_ad859563: '⏸ Auto receipt is disabled',
  x_1668b5ee: '⏸ Automatic claim has been disabled',
  x_f562ea82: 'Select the default store first',
  x_9f276dd7: '✅ Enabled: When customers send payment screenshots to your WhatsApp, the order will be automatically recognized and compared.',
  x_08f2f5b8: '⏸ Automatic cancellation is disabled',
  x_207fff73: 'Are you sure you want to log out of WhatsApp? After you log out, you need to scan the QR code to log in again.',
  x_a58b3a30: 'I logged out, waiting for a new QR code...',
  x_3d7c933b: 'Logout error',
  x_c5ea9c6a: 'Connected',
  x_9fde5e83: 'Waiting for scan',
  x_61536d6b: 'Certification in process...',
  x_7f3a55b2: 'Not connected',
  x_4c7bf874: 'Conflict (log in from another device)',
  x_fbecd9e3: 'service exception',
  x_e12b354d: 'ON',
  x_3b6ed28d: 'Close OFF',
  x_be5fbbe3: 'save',
  x_7657f76c: 'your number',
  x_65026c6a: 'Connection status:',
  x_9db7a84f: 'Already on',
  x_d4909dab: 'received automatically',
  x_5d855937: 'expired',
  x_0d041ace: 'Expires in 3 days',
  x_0e4b660d: 'The minimum interval between two reminders for the same customer:',
  x_30b38123: 'Sent to your WhatsApp number',
  x_6134f524: 'automatic matching',
  x_f3a2348c: 'Guests do not need to open the website or scan the QR code, just like sending a message on WeChat.',
  x_12e45b5a: 'Default property store:',
  x_f26bedc7: '(without store)',
  x_abfc9ba9: 'Close first before changing stores.',
  x_c363b9ec: 'Scan the QR code to connect to your WhatsApp',
  x_dfaf8682: 'Open WhatsApp on your phone',
  x_3fafc6fe: 'Menu →',
  x_4a4c2cf7: 'Linked devices',
  x_a7ad104b: 'link device',
  x_e0290bd7: 'Scan the QR code below with your camera',
  x_6d81d254: 'Wait 5 to 10 seconds until "Connected" appears.',
  x_0d280386: 'Waiting for the QR code to be generated...',
  x_008fe1ba: 'It usually takes between 10 and 20 seconds',
  x_b8a25309: 'Connected successfully ✅',
  x_b71dbebc: '📤 Test shipping',
  x_565ea0b6: 'Recipient number (E.164 format)',
  x_b87b7756: 'Message content',
  x_eb0bd897: '💡 Usage tips',
  x_0fb5c8cf: 'This connection is',
  x_01e161e9: 'free',
  x_22d65176: ', does not consume Twilio credit',
  x_d01f9a4f: 'Send a message to any client',
  x_52c58309: 'No need to join',
  x_332247f3: ', just like WeChat group sending',
  x_83320746: 'You don\'t need to keep WhatsApp open on your phone, VPS keeps you logged in automatically',
  x_fcf8348a: 'If it says "conflict", you are using WhatsApp Web elsewhere; just log out of the other device',
  x_0f4dfafd: 'In case you log out, simply return to this page and scan the code again (1 minute)',
  x_f27d2855: '👉Cut up',
  x_167fc20b: '"🎂Festival/Birthday Marketing"',
  x_525ce8d5: 'Tags, you can send holiday/birthday group messages to WhatsApp with one click, AI automatically writes a copy',
  x_4fe8cddc: 'Set unlimited stores',
  x_7b9796b4: 'The diagnosis failed:',
  x_c1e4fc86: 'Repair completed',
  x_24c6a887: 'Failed repair:',
  x_105c8a51: 'Successful export',
  x_dd51ab50: 'Export failed',
  x_80070ef8: 'No store limit',
  x_104faff3: 'Store limit',
  x_7fa365e7: 'Diagnosis/Repair',
  x_9344b89b: 'Export backup',
  x_0719aa2b: 'reset password',
  x_bdd21b3d: 'Change ID',
  x_9171e387: 'Custom quantity (leave blank = no limit)',
  x_a94b953e: '→ Create tables automatically, enable kitchen ticketing, service scenario tags and a 10% service fee',
  x_1b89e094: '→ Open the number for meal pickup, issuance of kitchen tickets and self-service orders',
  x_5d960ff3: '→ Enable size × color variants, seasonal tags, automatic wholesale and retail price reduction',
  x_3fc4b6fb: '→ Enable lot number and expiration date management',
  x_db15472a: '→ Start bulk sales/weighing and full cases',
  x_609adbd2: '→ General retail (no industry-specific roles)',
  x_72d55e89: 'Enter a new password',
  x_fbc026c9: 'health',
  x_fe3d61c1: 'with warning',
  x_ab9512ba: 'There is a serious problem',
  x_e2e27a87: 'serious',
  x_900c70fa: 'warning',
  x_8f3d0f51: 'Are you sure you want to delete all orders? This action is irreversible!',
  x_b97b6c51: 'Set the maximum number of stores this merchant can open based on the package (corresponding price: 1 store $50 / 2 stores $80 / 3 stores $110 / 5 stores $160 / 8 stores $230). Leave blank = no limit.',
  x_8441b348: 'No limit',
  x_6258bb14: '— Automatically initialize industry ranking + features',
  x_9e0124e8: 'General Retail',
  x_8bc59f0c: '🍽️ Restaurant (table + kitchen screen + service charge)',
  x_2306dfd6: '🍔 Fast food / Fast food (order number + kitchen screen)',
  x_03d614a2: '👕 Clothing / Clothing store (size × color + season + wholesale)',
  x_9357f511: '💊 Pharmacy/Pharmacy (batch number + expiration management)',
  x_ef343e19: '🥕 Supermarket/Supermarket (bulk + weighing)',
  x_e44ccd80: 'Bakery',
  x_1464330c: 'hardware store',
  x_08460537: '📱 Electronics / Electronics (serial number)',
  x_eebcf410: '💄Beauty/Beauty (quote)',
  x_89d569a1: 'Reset merchant password',
  x_0644dad5: 'Enter your username and new password. If the user does not exist, the system will create it automatically.',
  x_bf7da0bf: 'new password',
  x_80cfc33c: 'Confirm reboot',
  x_316a4683: 'Diagnostic and repair shop.',
  x_44d50e5a: 'Diagnosing...',
  x_a519dc2a: 'Problems encountered',
  x_95ab9037: 'repair operation',
  x_bab268d5: 'supplier',
  x_e54ee345: 'Overdue!',
  x_edae78fd: 'loan',
  x_c3704da5: 'Goods Credit',
  x_ebe86a1f: 'Repayment',
  x_03531769: 'Salary Deduction',
  x_756048fc: 'Employee statement',
  x_4cf24aba: 'Quantity',
  x_5a4fcfe2: 'Current amount owed',
  x_90ea8d11: 'employee credit',
  x_5a611987: 'Unassigned store',
  x_ad83f8e5: 'total amount owed',
  x_bd3616ee: 'Receipt + QR',
  x_2dbf283b: 'Account statement',
  x_bbdd42a0: 'settled',
  x_ea340b7c: 'borrow money',
  x_3f01df5b: 'goods on credit',
  x_620610c0: 'has been returned',
  x_8577b01a: 'Deposit withdrawal',
  x_44ba3fed: 'Could not extract',
  x_7b1df363: 'Currently there is no record of employee debts.',
  x_4c95bf44: 'refund',
  x_79ef16e5: 'payroll deductions',
  x_006deeed: 'POS Credit',
  x_d2f88894: 'Acquisitions',
  x_e6119529: 'Payment Receipt + QR',
  x_ef9ec7c0: 'Contact Support',
  x_acf0664a: 'Delete error',
  x_ec25deba: 'Error while deleting',
  x_a2339865: 'Now the main warehouse.',
  x_5154ae17: 'Failed copy',
  x_d6fecfb2: 'Please enter a valid amount',
  x_956ef5ad: 'Approved / Approved',
  x_786c8fe1: 'Rejected / Rejected',
  x_7e237e94: 'cost',
  x_4eb4b061: 'Copy from main repository',
  x_b6eea70f: 'Failed to load tiers',
  x_81bbad14: 'Cost not established',
  x_901a44b7: 'Not established',
  x_55fadf3b: 'unit cost',
  x_7e0457bb: 'Settings saved',
  x_c330679b: 'The threshold is too high and the test does not activate (the current threshold',
  x_82b783f0: 'ignored',
  x_d06adee8: 'Exchange rate fluctuation warning',
  x_46d3ff51: 'Alert Settings',
  x_5659fd6c: 'Enable FX alerts',
  x_839db71f: '— activates when this percentage is exceeded',
  x_3a62401d: 'Recommended 5% (regular daily BCV fluctuations are 1-3%, exceeding 5% is abnormal)',
  x_4ab817d3: '—With country code, without +',
  x_eae0f4d8: 'Number automatically configured with Boss PIN when empty',
  x_0468089c: 'Alert History',
  x_317dbe0f: 'Don\'t alert yet',
  x_c4677828: 'time',
  x_8bd0b918: 'Source',
  x_609a902e: 'old → new',
  x_34d0195a: 'change',
  x_41dfb0bf: 'Reason',
  x_6ef780bf: 'damaged',
  x_584cd195: 'Expired',
  x_a6a652d7: 'personal use',
  x_42e0c46b: 'sample',
  x_fe299b11: 'Classification report/exchange rate analysis',
  x_1e355e1f: 'black market',
  x_800dfdd9: 'today',
  x_72520580: 'this week',
  x_0ec94a37: 'this month',
  x_c5d35890: 'last month',
  x_6da06b0c: 'All stores',
  x_bee912d7: 'Consultation',
  x_72d76618: 'Exchange rate:',
  x_4cbae8f6: 'total sales',
  x_9719978c: 'cost of goods',
  x_bae6c9ba: 'gross profit',
  x_7bfa923d: 'daily expenses',
  x_cea67413: 'Reported damage/loss',
  x_29225555: 'Exchange gains',
  x_33fa2d30: 'Accounts receivable from employees',
  x_4fbe97e5: 'To be removed',
  x_fbb493d0: 'Number of orders',
  x_eee785b1: 'Get products at the government exchange rate',
  x_9ae44464: 'sales',
  x_f5acfdc9: 'Black market goods',
  x_bc41ea8b: 'Statistics by category',
  x_bfec3534: 'Pricing model',
  x_27a504ee: 'Sales ($)',
  x_2d4ec760: 'Sales (Bs)',
  x_eae13adc: 'Cost ($)',
  x_e052f520: 'Profit ($)',
  x_7a3da957: 'profit margin',
  x_e4f48bf4: 'number of pieces',
  x_dda07873: 'Expense details',
  x_030808e9: 'Damage/Loss Report Details',
  x_65cccb1c: 'Exchange Income Details',
  x_ac502247: 'Buy USD in cash',
  x_2feedc17: 'Swipe card to get cash',
  x_0d91478b: 'Statistics per day',
  x_d6ddd835: 'Batch/Lot Tracking (FIFO)',
  x_e06e4a15: 'Add new batch',
  x_a6eefa41: 'Recover traceability',
  x_f7414a41: 'Preparing',
  x_a2d94b67: 'Ready',
  x_362f791f: 'Error',
  x_a7cf3c19: 'New',
  x_641fb174: 'Get started',
  x_6062f967: 'Ready',
  x_c7664439: 'Lists',
  x_d9d86061: 'rollback',
  x_4f5b356a: 'Kitchen Display',
  x_f05d50fe: 'No orders',
  x_ebedad8a: 'Waiting for POS orders...',
  x_8f9d8f83: 'Account/Email (PayPal/Wise/Zelle)',
  x_6ee9e469: 'Wallet Address (USDT/BTC/ETH)',
  x_6a069dc9: 'Revolut)',
  x_436d77df: 'Binance Pay)',
  x_03c32ab3: 'Bank account number (bank transfer)',
  x_f8dfedcd: 'bran',
  x_a9ca9fd6: '+58 424-8476761 (中文/Spanish/English)',
  x_274c1e1b: 'TU_USDT_TRC20_HERE (placeholder)',
  x_ed7823b1: '+ add',
  x_ac92f4c5: 'Name (e.g. Wise/Zelle/Binance Pay)',
  x_76254a13: 'Account/address/link (such as your-wise@email.com)',
  x_61860e54: 'Payment instructions to clients (optional)',
  x_908a649e: 'Example: After payment, take a screenshot and send it to WhatsApp customer service. We will activate your Sellox account and send you your login credentials within 30 minutes.',
  x_921915b6: 'Save all settings',
  x_fb4ca1cf: 'Loading…',
  x_f19e59a5: '🌍 Setting up international payments (cross-border collection)',
  x_4290f0a0: 'Set the payment method for foreign customers (South Africa/Brazil/Colombia and 7 other countries) to pay $199/$499/$999. The information will be displayed in the "Buy" popup on the home page.',
  x_8009051e: 'Enable international payments',
  x_e90bdf1a: 'After closing, the Buy button on the home page only shows customer service WhatsApp.',
  x_17fb55f0: 'WhatsApp number (with country code, without +)',
  x_45ffbd9d: 'Example: 5804248476761 (Venezuela)',
  x_f3864065: 'Show label (optional)',
  x_d04bbc0e: 'PayPal email',
  x_0fed3f6b: 'paypal.me link (recommended: one-click payment for customers)',
  x_0b36d1a2: 'TRC20 (Tron): management fee ≈ $1, recommended ⭐',
  x_67ebc935: 'ERC20 (Ethereum): $5-$20 management fee',
  x_51e8a79c: 'BEP20 (Binance Smart Chain): fee <$1',
  x_e71d5f47: 'Not added yet. Click "+Add" in the upper right corner to add any payment method (Wise/Revolut/Zelle/Binance Pay/Pix/Western Union, etc.)',
  x_0380d11f: '💰 Package price (USD)',
  x_dcf9f3db: 'One-time purchase in USD',
  x_92d28a70: '📝 Payment instructions to clients (optional)',
  x_37ef8c61: 'paypal registration',
  x_a094a4a9: '(Personal account can collect payment)',
  x_9b3c8bf1: 'paypal.me created',
  x_d149282b: 'USDT TRC20 Wallet (Recommended)',
  x_b9f4d9f0: 'Wise (cross-border remittances)',
  x_42c062bf: '🛒 Ordinary store',
  x_b0c7322a: 'General retail trade such as grocery stores, hardware stores, convenience stores, stationery stores, cosmetics stores, etc. There are no pre-established categories, create your own according to your needs.',
  x_e69533ce: '✓ Double currency (USD + Bs)',
  x_5c26623b: '✓Multiple stores',
  x_348c3c42: '✓ Online store publication',
  x_c971b497: '✓ Suitable for 90% of ordinary businesses',
  x_d5ebb7de: '🍽️ Restaurant',
  x_c85301d4: 'Tea restaurants, fast food, barbecues, cafes, bars, etc. Create menu categories, table placements, and kitchen orders with just one click.',
  x_74efa0b8: '✓ 7 automatically created menu categories',
  x_03fb8ea8: '✓ 10 tables available immediately',
  x_01cdb4fc: '✓ Automatically place orders in the kitchen',
  x_05474198: '✓ Service fee 10%',
  x_6229e580: '👕 Clothing store',
  x_66682a68: 'Clothing, shoes and hats, children\'s clothing, accessories. Each garment may have size (S/M/L/XL) × color (red/blue/black) and multiple variations in stock.',
  x_57dd3ef7: '✓ 8 clothing categories',
  x_2b54dfae: '✓ Size + Color Variations',
  x_7d9f9b66: '✓ Seasonal labels',
  x_72c05d38: '✓ Double wholesale and retail price',
  x_f9003331: 'Already in this industry',
  x_acd5cb84: 'failed',
  x_66342ccc: '✓ Current industry',
  x_3f86ef3c: 'Apply this template',
  x_e2662ca4: 'Service',
  x_8da5aff6: '✅ Saved: POS payment will work immediately',
  x_cea028d0: 'Industry template',
  x_cd790081: 'Define your store type with a single click: categories, tables and variations, all at once',
  x_a22b06e7: 'Tips:',
  x_605629af: 'ordinary store',
  x_686dbf3b: 'Service charge/tip (Service)',
  x_3b858549: 'Service fee enabled by default',
  x_2420b778: 'Service fee percentage (%)',
  x_f0d6cce2: 'The name that appears on the receipt.',
  x_0bfa1205: '🛵 rider',
  x_00a0e92f: '⚙️ Rate configuration',
  x_6af35899: '📦 Delivery order',
  x_696bc73f: '✅ Approved, passengers can now accept orders',
  x_28687aeb: 'Are you sure you want to reject this rider? If it is rejected, you will not be able to accept the order.',
  x_81233d75: 'Rejected',
  x_3bddf714: 'Suspend this cyclist? Could not accept new orders after suspension.',
  x_a2d930fd: 'suspended',
  x_30a59161: '✅ Restored and can accept orders.',
  x_a431ba4e: 'Search by name/phone',
  x_75eb29d6: '🛵 Motorcycle',
  x_f534abbc: '🚲 Bicycle',
  x_b590db5d: '🚗 car',
  x_56d6a939: '🚶 walking',
  x_5c2ee4b5: '📍 Getting location...',
  x_88a5387f: '✅ The current location has been obtained as store coordinates.',
  x_1b925959: 'Can\'t get location, enter it manually',
  x_77322d90: '✅ Saved settings',
  x_6620698d: 'Grab order group',
  x_68905cf3: 'online',
  x_cb2806df: '⏳ Pending orders',
  x_fc6e17a5: '🛵 Received',
  x_107d8896: '📦 Picked up',
  x_e0ae219c: '🚀 Delivering',
  x_16661b98: '✓ Delivered',
  x_9d77d772: 'Delivery man management',
  x_bce11e3f: 'Delivery Drivers · Review passengers / set rates / monitor orders',
  x_c612876e: 'There are no registered runners yet',
  x_a37a9be7: 'put',
  x_25e4e975: 'Send the link to your users and ask them to register with the store code.',
  x_809476e2: 'Share with cyclists:',
  x_6cab0af7: 'Delivery rate',
  x_14289a36: 'Initial fee (USD)',
  x_7de56a40: 'Price increase per kilometer (USD)',
  x_b25f1d80: 'Farthest delivery distance (km)',
  x_73bb91d6: 'Store location (used to calculate distance)',
  x_039e0dfc: 'Latitude Latitude',
  x_05e720b2: 'length length',
  x_3fd0fc33: 'Store address (displayed to passengers)',
  x_fa8ee2c3: 'Auto-assignment',
  x_28b2a26f: 'Automatically assigned to the nearest online passenger',
  x_f2418716: 'Distance × 50 - Number of orders × 30',
  x_58714e73: 'There are no orders yet',
  x_86ce4ab5: 'Rider:',
  x_9f911a7c: 'No order has been accepted yet',
  x_188bff11: '🔴 Expired',
  x_6314a940: '🟠Within 7 days',
  x_fc95d888: '🟡Within 30 days',
  x_3aae3aea: '🆓 Try it',
  x_d7bfdc78: '🟢 Health',
  x_d94c64e8: '👑 The purchase is permanent',
  x_4a5421bb: '❔ No expiration date',
  x_32137a91: 'The AI generation failed',
  x_3b5acbf9: 'The message cannot be empty',
  x_1a70e8dc: 'Joined Outbox + Open WhatsApp',
  x_4d5ccd01: 'Expired',
  x_d3cf0210: 'Expires in 7 days',
  x_56ee9094: 'Expires in 30 days',
  x_cda88e69: 'permanent purchase',
  x_1a5e9603: '😊 Friendly',
  x_489fd45e: '⏰ urgent',
  x_c6863be8: '💎Upgrade purchase',
  x_0e223ebb: 'Not completed',
  x_05e9dc7b: 'Send WhatsApp',
  x_de815854: 'Tenant Subscription/Renewal Dashboard',
  x_ecb48dd6: '🤖 AI smart reminder',
  x_ee3f5585: 'country',
  x_927babb3: 'Remaining days',
  x_fd5561f7: 'final payment',
  x_a522f3ba: 'There are currently no tenants in this category.',
  x_46ca8fe7: 'no phone',
  x_59cf15fe: 'Template',
  x_0f0c4077: '😊 Rewrite (friendly)',
  x_849ced1d: '⏰ Rewrite (urgent)',
  x_28e51c71: '💎 Rewrite (update)',
  x_6b2b61c1: 'When you click "Send WhatsApp", it will automatically join the Outbox and open the WhatsApp web/app at the same time. You just need to click ➤ Send Arrow.',
  x_8fe83636: 'Please enter the reception phone number',
  x_b8c17683: 'Meta is blocked and has been added to the wa.me queue.',
  x_8384ee76: 'Sent via Meta API',
  x_e98c5780: 'Configuration',
  x_e1c652bc: 'Test shipment',
  x_8b608503: 'What is the profit today?',
  x_780a3ce3: 'Copied from Meta WhatsApp settings page',
  x_dfc26b0a: 'If you need to update, paste the new token',
  x_14ae8f5b: 'Generated from metasystem user',
  x_4323be72: 'Save settings',
  x_1b709fcc: 'Receive calls +584...',
  x_ff6d830a: 'Send test message',
  x_1c00c645: '💡 It takes between 15 and 20 minutes. Set it up once and you\'ll never have to worry about it again.',
  x_5a3044a7: 'All steps are free unless WhatsApp business messages exceed the free Meta limit.',
  x_d9917a0f: 'Step 1 / Step 1: Create a meta developer account',
  x_18305c0e: 'Open:',
  x_f9056348: 'Log in with your Facebook/WhatsApp account',
  x_7d427d3d: 'Click on the top right corner',
  x_9c11804f: 'start/begin',
  x_a3c972b7: '→ Follow the instructions to complete registration (free)',
  x_63d5e90b: 'Step 2 / Step 2: Create a business account',
  x_be604f8b: 'point',
  x_86165c96: 'Create Business',
  x_34bc86ed: '→ Fill in the store name, your name and email address',
  x_ff5d264e: 'Step 3 / Step 3: Create the WhatsApp Business application',
  x_b140dd92: 'go back to',
  x_abb2b8f6: 'Create application / Create application',
  x_e90efab1: 'Use case option',
  x_7d394eff: 'other / other',
  x_9c2b1541: '→ Type selection',
  x_eaa0a8e3: 'Business/Business',
  x_36a6d4b9: 'Link to the business account created in the previous step → Create',
  x_de9dda75: 'Enter the Application Panel → Search in the left menu',
  x_2ac93ee6: '→ point',
  x_700677b3: 'Install/configure',
  x_ca3908a1: 'Step 4 / Step 4: Get Phone Number ID + Temporary Token',
  x_2fcc28b3: 'Enter WhatsApp → click on the left',
  x_b1d07643: 'API Setup',
  x_593a1499: 'At the top of the page you will see',
  x_542bd2bd: '(starting with `EAA...`) → Copy',
  x_0c4c68c7: 'You will see in the middle',
  x_2868963d: 'Telephone number ID/phone number',
  x_1ff9d199: '(a string of numbers) → copy',
  x_9a3f0a43: '⚠️ The temporary token only lasts for 24 hours and will be used as a permanent token for the system user later (see next step).',
  x_1743a4bd: 'Step 5 / Step 5: Permanent Token (recommended)',
  x_d7098f50: 'open',
  x_5b1bc0f8: 'add/add',
  x_04bb0f86: '→ Name "Sellox Bot" → Character selection',
  x_7635736a: 'Enter the system user → click',
  x_6effb00e: 'Add assets / Add assets',
  x_0c143e9a: '☑ Applications → Hook Application →',
  x_d0a5ba88: '☑ WhatsApp accounts → WABA hook →',
  x_609f8cf0: 'Generate new token / Generate new token',
  x_373a96ca: '→ Select application →',
  x_be153369: 'Generate →',
  x_d600945c: 'Copy now',
  x_e9b20985: '(You can\'t see it if you close the window)',
  x_eeb6320c: 'Step 6 / Step 6: Set up Webhook (so Meta can send us messages)',
  x_9ce48b57: 'Configuration"',
  x_99539f07: 'Meta settings page',
  x_4d572586: 'Edit / edit',
  x_bdc858dc: 'Paste the two values above',
  x_fae01bc0: 'Check and save / Check and save',
  x_7701988b: '→ A green check appears ✅',
  x_c348bfce: 'Webhook fields below →',
  x_bc2153d1: '→ Subscribe',
  x_ab20cc42: 'and',
  x_8f2b0cd1: 'Step 7 / Step 7: Complete the Sellox backend (this is the page below)',
  x_5ce0ecbc: 'down',
  x_95805797: '② Your WhatsApp Business credentials',
  x_87bff178: 'Permanent access token (or temporary token)',
  x_c4d93fb8: 'Telephone number (optional)',
  x_c8c135f6: 'Boss mobile phone whitelist (+584xxxxxxxxxx format)',
  x_142f5856: 'hook',
  x_97c38974: 'Step 8 / Step 8: Test',
  x_eb2ec6d7: 'After saving, the following will appear',
  x_f94ea898: '"Test shipment"',
  x_d87f215d: 'card',
  x_742be581: 'Enter your boss\'s mobile phone number and try to send a message.',
  x_4ee03501: 'After receiving it, answer "What is the profit today?" on WhatsApp → AI will respond with real data 🎉',
  x_7d5267db: '⚠️ Test number limit',
  x_7509351d: 'Meta-free trial numbers (+1 555 662 4521) can only be issued to a maximum of 5 manually verified recipients. To send it to anyone, you need to add your business number in Meta (business verification will take a few days).',
  x_20c5cf28: '💬Do you have any problem?',
  x_fd4d3093: 'Contact your platform administrator to help you set up your platform, or click the AI wizard in the lower right corner to request specific steps.',
  x_3f58e45d: '① Meta Webhook Settings (fill in the Meta App panel)',
  x_d025f0d5: 'Subscription fields:',
  x_01f35594: 'Telephone number (E.164)',
  x_60eae7be: '(saved, not shown)',
  x_372c24bf: 'Boss mobile phone whitelist (separated by half-width commas, multiple)',
  x_bb28c476: 'Only with whitelisted mobile numbers will the AI respond to business data (profits, inventory, debt, etc.)',
  x_01b59ca9: '③ AI behavior',
  x_e6a08432: 'AI mode',
  x_639ebc3f: 'Only the boss - only the whitelist can chat, others will not respond',
  x_31d7946b: 'Customers only: Customers check products, but boss can still request data',
  x_4ea5a5ee: 'Both: customers check products, bosses check data',
  x_20339501: 'Automatically send an electronic receipt to the customer\'s WhatsApp after each payment.',
  x_f679838d: 'The customer\'s profile has "📨 Subscribe to WhatsApp notifications" checked',
  x_f4cfb985: 'That is, each client can individually choose whether they wish to receive',
  x_185c0503: 'Please select a client',
  x_dd2124ee: 'Please add product',
  x_9923d1e2: 'Order opened successfully',
  x_21263321: 'Wholesale billing',
  x_d166bb06: 'Headquarters',
  x_abfecaae: 'add client',
  x_c6403f20: 'Fee',
  x_ec3fb565: 'Select client',
  x_b042c052: 'Search product (name/barcode)...',
  x_57c89bca: 'Find items and add them to the order',
  x_fedff361: 'Order Summary',
  x_0367ebd1: 'Observations...',
  x_e7814437: 'Confirm billing',
  x_0706515e: 'Add clients quickly',
  x_18401477: 'Credit limit ($)',
  x_a48948bf: 'All stores',
  x_be3565c4: 'Reference number match',
  x_a0e50b0e: 'order matching',
  x_c95d6f32: 'quantity equalization',
  x_1622dc9b: 'unknown',
  x_ed0ad119: 'Daily reconciliation report',
  x_8e600fc0: 'paired',
  x_8567bca1: 'No matching verification',
  x_728bf491: 'Unmatched sales',
  x_1e8dc255: 'Order number',
  x_ca2944f0: 'amount of AI',
  x_093c45aa: 'sales amount',
  x_5c4caeaf: 'Reference number',
  x_f3d55d6b: 'sender',
  x_f14b4f28: 'bank',
  x_d47a0207: 'Daily automatic reconciliation',
  x_6ea41b97: 'AI Verification Record Versus E-Payment Sales – Automatic Match Verification',
  x_dd09a5da: 'Total number of AI verifications',
  x_193911c6: 'No corresponding sales order was found in these AI verification records. It may be that the customer has uploaded it but the cashier has not confirmed it.',
  x_396a3453: 'No corresponding AI verification was found for these e-payment sales. The customer may not have uploaded payment screenshots.',
  x_d4c1ecd7: 'They all agree! All electronic payments for the day have been verified.',
  x_82e96463: 'Inventory must be a number ≥ 0',
  x_6e5907ee: '🔄 Update',
  x_1db180af: 'Search product / color / size / SKU',
  x_105b1395: 'Stock ≤5',
  x_b12876c8: 'Out of stock',
  x_ad9238d4: 'No products with sizes',
  x_36094e1c: 'No matches',
  x_afcc3e34: '💾 Save',
  x_5c94144d: 'Total Variant SKU',
  x_0e076143: 'Product',
  x_f1daf080: 'Size',
  x_6b36c6f7: 'Color',
  x_dd56adce: 'Are you sure you want to automatically create/associate customer profiles for all employees? \\nThis way you can accumulate points by making credit or spending.',
  x_f10dfc69: 'Automatically registers all employees as \'customers\' (is_staff=true) so they can accumulate points when making loans or purchases.',
  x_f33656e1: 'ID card',
  x_881a9bd5: 'Identification number (Cedula)',
  x_69b8571e: 'Salary ($)',
  x_b5ca1dd9: 'payment cycle',
  x_09b03b6d: 'weekly',
  x_9104c0c5: 'every two weeks',
  x_aa3d57c0: 'monthly',
  x_72b3c2be: 'IP whitelist (leave blank = no restrictions)',
  x_ba15d1d2: 'Example: 190.205.1.100, 200.44.32.50',
  x_9cf8e8f2: 'Separate multiple IPs with commas. Administrators and directors are exempt from this restriction.',
  x_e6d7c138: 'Login time allowed (leave blank = no limit)',
  x_d18b4c06: 'Venezuela time (UTC-4). Example: 07:00 ~ 22:00',
  x_3eb2b5e8: 'It cannot be less than the cost price.',
  x_6bde6f81: 'The price after the discount cannot be lower than the cost price.',
  x_a6f3ec47: 'Online Store AI Customer Service',
  x_e7454268: 'AI boss counting',
  x_10f8a322: 'whatsapp message',
  x_bb364b6d: 'WhatsApp Voice',
  x_6af959ee: 'Take photos and save them in a storage location.',
  x_e50663b2: 'Recharge',
  x_34ce201c: 'give away',
  x_85f42dcd: 'consumption',
  x_51d2fc74: 'Cancel current order? You can recharge again after cancellation. \\nCancel this order?',
  x_f3955e88: 'Canceled order',
  x_2b8fa5ac: 'Already paid',
  x_98308839: 'AI Credits added ✓',
  x_655c5610: 'No payment address',
  x_326e34ed: 'Payment information has been generated / Payment information ready: scan the QR code to pay',
  x_efad9fe0: 'Invoice could not be created',
  x_46ccee5b: 'Copied',
  x_2e3006a9: 'Copied address',
  x_9790e47c: 'AI Credits',
  x_ae190ef1: 'Current balance',
  x_8af6c290: 'Accumulated recharge',
  x_5c9bc81a: 'Accumulated consumption',
  x_34dccb6b: 'Cost per feature',
  x_7efdc4e4: 'History',
  x_b9db8476: 'There is no registration yet',
  x_833cba67: 'Paying USDT TRC-20',
  x_1833a9ec: '💰 Payment Amount / Amount (USDT-TRC20) ⚠️ Manual entry',
  x_9d3931f8: 'Steering (TRON TRC-20)',
  x_900ee05e: 'Scanning process',
  x_30d4a272: '(Any USDT wallet will work):',
  x_bf863bf8: '1. Click “Send” on Binance/OKX/Trust Wallet → select USDT → Network',
  x_4c6c1bd8: '2. Scan this QR code → the address will be filled in automatically',
  x_550c9aef: 'Amount entered manually',
  x_46703262: '✓ Already received',
  x_f4e8f238: 'Old pending order',
  x_3d75129d: 'credits',
  x_3f60cc81: 'Buy with USDT',
  x_e6b9334f: 'Welcome follow-up',
  x_4f3f45b3: 'Hello {name}! Thank you for signing up for your Sellox trial. I am the founder. If you have any questions, please ask me directly. You have {days} days left in your trial, this is the login address:\\nhttps://backup.sellox.shop',
  x_1b556750: 'Expiring reminder',
  x_b8e14961: 'Hello {name}, you have {days} days left on your Sellox trial. To continue using it, choose a package:\\n• Standard $29/month (5 people in 1 store)\\n• Pro $49/month (15 people in 3 stores + AI)\\n\\nRenewal link: https://backup.sellox.shop/saas/checkout',
  x_0cc0a930: 'Invite demo',
  x_8787d76d: 'Hello {name}, would you like me to give you a 15-minute remote demo? We can import your products together and allow you to start paying with POS within 1 hour.',
  x_9639c829: 'No phone number',
  x_558b5ced: 'WhatsApp is open and tracking is recorded',
  x_cdcef6e3: 'WhatsApp is open',
  x_e984172c: 'copied phone',
  x_5255b7ec: 'Total',
  x_30aeeb9b: 'Activate',
  x_a337d612: 'Expiring',
  x_f7656c12: 'Expired',
  x_2ba7855c: 'Pending',
  x_80d9ba9e: 'Search Merchant / Contact / Phone / ID...',
  x_c41ac297: 'Expires soon',
  x_9246fe88: 'to pay',
  x_f2992715: 'Click to copy',
  x_fb4174dd: 'Trial Signups',
  x_4740f413: 'All countries',
  x_f10c9104: 'There are no matching results',
  x_5bf2e3d5: 'Tenant',
  x_52409da5: 'Contact person',
  x_5a93d3f7: 'phone',
  x_56526d93: 'Registered in',
  x_43b510ed: 'remaining',
  x_b0d7b92a: 'Templates',
  x_56cfacad: 'Message content (editable)',
  x_a66e77ec: 'Unique store',
  x_6feaed50: '1 store',
  x_792d962f: '3 cashiers',
  x_f2e24124: 'No online store',
  x_8a77db1e: '🎁 New tenants do not need maintenance for the first year',
  x_9a61b1d7: '1 main store + 2 branches',
  x_4463f4a6: '12 ATMs',
  x_dab7b561: 'Online store',
  x_a0eac492: 'Company · 1+10 · Recommended',
  x_fe8cdaef: '1 main store + 10 branches',
  x_63c7540a: 'Unlimited ATMs',
  x_1e7614cb: '✅ Online store + delivery + multi-store report',
  x_b934c4e3: 'Cancel this order?',
  x_d16fd88d: 'Canceled',
  x_2276b3e8: 'Successful activation!',
  x_92a13409: 'Unable to generate payment address',
  x_33486076: 'Payment code has been generated/scan the code or copy the address to pay',
  x_1c017415: 'Payment code has been generated',
  x_d988ff0f: 'Copied address',
  x_65dd9ef1: 'waiting',
  x_fafc7219: 'Plan Activation · yearly service fee',
  x_e2841a14: 'Amount',
  x_d41c514e: 'network',
  x_93ba918d: 'TRON network only',
  x_13b5c750: 'Status:',
  x_b21b5ec9: 'Cancel order',
  x_228a7d81: '⭐ Recommended',
  x_d65904be: 'Incl. 1st-year service · yearly fee afterwards',
  x_39e6803b: 'USDT purchase',
  x_b36b9c5e: '/year',
  x_16bcce59: 'Includes: Server · Automatic updates · Customer service · Data backup · Monthly PWA updates',
  x_338e96c9: '🎁 The first year for new tenants is free with purchase · Renewal begins from the second year',
  x_2962f3d5: 'purchase package',
  x_d1fdc613: 'There is an upper limit on the number of stores.',
  x_9823244e: '. If you need to add a store, please contact WhatsApp customer service directly for a quote. It will not be automatically updated in the system.',
  x_29aca265: 'USDT TRC-20 network only. Any other coins or chains will be permanently lost.',
  x_8428cdf2: 'Automatic activation between 5 and 15 minutes after payment. If you have any questions, WhatsApp customer service:',
  x_1f1c7645: 'Optional groups require at least 2 options.',
  x_5b530127: 'Please complete the complete information',
  x_a3033ebf: '(Copy)',
  x_79d3abe9: 'Copy',
  x_ea15ae2b: 'Options',
  x_839a578d: 'Create package combinations to increase unit price per customer',
  x_c901f681: 'Package name',
  x_cc6c35a3: 'coding',
  x_cc949910: 'Fixed items',
  x_abba9357: '🔍 Enter the name to search, automatic filter dropdown menu...',
  x_2cad29d6: 'There are no fixed products yet',
  x_9a982d0f: 'Optional accessories',
  x_2e363fc9: 'Add optional group',
  x_8243c74a: 'There are currently no optional groups (customers can choose one from each group)',
  x_c6db8605: 'Prices',
  x_75c8703e: 'Package price',
  x_8690ee2e: 'save',
  x_c12c079a: 'Group name (e.g. drink selection)',
  x_d2ea9e05: 'Default options',
  x_ae648cba: 'Add at least 2 options, customers can choose one of them when purchasing the package',
  x_348f1b33: 'Please select an image first',
  x_4dc3f98d: 'OCR failed',
  x_17710b35: 'No rows to import',
  x_9190cc22: 'Supplier name',
  x_1fd1d5c5: 'Product name',
  x_39f76a9b: 'barcode',
  x_5f99f6a8: 'sale price',
  x_1981be5f: 'Take a purchase order and AI will automatically identify it → Align products → Update inventory + recommended selling price',
  x_bfd77887: '① Upload photos of purchase orders',
  x_5324ed82: 'Click to take a photo or select an image',
  x_346a0f2f: 'Supports JPG/PNG, maximum 15 MB',
  x_da7e7127: 'AI recognition in progress, about 5 to 10 seconds...',
  x_4eb51d8f: 'Start identifying',
  x_3f2f5467: '② Check the recognition results',
  x_a24b9d90: 'I already have a supplier (optional)',
  x_7b8bc49d: '-- use the name above --',
  x_9452920c: 'Incoming warehouse',
  x_dcffc8fa: 'Order number:',
  x_7501567a: 'Date:',
  x_dbcbbf20: 'Totals:',
  x_01be458f: '③ Each product row: select action',
  x_d32fc7ef: 'No product line recognized',
  x_c58187fe: 'OCR recognition',
  x_e514d3ef: 'Quantity:',
  x_3bf6cfdd: '× unit price',
  x_c500cfab: 'action',
  x_f504986f: 'party',
  x_26bb8418: 'New',
  x_92636e8c: 'jump',
  x_ba30d5cc: '-- Classification --',
  x_6a9e619b: 'Confirm storage',
  x_1d46b01c: '✅ Storage completed',
  x_bb3502bb: 'Purchase order number:',
  x_4a049640: 'Items in stock:',
  x_29645b50: 'item',
  x_art_pl: 'items',
  x_d909d882: 'Total amount:',
  x_c28d24cc: 'Please select a bank',
  x_f821a75d: 'Please enter account number',
  x_5d813f65: 'Please enter phone number',
  x_d467588f: 'Already added, remember to click Save',
  x_e742ab60: 'Example: 0199 My Personal Bank',
  x_8d1a5254: 'Please enter the bank name',
  x_c3441b0e: 'The bank already exists',
  x_1796b0b6: 'Receiving Accounts',
  x_2fae4dfd: 'The beneficiary\'s bank account number seen when the customer places an order. Multiples can be added (Transfer + Mobile Payment).',
  x_4edfb958: 'There is no collection account yet. Add the first one below.',
  x_9c3929ba: 'Account:',
  x_343c39bd: 'Telephone:',
  x_468507f3: 'Cardholder:',
  x_a315035f: 'Add account',
  x_b7887785: 'Type',
  x_c75632b1: 'Bank',
  x_d9d63df2: 'Account',
  x_ccfc0579: 'Holder',
  x_b87b58ea: 'Telephone',
  x_f1e36d48: '+ Add payment account',
  x_3a24d652: 'Banks in Online Store',
  x_9bdee3a3: 'The bank selected by the customer when placing the order. Uncheck any = show all (default). Custom banks can be added.',
  x_3036d714: 'Add bank',
  x_de8733ca: 'all',
  x_7c589a7b: 'None',
  x_4d915d93: 'Extended subscription ✓',
  x_9d6a7ced: 'Unable to create invoice',
  x_4e16c811: 'months',
  x_5beef376: 'month',
  x_91d63f7f: 'Renew Subscription',
  x_bc8a11d1: 'Tenant:',
  x_9b9a6730: 'Plan:',
  x_5f06418b: 'Waiting for USDT confirmation…',
  x_516de1ba: '· Status:',
  x_1bcf2f98: 'Save 2 months',
  x_e27e83d3: 'USDT renewal',
  x_77de9017: 'Wallet: Only USDT from the TRON network, sending other currencies will not be able to arrive.',
  x_ef6a3fe2: 'Once the payment is completed, the page will automatically return here and show "Subscription has been renewed." If it doesn\'t jump automatically, you can manually go back and click "Refresh."',
  x_da8f9e35: 'boxes/box',
  x_77862e71: 'Sync error, please check network and try again',
  x_ad41fef2: 'BCV sync failed',
  x_12d0d88a: 'Parallel sync error',
  x_b4b5434b: 'BCV = official/report | Binance = US dollar cash/change | black market = selling price',
  x_536911f7: 'No internet / no internet — wait for connection to return',
  x_b2fbbabf: 'Nothing to sync / No items to sync',
  x_aece3f5d: 'Discard this change? It will not be recoverable / Are you sure you want to abandon this operation? cannot be recovered',
  x_912a4250: 'Deleted/Deleted',
  x_cb4d2044: 'No Failed Items / No Failed Mission',
  x_10b526fb: 'The shift has ended: the sales order has actually been saved; this is a duplicate count request and can be safely discarded',
  x_5f01f33d: 'The pending order no longer exists; It may have been liquidated or deleted, so you can safely discard it.',
  x_d10bff45: 'Insufficient stock',
  x_57e7ae15: 'Insufficient inventory at the origin warehouse',
  x_8496514a: 'The origin warehouse does not have enough inventory: the transfer order has not been created! Please reduce the quantity and reorder, or replenish stock first. This stuck order can be discarded',
  x_4eb6919a: 'credit authority',
  x_fee56ee3: 'The customer has not opened the credit permit; first open enable_credit in "Customer Management" or discard the order and redo it with cash or transfer.',
  x_b5bda5aa: 'Duplicate request: The server has processed it and can be safely discarded',
  x_f17d4674: 'The network is normal.',
  x_01f3782e: 'Network disconnected',
  x_8b9a1e80: '— synchronizing automatically / Synchronizing automatically',
  x_9e50fc79: '🔄 Sync Now / Sync Now',
  x_1a62aebf: 'Discard/give up',
  x_bcb61127: 'Nothing pending / No items to upload',
  x_78e8a2f9: '✅ The account has been published',
  x_ccc63b24: '🔧 Credit account repair without owner',
  x_97ce76db: 'The cashier clicked “Credit” but did not select a customer/employee; Click "Credit" on the right to transfer the credit to the correct person.',
  x_2a4cb867: '✅ No unowned credit accounts found, all credit accounts have been successfully linked to customer/employee accounts',
  x_b7a67cb8: 'Search order/item/cashier number...',
  x_faa34bbd: 'There is no credit account without a matching owner',
  x_87633dad: 'Outstanding debt',
  x_bdc278a2: 'Pay the bill to...',
  x_d84f39b4: '👤 Employees',
  x_796638a3: '🧑‍🤝‍🧑 Clients',
  x_69632a49: 'Find employees...',
  x_4b93385f: 'Find clients...',
  x_ce2242ff: 'Mixing actual US dollar income and local currency conversion into a single total is strictly prohibited; The nature and risk of coverage of the two are different.',
  x_0b0fad08: 'Analysis of package sales.',
  x_b061a19e: 'Number of package orders',
  x_761c7bd5: 'Share of total orders',
  x_e0674456: 'Package revenue',
  x_8bdec340: 'Number of active packages',
  x_a789726b: 'Average price of the fixed menu',
  x_221340da: 'Package sales ranking',
  x_794b4643: 'There is no package sales data yet',
  x_da518fe1: 'After creating a package, sales data will be displayed here.',
  x_398265e4: 'Package sales distribution.',
  x_956aaaf0: 'Bundle Sales Trends',
  x_9c4738fa: 'Package order',
  x_c2ee20c6: 'Accessories selection statistics',
  x_d7bbccf6: 'Package sales details',
  x_46cd403a: '💵 Receipts in USD · Receipts in USD',
  x_9a2602b9: 'actual cash flow',
  x_b5091ee6: '💰 Local Currency Conversion · VES → USD Snapshot',
  x_3989b42a: 'Lock price in $ for the day',
  x_840a3569: '(reference)',
  x_d22c8252: 'Sample/Test',
  x_2ba8df79: 'Loss/oversold',
  x_1a6387e4: 'Successful damage registration',
  x_8f2328a2: 'Loss Report Management',
  x_20d8ea7f: 'Create a new loss report',
  x_6e2c4471: 'Loss Report Log',
  x_1a9a9b5c: 'Amount of losses reported',
  x_6c3b96c6: 'loss amount',
  x_2e51c1e9: 'all the reasons',
  x_7074d50c: 'loss',
  x_531401ac: 'Replace',
  x_c270fc6f: 'warehouse',
  x_cb29982e: 'Default warehouse',
  x_748662a5: 'Reason for reporting loss',
  x_da086f20: 'Additional instructions (optional)',
  x_6966f4a1: 'expected loss',
  x_3303f395: 'Confirm loss report',
  x_607e7a4f: 'See',
  x_30eb1c49: 'there is this week',
  x_0c6ff5f3: 'Customer\'s birthday - click to view marketing hub',
  x_35bd0636: 'Keep at least one item',
  x_dadc0335: 'Order modification',
  x_5badb3ba: 'Modification failed',
  x_1229b861: 'Hide non-legitimate orders activated',
  x_dc78ab4d: 'Closed to hide non-original orders - Show all',
  x_a2290676: 'Hide non-legitimate orders: On',
  x_3d0512c9: 'Hide non-legitimate orders: disabled',
  x_027d489f: 'Average customer order',
  x_77678b5c: 'All stores',
  x_565955cb: 'All ATMs',
  x_bfdaebfd: 'cashier',
  x_41ce131a: 'mix',
  x_966038af: 'returned',
  x_7623803b: 'Marking completed',
  x_1512dcd4: 'Edit order',
  x_9567eef9: 'cash cash',
  x_838effc3: 'Swipe Point',
  x_32005a19: 'Transfer Transfer',
  x_30bee6f5: 'Mixed payment',
  x_5939657d: 'split payment',
  x_1e9b1d5d: 'Cash$',
  x_26954cc9: 'Bs in cash',
  x_26922a58: 'received',
  x_c993e001: 'change',
  x_4091e27c: 'Discount',
  x_c8b8ba24: 'actual payment',
  x_c5575b3f: 'Save changes',
  x_7a8a35ec: 'All payment methods',
  x_25557e0c: 'Card',
  x_9f6bb100: 'Mixed',
  x_04330953: 'Credit',
  x_974470ef: 'Payment:',
  x_da4abd3e: 'unit price',
  x_0bf60b32: 'Quantity',
  x_f599fcd3: 'Subtotal',
  x_669e3a20: 'Saved Settings',
  x_9e144231: 'Send today\'s birthday wishes now?',
  x_6193e011: 'message too short',
  x_0ef8caa0: 'Please select a scheduled delivery time',
  x_50525e3d: 'The time cannot be earlier than the current time.',
  x_a5a64f69: '${blastForm.campaign_name || \'Festival\'}',
  x_4dc5ca8d: 'Programming failed',
  x_370f2e2c: 'Cancel this scheduled task?',
  x_482e8539: 'Cancellation failed',
  x_5ae7b19b: 'Today!',
  x_71325692: 'Example: Mother\'s Day 2026',
  x_2fb90b05: 'Processing...',
  x_2ae98dbc: '⏰ Scheduled',
  x_846a6e3b: 'Send to mass immediately',
  x_917f9004: '🎂 Birthday/Holiday WhatsApp Auto Marketing',
  x_2e7a63e4: 'Automatically sent to customers with birthdays at 9:00 AM (VE) every day',
  x_81b7205c: 'Each client is automatically deduplicated once a year.',
  x_8f6280a1: 'Coupon prefix',
  x_429d5967: 'Discount percentage (%)',
  x_f81c3d04: 'Valid days',
  x_d3276905: 'None yet. First fill in the date of birth (MM-DD) in the customer information.',
  x_8483ed13: 'birthday',
  x_3ec2bba0: 'distance',
  x_02daf71f: 'Subscribe',
  x_7001dd63: 'Cancel subscription',
  x_3e744a9b: 'Subscribe',
  x_1fd094a7: '📅 Quick vacation selection (sort by date, click to select)',
  x_919bf6ba: 'Select a blessing template → automatically fill out the form below (can be edited)',
  x_83f2b3fe: 'There is no default template for this holiday, please enter it manually',
  x_53eab0ee: 'Event name (used to remove duplicates, the same name will only be sent once a day)',
  x_baa7d2f5: '⏰ Scheduled shipping (optional)',
  x_a69942de: 'Select shipping date and time (in your local time zone)',
  x_afea4271: '✨The system will automatically send it at the time you specify. For example, if set a week before Mother\'s Day, it will automatically send at 9 a.m. m. from May 10.',
  x_04ab3e0f: 'After activating it, you can specify a time in the future for it to be sent automatically (for example, 09:00 on Mother\'s Day).',
  x_f9c3ed43: 'There is no shipping record yet',
  x_db8a4b9a: 'Complete all',
  x_4177fcbd: 'Welcome',
  x_b6076a05: 'Login error',
  x_459db148: 'e.g. store-code',
  x_d89bbf9f: 'Store code/mobile phone/password/name required',
  x_817f3912: '✅ Successful registration! Wait for the boss to approve the order before accepting it.',
  x_1c56d8c5: 'Registration failed',
  x_c5864848: 'Code *',
  x_a3006784: 'Telephone *',
  x_0b7dd959: 'Password *',
  x_552fd502: 'At least 4 people',
  x_914a33ec: 'Name *',
  x_3f1613aa: 'Plate',
  x_e33cbc27: '🎉Successful purchase! Go to the store to pick up the merchandise as soon as possible.',
  x_ecb6d7f9: 'The order could not be taken',
  x_5cc14c3c: 'Accepted',
  x_c92aaa37: 'Confirmation error',
  x_74cc7a41: 'Passed to next dealer',
  x_52690cab: '🚀Start delivery',
  x_1d6ecc64: '✅ Delivered, the shipping cost has been credited to the account',
  x_e319cca8: 'Take a photo of the delivery proof?\\n(You can skip it and cancel it directly)',
  x_ead2daed: 'Contact owner for details.',
  x_757bc40a: 'After passing the review, the available order will be displayed here.',
  x_a830777b: 'The order cannot be accepted',
  x_b720a69a: 'Under review',
  x_4a9428f9: '✓ Certificate',
  x_c9d929e0: '✗ Rejected',
  x_1ef6f1db: 'waiting for orders',
  x_10f8cbf4: 'I received the order and went to pick it up.',
  x_f8a40394: 'Picked up',
  x_d409c4ea: 'unknown distance',
  x_e91aeee2: 'Completed orders',
  x_9af2659b: 'Accumulated income',
  x_f061db1c: 'Vehicle',
  x_108db12e: 'Rating',
  x_ad77bf1d: 'sellox rider',
  x_dec20a6b: 'Store code',
  x_8e362599: 'Telephone',
  x_a6eabe9b: 'Password',
  x_58caca00: 'Cyclist registration',
  x_1c3a8565: 'Vehicle type *',
  x_8db8ee8e: 'Motorcycle',
  x_201504a8: 'Bicycle',
  x_cc31ee5d: 'Car',
  x_fbba6044: 'on foot',
  x_6c78bebb: 'Waiting for approval',
  x_4a798e43: 'The account has been deactivated',
  x_d6991a83: 'Completed ✓',
  x_9890f97b: 'Print Setup Wizard',
  x_cff3211b: 'Complete silent printing setup in 3 steps, printing without pop-ups',
  x_26590e3f: 'Step 1: Set the default printer',
  x_8fb52e11: 'Open Windows Settings → Bluetooth and devices → Printers and scanners',
  x_86219510: 'Disable "Allow Windows to manage the default printer"',
  x_d82f67dd: 'Click on your thermal printer (such as the XP-80C)',
  x_476e0586: 'Click "Set as default"',
  x_b26839a0: 'Step 2: Copy the startup command',
  x_89eff51a: 'Click the button below to copy the command',
  x_e63a8355: 'Step 3: Create a desktop shortcut',
  x_4a7e4b2f: 'Follow these steps',
  x_39dca51d: 'Right click on an empty space on the desktop → New → Shortcut',
  x_f89fc87a: 'Paste the command you just copied into the "Where" box',
  x_8f932a07: 'Click Next and enter Sellox POS as the name',
  x_631effbe: 'Click Done. In the future, double-click the icon to open the cash system.',
  x_e45ed499: 'Copy the Edge startup command',
  x_a28aa67f: 'Copied!',
  x_e541bfc7: 'Copy Chrome Command',
  x_eedf4bbd: 'Tip: If you print to OneNote or PDF, check if the default printer is set correctly in step 1.',
  x_797d0e09: 'After the setup is completed, double-click the "Sellox POS" icon on the desktop and the printout will be automatically sent to the printer without any dialog box appearing.',
  x_f394cfe1: 'Wholesale Account / Wholesale Account',
  x_95e3ad97: 'Client/customer',
  x_a702e3be: 'Points / Points',
  x_b29b209c: 'credit/credit',
  x_0170732a: 'Debt Summary / Overview of outstanding debts',
  x_39ee196f: 'Wholesale Orders / Wholesale Orders',
  x_4ccb2222: 'Recent purchases / recent purchases',
  x_5f2a9420: 'scan code',
  x_ecd041a0: 'Redirecting / Redirecting…',
  x_9a8ed80b: 'Payment received / payment successful',
  x_e7268001: 'Error uploading / Error uploading',
  x_b37d1896: 'Compressing... / Compressing images...',
  x_bd703be1: 'Processing... / Processing...',
  x_67c3bc10: 'The bonus has been sent.',
  x_96d7970c: 'Confirmed payment',
  x_0cb0251b: 'Rejected payment',
  x_ea4ccc53: 'Voucher sent to cashier',
  x_8a6643a7: 'Reference / reference number',
  x_88e9e55d: 'Amount/quantity',
  x_230397c0: 'Date/Date',
  x_e10ba955: 'sender/name',
  x_e222bb0c: 'Telephone/mobile phone',
  x_248a9885: 'ID/ID',
  x_e4f17ebf: 'bench / bank',
  x_31bde601: 'Type / Type',
  x_2faded9f: 'Upload a screenshot of your payment receipt',
  x_ff5f2a1f: 'Please wait / Please wait...',
  x_ee8d09d1: 'Click to take a photo or select an image to upload',
  x_e893f6b1: 'Identified data/AI recognition results',
  x_c7c7b829: '✓ Correct receiving account / The receiving account is correct',
  x_aa855a32: '⚠️ Account does NOT match — review / Receiving account does not match',
  x_2f1745ef: 'Upload another receipt / Upload another',
  x_1b056098: 'The cashier can see this result in real time.',
  x_7eef492b: 'Enter your phone or code / Please enter your mobile phone number or customer number',
  x_rider_push_banner: 'Enable background order alerts (rings even when locked)',
  x_rider_push_btn: 'Enable',
  x_rider_push_on: 'Background alerts enabled!',
  x_rider_push_denied: 'Notifications blocked — allow them in phone settings',
  x_rider_push_fail: 'Failed to enable, try again',
  x_rider_new_order: 'New order!',
  x_5b4d6f56: 'Not found / not found',
  x_ba825d88: 'Lack of store / lack of stores',
  x_163d4734: 'Very short name / too short name',
  x_d8d5dbd4: 'Invalid phone / Mobile number format error',
  x_61d1e909: 'Logger error/Registration error',
  x_9e478700: '🎁 Points Club / Points Club',
  x_4f4ed4a8: 'Store / Store ID',
  x_e223e6f8: '📱 Telephone or Code / Number or mobile phone number',
  x_400ea289: '📋 Rules / Rules',
  x_f4ae4ba2: '1 minute',
  x_e41c8f96: 'Receive Birthday/Holiday WhatsApp Wishes and Offers',
  x_472eeea6: 'Hello / Hello',
  x_e0ad1b59: 'points / points',
  x_b6d516c1: 'Rules/rules',
  x_3207b63d: 'Absence penalty',
  x_366edeab: 'salary deduction',
  x_1eb00e63: 'Company owes you / The company owes its employees',
  x_ecd32f47: 'Outstanding balance / pending payment',
  x_a93dac50: 'Balance / Balance',
  x_e37433ef: 'To be picked up at checkout / can be picked up at checkout',
  x_c72b5c9e: 'Weekly Schedule / Shift schedule this week',
  x_2c7d6de7: 'Recent movements / recent registrations',
  x_4536f3e5: 'es / chinese',
  x_98961d8e: '⏰ Expired link / expired link',
  x_13cd19da: '📸 Original / original image',
  x_855e9d6c: '✨ AI Enhanced / AI Embellished Version',
  x_8cd3793f: 'div>',
  x_9f2178d0: 'div>',
  x_261541dd: '⏳ Waiting for the passenger to take the order.',
  x_b886ab95: '🛵 The cyclist has accepted the order and heads to the store.',
  x_a2d70627: '📦 The passenger has collected the merchandise.',
  x_168a78b9: '🚀 The cyclist is delivering',
  x_c5febde0: '✅ Delivered',
  x_4babc22d: '❌ Canceled',
  x_f07cecdb: 'Unable to get order status',
  x_69deca2b: 'Order not found',
  x_638959b3: 'Store',
  x_9b16789f: '🏪 Store',
  x_341cb93c: '📍you',
  x_3934104b: 'Delivery man',
  x_b1862ef3: 'Order amount',
  x_1138a92b: 'delivery fee',
  x_2541ca48: 'Update now',
  x_153942db: 'See you next time',
  x_78f2095f: 'new version found',
  x_9b601b8e: 'Current version',
  x_9ee20a30: 'latest version',
  x_49009569: '📝 Update content',
  x_4a07f0c8: 'Subscription has expired',
  x_db45a2da: 'Your Sellox subscription has expired. To avoid affecting business, renew as soon as possible.',
  x_5eeb04af: 'Subscription is about to expire',
  x_8dd2a3dc: 'The trial ends soon',
  x_01059b1d: 'Free trial has ended',
  x_26a5e5a8: 'Renew to unlock all features and continue running your business.',
  x_0ea5b9f4: 'Annual payment is only $500 (Save $100 Get 2 months free) Monthly payment is $50',
  x_39bb592b: 'Renew now (WhatsApp)',
  x_dc017114: 'reminder later',
  x_7693a3c0: 'Hello, I would like to renew my subscription to Sellox. Merchant:',
  x_4a6ea4ec: 'No more notices within 7 days',
  x_feea9211: 'Download QR code',
  x_04c8c8a8: '📱 Sellox mobile application launched',
  x_faf8c169: 'Scan QR code with camera Bluetooth printing Check your sales at any time - click here to scan QR code to download',
  x_053877ee: 'Scan the QR code to download the Sellox mobile app',
  x_d73e6673: '📱Scan with mobile phone camera or WeChat',
  x_9f9d3632: 'mobile phone',
  x_5c980c4f: 'camera',
  x_a7185263: 'or',
  x_767c7df9: 'Scan on WeChat',
  x_d17430c7: 'Align the QR code',
  x_15067f6d: 'Click to appear',
  x_17dbbc8e: 'Download link',
  x_69350bb6: '→ APK starts downloading',
  x_86e36e8c: 'After installation, there will be an additional Sellox icon - log in directly',
  x_6d876a09: 'See full page',
  x_a75406c6: 'Hello Super Admin 👑\\nYou can ask me to do the following:\\n• "Recharge 500 points to Andy"\\n• "Observe the total tenants and AI usage of the platform"\\n• "Top 10 tenants with the highest AI balance"\\n• "Detailed information about Andy"',
  x_720f0600: 'AI service is not available',
  x_d21e1fb6: 'Platform Overview',
  x_dc45b9fc: 'List all tenants',
  x_1c101627: 'Top 10 balances',
  x_922f1ff2: 'Recharge Andy with 500 points',
  x_40e77bcc: 'tell me what to do...',
  x_ee98d830: 'Platform level control GPT-5.2',
  x_dbd5f6e5: 'Pick a variant',
  x_9cc890a7: 'Cancel',
  x_b4a55bb3: 'Allow pop-ups / Please enable pop-ups',
  x_45546304: 'Send to WhatsApp (~$0.01)',
  x_3835157d: 'One-Click Dual Send: Print QR Paper + WhatsApp Popup Box',
  x_e0caf262: 'Quick reconciliation',
  x_fccab93a: 'to collect',
  x_6e2a13a0: 'Requires confirmation from manager to end shift',
  x_4349b878: 'The manager confirms',
  x_49dfdd8b: 'Confirmed manager',
  x_04070c1f: 'Actual counting quantity',
  x_57680d2c: 'Cash receivable',
  x_4acec17e: 'Remarks (if there is any difference, please explain the reasons)',
  x_5f411223: 'Return',
  x_1e576858: 'Synchronized offline order / Offline supplementary order transmission',
  x_b15d9127: 'Close',
  x_240ce88f: 'The manager must scan the QR code or enter the password to confirm the shift change.',
  x_26201f40: 'Mobile Payment Verification:',
  x_eec5e9de: '💡 The "Accounts Receivable" system has been completed by default. Simply modify the row that doesn\'t match the actual count (usually just the cash row).',
  x_77f4b22c: 'Starting box:',
  x_cf80dc01: '(Added to "cash receivable")',
  x_3b2cc96c: 'It is normal if the difference comes from bank fees, tips or exchange. If the numbers don\'t match, check to see if you made a typo or missed something.',
  x_81ab69b9: 'Change tables / share tables / force close table',
  x_555dcd4d: 'No tables',
  x_7188b57a: 'First go to Administrator → Industry Template → Restaurant to create a table automatically, or → Table Management to add a table manually',
  x_21f69613: 'Table: Open a new order. point',
  x_b19d83e5: 'Change table',
  x_6f52c7c0: 'shared table',
  x_cecf0ca3: 'Force close the table',
  x_2435f5bd: 'Product Feedback',
  x_0fa5956e: 'Enter notes...',
  x_da36e122: 'no sugar',
  x_d8a56361: 'shaobing',
  x_358cbe41: 'spicy',
  x_81f4307e: 'no onions',
  x_7e1d3c25: 'to take away',
  x_bc8d758c: 'urgent',
  x_11db356c: 'Enter order notes...',
  x_4403fca0: 'Delete',
  x_2b6c52ae: 'There are no new orders',
  x_8131eb5e: 'Sound is off · Click to activate',
  x_7d1a9279: 'Sound is on · Click to turn off',
  x_e2392cc3: 'No table orders yet',
  x_60ce5286: 'Prescribed product:',
  x_2c475e48: 'You must first register the customer (name + phone number) before you can make the payment.',
  x_8e5fdd7c: '⚠️Immediate/expired items:',
  x_c15301ed: 'Expires today',
  x_abfc8ce7: 'Open Shift',
  x_9f22fdc1: 'Starter box',
  x_561e47de: 'How much cash is in the drawer now? I used to make changes. The system will automatically deduct this amount for reconciliation at the end of the shift.',
  x_b250b8da: 'Skip',
  x_e2f5ed34: 'Open',
  x_d43f28df: 'Price Tags',
  x_cb08c979: 'Search...',
  x_6ff3aa66: 'Price',
  x_b7704c27: 'Size',
  x_eb10f492: '80mm thermal (1 photo per order)',
  x_bc3c00b4: 'A4 (3 column grid, paper saving)',
  x_3f5cee0a: 'Cashea surcharge %',
  x_248bf378: 'No results',
  x_8821f767: 'Search name or phone',
  x_aed44ac1: 'Client Signature *',
  x_1c5dca75: 'Total / total amount',
  x_a306d0a4: 'Client *',
  x_b21d8bb4: 'No results',
  x_15e8601c: 'USD Cash',
  x_6aad3987: 'Bs in cash',
  x_edf32545: 'Bank Ref.',
  x_a31b8b65: 'Enter the customer\'s transfer reference number and the system will automatically check if the bank has received the payment.',
  x_868e4ac3: 'Term (days)',
  x_9da7a7b8: 'credit contract',
  x_6c6d1878: 'myself',
  x_0f76a0c9: 'Confirm receipt of the described merchandise, total value.',
  x_7221fd2a: ', Chengruozai',
  x_d959b5d4: 'settle the balance',
  x_96553cea: '. Merchants with late payments have the right to take legal action.',
  x_e2b5c6cc: 'Product name',
  x_b10acb59: 'take order',
  x_a5e0e12d: 'A FAVOR FROM THE EMPLOYEE / The company owes its employees',
  x_17ea5dd2: '📱 Digital account statement / electronic invoice',
  x_4e743c6d: 'Actual balance/current balance',
  x_4ae414d7: 'Loans and credits / Loans and refunds',
  x_c7d9aa03: 'Merchandise on credit / credit record',
  x_8815c25b: 'Salaries Paid / Salary History',
  x_6cb22de0: '✅ Company owes you / The company owes deposits to employees',
  x_66ea4390: '📱 Scan to see your digital statement / Scan the QR code to see the electronic invoice',
  x_443de421: 'Report loss',
  x_bb54122e: 'Reprint receipt',
  x_50c099f4: 'Loss record',
  x_a1ed3194: 'Search product name or code...',
  x_7959f6f5: 'wholesale clients',
  x_e2e1c3c9: 'Search members (name/mobile phone)',
  x_0c9545b4: 'Customer name *',
  x_8098e2b4: 'Mobile phone number',
  x_6ecea67c: 'Identification number Card',
  x_67f6a89e: 'Observations (optional)',
  x_df3c5cbe: 'USB is connected',
  x_d685a4d5: 'Connect USB printer',
  x_bfff47cd: 'The electronic scale is connected.',
  x_2864a729: 'Connect electronic scale',
  x_912cc1e7: 'checklist',
  x_4b8e471b: 'apart',
  x_05cee7de: 'Print price tags',
  x_6441bd25: 'Refreshing...',
  x_498519d1: 'Update data',
  x_066ae8d7: 'backstage',
  x_b9431793: 'Change user',
  x_c3992269: 'Exit',
  x_f98a4911: 'Early Cash Drop',
  x_953a783e: 'Offline mode: Orders can be placed normally and orders will be automatically synchronized once the network is restored.',
  x_4080c16f: 'Offline and no cached data: Connect to the Internet first to upload data',
  x_8bcfc934: 'The cached data is more than 24 hours old, prices and stock may have been updated. It will update automatically after the network is restored.',
  x_a75ed77e: 'If the cached data exceeds 1 hour, it is recommended to connect to the Internet to refresh.',
  x_333142e1: 'Type to search / Enter to search more...',
  x_7ffacc1a: '🎂 Birthday Birthday',
  x_787b5677: 'gender',
  x_6a0ee6bd: 'Use Chrome\'s Kiosk Print Mode to silently print to the default printer (XP-80C) without additional setup',
  x_8dc32ae4: 'Cash',
  x_14add33c: 'Card',
  x_a474b44e: 'Transfer',
  x_80263dad: 'Mixed',
  x_7f3933e2: 'Credit',
  x_86aa4552: 'Order inquiry/invoice reprint',
  x_36bcb2a1: 'Find order number...',
  x_0cc05f42: 'of',
  x_d716f1e8: 'arrive',
  x_83958d46: 'single',
  x_85ab5250: 'no order',
  x_9109ea1e: 'add payment',
  x_16a3cf1d: 'Change payment',
  x_d8b294d0: 'print invoice',
  x_15a6696e: '80mm small bill',
  x_62d36990: 'add to cart',
  x_e90b99bd: 'Early Drop',
  x_6cbe5ffa: 'USD (United States Dollar)',
  x_7559edad: 'Enter amount',
  x_06508433: 'Manager PIN required',
  x_731c658b: 'Void this drop?',
  x_dcc961ae: 'voided',
  x_267fa274: 'Select administrator',
  x_3700ec74: '4-8 digits',
  x_e20efdec: 'Example: the drawer is too full',
  x_e39ec276: 'Confirm Drop',
  x_563e10ba: 'Void',
  x_43c80a9b: 'Give the large amount of cash in the drawer to the manager in advance. The system will automatically deduct it at the end of the shift and simply count the remaining cash.',
  x_2ed7e4e2: 'Currency',
  x_ae59a48e: 'Manager',
  x_a87ce55a: 'PIN Manager',
  x_3a14c9f8: 'Notes / Notes (optional)',
  x_b72845a8: 'No check-in yet',
  x_db16fe15: '✅ Complete',
  x_de040917: '⚠️ Confiscated',
  x_56673f3a: 'Error',
  x_f15ea525: 'Find order number/customer/phone number',
  x_712939e0: 'The quantity must be greater than 0',
  x_e1308cbe: '✅ Payment received successfully',
  x_1d5381c2: 'Cancelled, inventory has been reversed',
  x_a29d3fab: 'Reason',
  x_92b67f7b: 'Return of deposit to client',
  x_4c2db86d: 'The deposit goes to the merchant.',
  x_0aa2fd58: 'Active',
  x_80e42329: 'Completed',
  x_f3f6aad1: 'Canceled',
  x_9f5fa600: 'Forfeit',
  x_7cf73f3d: 'All',
  x_4865eb9a: 'not apart',
  x_76898534: 'balance',
  x_d941a5be: '⚠️ Expired',
  x_3a291eca: 'Get paid',
  x_0959981b: '✅ Erased',
  x_353048bb: 'Can be sent to customers.',
  x_e91d829e: 'Canceling orders requires administrator permissions',
  x_e8606af7: 'Confirm cancellation',
  x_d2dbc37e: 'do not cancel',
  x_de1ec1b5: 'Divide by / divide equally',
  x_32cd3100: 'Error changing table',
  x_26e78ec2: 'Could not join table',
  x_ae1573f2: 'Failed release',
  x_be163dfd: 'Change table',
  x_010a57e3: 'Transfer the account from this table to another empty table',
  x_f4b63ba2: 'Combine accounts',
  x_57c68729: 'Merge accounts from another table with this table',
  x_dee2caa5: 'Release table',
  x_145ac83c: 'Without settlement, only table entries are released (manual reconciliation scenario)',
  x_5a43d675: 'Select free table:',
  x_88f3038b: 'WhatsApp will be sent to',
  x_b787eaf7: 'The number is too short, at least 8 digits',
  x_1a5e2d7a: 'one-click)',
  x_a62f3804: 'USDT (TRC20) · Tron · Management fee ≈$1 ⭐',
  x_e9868cc5: 'Copied ✓',
  x_48eb1f6c: 'Fastest)',
  x_50a13126: 'Tap to chat with pre-filled message',
  x_067ff847: 'Payment Methods',
  x_57c296c9: 'Payment instructions',
  x_422c8df2: 'billing',
  x_96575b5a: 'singular',
  x_2ab9e7e1: 'Cash without prescription',
  x_9627644f: 'Return',
  x_598fb8ab: 'Payment method',
  x_5d5de3a9: 'What was sold?',
  x_9902bd0f: 'Search product name...',
  x_729c413f: 'goods',
  x_f965fea3: 'times',
  x_b68919a3: 'turn',
  x_6f862984: 'Money to start a class.',
  x_3788667e: 'cash receipts',
  x_8fbe97e2: 'remove',
  x_769b69c5: 'should now',
  x_27e303bd: 'No open classes (no cash details at the counter)',
  x_3e586351: 'There is no record of the day.',
  x_244b0c8f: 'original order',
  x_ea9fedcb: 'gross income',
  x_211d2fdf: 'Camera not available:',
  x_2637e51a: 'Error starting camera',
  x_2cbd6249: 'Code is not in public databases — fill manually',
  x_3016cebc: 'Search failed',
  x_2a3e7f5c: 'manuals',
  x_092a15aa: 'Enter the code (EAN-13, UPC...)',
  x_9ebf3950: 'Use and create',
  x_82cafd5c: 'Continue with code',
  x_c0079539: 'Searching...',
  x_eba9d01c: 'Code not found',
  x_913fcd49: 'No changes',
  x_9216d1be: 'Sizes',
  x_bbbbab6e: 'Colors',
  x_f297d54c: 'Step 2: Enter inventory by line → Save',
  x_2f88548e: 'Size\\Color',
  x_3e616117: 'Enter your phone / Please enter your registered mobile number',
  x_925ff2fa: 'Enter the code / Please enter the verification code',
  x_798b1cb7: 'Password minimum 6 characters / Password must be at least 6 characters',
  x_8052ef2a: 'Passwords do not match / Two passwords are inconsistent',
  x_8049f1c7: 'Send code / Send verification code',
  x_9d936c0f: 'Reset / Reset Password',
  x_a850638e: 'A verification code will be sent to the store\'s registered WhatsApp.',
  x_6c546734: 'Registered phone / Register mobile number',
  x_b3382444: 'Verification code/code',
  x_a25bd352: 'New password / New password',
  x_134cc560: 'Repeat password / lose again',
  x_72138076: 'Password reset! / Reset password',
  x_35973a26: 'Store / Store ID:',
  x_0c58a4d9: 'User / Username:',
  x_871b1e0c: 'New version ready',
  x_77dbaf27: 'Updating...',
  x_edf4de14: 'official)',
  x_c9dc4ffd: 'Firefox ESR legacy system support',
  x_39400df4: '🌍 Global tenant map',
  x_ef8318a7: '💰 Crypto Payments Overview',
  x_09636666: '🔔 Renewal reminder (AI)',
  x_542ce2f8: 'Trial Signups',
  x_408009cf: 'International Pay',
  x_5910639f: '📦 Lot/lot number (FIFO)',
  x_b1381d19: '🎯 RFM grouping + mass shipping',
  x_559dca3c: '🏆 Employee performance details',
  x_6e1ce46a: 'printer manual',
  x_03a9825e: 'Hello boss! I am your AI business assistant. You can ask me "How much profit is today?", "Best selling product", "Insufficient inventory", "Who owes me money", etc.',
  x_b26b0699: 'AI service is temporarily unavailable',
  x_0a0092b7: 'The 5 products with the highest grossing',
  x_b23a6752: 'What stocks are out of stock?',
  x_19a63387: 'Who owes me the most money?',
  x_9445221f: 'AI Business Assistant',
  x_a6f1ba27: 'Ask a question...',
  x_20448d20: 'GPT-5.2 · Consult data in real time',
  x_943201f9: 'rise/up',
  x_caecf5b4: 'fall / fall',
  x_f345932a: 'Dismiss',
  x_1c4d65a8: 'FX Alert',
  x_2a9db7a6: '✓ WhatsApp boss account pushed',
  x_b2a5c20e: '⚪ WhatsApp is not activated (set boss number in FX settings)',
  x_4f100f54: 'Hello Sellox! I am interested in your POS.',
  x_0cbf83cc: 'Contact us',
  x_e9e8054f: 'mail',
  x_73325cad: 'full',
  x_41f5f6ef: 'less',
  x_8be34d50: 'buy',
  x_040f3943: 'send',
  x_9aacc1c5: 'special offer',
  x_3fcde29c: 'Proof of payment could not be uploaded:',
  x_bf7669aa: '. Try using a clearer screenshot.',
  x_b4c3bd30: '无图 / No image',
  x_3cf48c32: 'existing images (can be replaced) / With image',
  x_f653eca8: 'Camera is not available (',
  x_90b6a7dd: '), return to photo album',
  x_52983340: 'Stores Unlimited employees',
  x_a40aedb7: '✅ Sent',
  x_791333be: 'WhatsApp',
  x_3083efed: 'Make sure the client',
  x_97bbb919: '"Move to recycle bin?" \\nAccounts and history will not be lost and can be restored at any time.',
  x_8d6e3b74: 'Moved to the trash',
  x_b70e8e43: 'Restored',
  x_3580b741: 'Reactivated',
  x_4a561e6f: 'characters (signature has been tested and approved)',
  x_f30d10af: 'box x',
  x_cdf08038: 'make sure',
  x_a24c6f3f: 'Mark all posts as published?',
  x_5c51c3b8: 'Exported',
  x_c0a515b2: 'clients / Exported',
  x_2d4c5dcc: 'Created',
  x_6c0b9fed: 'Minimum inventory of items.',
  x_ddfcb2be: 'Fixed',
  x_b1418bb8: 'Negative inventory of goods.',
  x_fe4c8813: '\\n...Also',
  x_930882bb: 'a',
  x_8cfef109: 'share',
  x_896a955f: 'Items without cost price:\\n\\n',
  x_6b73316d: '\\n\\nConfirm to delete everything? This operation is irreversible!',
  x_5cc23262: 'Deleted',
  x_db0a9f72: 'goods without cost price',
  x_a2aaa24e: 'Apply them all (',
  x_fc4d75f6: 'discover',
  x_1e2b2923: 'drifting products, total',
  x_e86ee821: 'unit. Repair immediately?',
  x_992bce69: 'products (',
  x_e2f9c4d8: 'unit)',
  x_e213f3ac: '✅ Shipped! identification:',
  x_30fae0dd: '✅ Enabled: Automatic reminder at 9:30 a.m. m. every day (same client',
  x_ed0dbd12: 'It does not repeat itself after a few days)',
  x_04501e0e: '✅ Saved: minimum number of same customers',
  x_99c19d88: 'The genie will remind you again.',
  x_11c0bdd6: 'Give"',
  x_04b02a3b: '》Set new login ID\\nCurrent:',
  x_951c3597: '\\n(4-20 digits, letters/numbers/hyphens/underlines)',
  x_ec9f4837: 'Confirm',
  x_eb7706ac: 'Change to',
  x_61bbc1d1: '?\\n⚠️ All employees of this merchant must log in again with new IDs and the online store link will also become /shop/',
  x_f0bb4cec: 'Store limit has been set to',
  x_a6cdd2a0: 'house',
  x_4a368d87: 'Confirm deletion',
  x_f8789f6e: 'Inventory records?',
  x_4d8a497e: 'Accept to delete',
  x_52f6f1b8: 'of all the inventory? This operation is irreversible!',
  x_61682ed3: 'Confirm again: delete',
  x_9a5e3bc8: 'All inventory records?',
  x_3683077f: 'Erased',
  x_4deb231b: 'inventory records',
  x_d5d53fcf: 'Be sure to copy all inventory from the main warehouse to',
  x_1b3f235d: 'Already since',
  x_06363f80: 'the items arrive',
  x_dd78ca49: '✅ Recharge successful! +',
  x_19e9aae9: 'Test warning has been activated:',
  x_adfefb8e: 'Change to "',
  x_0258b3da: '”? \\nThe corresponding categories will be created automatically (existing ones will not be repeated). You can change back at any time.',
  x_6341a6f1: 'table',
  x_2cf87b31: '✅ Changed - New',
  x_2cd6fde3: 'categories',
  x_f64a9820: '· Completed',
  x_8983c664: 'income risk',
  x_b8f4e941: 'Reconciliation report',
  x_822ac472: 'Matched (',
  x_268173c2: 'No matching validation (',
  x_172d9095: 'Unmatched sales (',
  x_d03e7311: '✅ Processed: New',
  x_11e6be8e: '· Association',
  x_b06b30ab: '·Associate',
  x_1b16b10a: '· Mobile phone number is missing',
  x_26b59f52: 'pay',
  x_fddfa6c6: 'AI recognition completed:',
  x_6def8122: 'Already in stock:',
  x_2ef72bb3: 'Item/purchase order',
  x_97695dd1: 's ago',
  x_be72b0b9: 'uploaded successfully / Uploaded',
  x_b0ef9048: 'discard',
  x_24406e3e: 'Was the operation rejected by the server?\\n\\n',
  x_8d893e60: '⚠️ These operations have no effect on the server. Please confirm whether you need to operate again before discarding)',
  x_61cef91b: 'deleted/cleared',
  x_9fb4dafd: 'pen',
  x_5526ee20: 'Credit account without owner, total',
  x_13743a01: 'Determine immediately until today.',
  x_1eca306b: 'Send blessings via WhatsApp to a birthday boy?',
  x_939d7902: '…etc.',
  x_2b689f7b: 'Modified',
  x_0a66a2c4: 'Preview: available today',
  x_27e4f2f4: 'client\'s birthday',
  x_bff5e1f3: 'Sent:',
  x_8e141b21: '· Failure:',
  x_2517df74: '· Skip:',
  x_9127c4b7: 'Preview: will be sent to',
  x_e61704c3: 'clients (excluding',
  x_e1967cf6: 'planned in',
  x_ed33b3f4: 'sendtr(',
  x_00c0b64d: ')? Confirm?',
  x_05235460: 'Scheduled:',
  x_bab46d2e: 'will send tr(',
  x_6912b561: ') message, confirmation?',
  x_f43d612e: 'Batch submission completed:',
  x_8891f2c6: 'Success ·',
  x_c3342602: 'Failure ·',
  x_17fbc240: 'queen of heaven',
  x_d5b805a6: 'diva ·',
  x_3b8c1c81: 'Complete template:',
  x_e46f5031: '% / Going up',
  x_1f06712c: 'rejected — review / Rejected, needs to be processed',
  x_35b7c240: 'Your subscription also has',
  x_aa277e9b: 'When the period expires, please renew in time to avoid interruption of use.',
  x_7dc5867e: 'The free trial remains',
  x_1d74fc6c: 'days. Renew to continue using all features.',
  x_613c2e78: '⚠️ Discover',
  x_81764eb3: 'There is a big difference between the articles, please check before closing the class.',
  x_86103e41: '⚠ Discover',
  x_473bed24: 'small differences',
  x_3aa832e9: 'Order through the online store #',
  x_1cda5086: 'Pending table order',
  x_1b95ed0e: 'deposit',
  x_641e1071: '≥ minimum',
  x_1c73433c: 'lower',
  x_1ecba8c2: '🏷️ Create Aparta (signed)',
  x_793d5c95: '🏷️ Create Aparta',
  x_4ffc9e7c: '✅ Already in the bag',
  x_ced2e82c: '⬆️ Upload',
  x_2180077a: 'Single / Upload',
  x_b6f69d33: 'Single to pass · red sin',
  x_0e6f5c6c: 'accounts merged into',
  x_d8817d65: '🤝 Fusion completed ·',
  x_dce1d1f6: 'Article ·',
  x_09e8990d: 'Confirm forced closure',
  x_7e05053e: '? This pending order will not be settled automatically. / Release the table without charging?',
  x_7f673278: 'released',
  x_050ed17c: '✅ Found / Found:',
  x_3bdece77: '✅ Generate',
  x_7a656cfc: 'variants',
  x_271f3942: 'line inventory',
  x_c53f6031: 'Accept · Fail',
  x_2d5aef4f: 'OK',
  x_b491196a: 'UI bug:',
  x_296304f1: 'today',
  x_d8886c56: 'Client Birthdays – Send Group Wishes With One Click',
  x_e292789d: 'Status/State',
  x_6165a875: 'Blocked to:',
  x_ba1267f0: 'Last update/Last update:',
  x_65d9f49b: 'Message to send (',
  x_764665c3: 'all (',
  x_028a9628: 'Create "',
  x_a0f73e03: 'Modify classification —',
  x_fa5bee02: '⚠️ Excluded:',
  x_dce0ab9f: '— Points will not be issued for orders placed with these payment methods.',
  x_27651c15: '30 day sale',
  x_1b3ba792: 'Minimum stock:',
  x_04d8e11a: '(Currently:',
  x_efa4cb5c: 'people/daily average',
  x_6f7909ea: 'Automatically send WhatsApp receipts',
  x_0141c048: 'Automatic claim (due to WhatsApp)',
  x_041a7a49: 'Days: After the customer has been urged, even if he has not paid yet, he still has to wait.',
  x_72f50f4b: '🤖 WhatsApp guarantees payments automatically',
  x_4c0d90b0: 'Currently wa-web is occupied by other tenants (',
  x_5250451c: 'Sellox is now available through your WhatsApp (',
  x_24d49a39: 'Only sent once a day',
  x_97f6b93d: ') — A server can only be enabled by one tenant at a time',
  x_4d4bb206: ') Automatically send messages to any client.',
  x_6dcb77fd: 'Store limit',
  x_2fd10482: 'Inventories pending approval / Inventory pending approval (',
  x_49f610ec: 'There is no established cost price for this product.',
  x_22261f15: 'Save Settings / Save',
  x_b45c0413: 'Send test alert / Send test',
  x_4d2afcd3: 'Completed (last 2h)',
  x_e0385134: 'To produce ·',
  x_d7104c13: 'In production ·',
  x_c02e8b6b: '💡 Buy button will be shown on the home page: WhatsApp Customer Service',
  x_889e1514: '· Others',
  x_6f2e8e74: 'Current industry:',
  x_26f914e7: 'Set time:',
  x_9657acc8: '💡 Example: Customer asks for $20 → Add $ automatically',
  x_dc0ccfb0: 'Service Fee → Total $',
  x_6690b55c: '⏳ Review pending (',
  x_a6b994c5: '✓ Certificate (',
  x_0a4b9139: 'Disabled (',
  x_c7c68337: 'Send this link to the runners you want to recruit →',
  x_bb5bb60d: 'Save Settings / Save',
  x_81cf7805: 'Tenant List (',
  x_a2b4e1d9: 'AI Renewal Reminder Draft',
  x_b6733812: '· Country',
  x_e852c9a4: 'store',
  x_a2cf4af4: '· Telephone',
  x_4b2603c3: 'Application Name Fill in a random name (for example:',
  x_bccb0533: 'Shift summary (',
  x_80a13d4d: 'Transfer:',
  x_f576986b: 'Start reconciliation',
  x_ad131c12: 'Pen$',
  x_54213898: 'details (',
  x_4209a9ba: '1 pipe = $',
  x_7a2c820b: '(Copy the one above',
  x_184b4831: '4. Confirm sending → 1-2 minutes of AI credits automatically +',
  x_8b2a4731: 'Order:',
  x_0b463505: 'USD AI function will be suspended when the balance is insufficient Contact the platform administrator to recharge',
  x_be11172d: 'test traders',
  x_8ae8f95e: 'The annual rate is valid until:',
  x_d3d43df8: 'Waiting for USDT to arrive',
  x_30c0ee04: 'Annual renewal fee USDT$',
  x_1a810c50: 'Store version',
  x_f8f63ea1: '(Sold for $',
  x_ea6914b3: '/Get into$',
  x_8f3599b6: 'trust',
  x_02456a77: 'Barcode:',
  x_b4fdcd01: 'Update cost price (original',
  x_a3f28012: 'Suggested retail price (+',
  x_8375f775: 'Box ×',
  x_2c0e9a33: 'Queuing / Join the team:',
  x_b8bfc6ea: 'Changes pending upload / Items to be uploaded',
  x_f15ef0a0: 'Pen·Customer pays in US dollars',
  x_fadfbb89: 'Pen · ≈',
  x_8e52492c: 'Send with one click',
  x_777ba9db: 'articles',
  x_60c22af0: 'Message template (supports variables',
  x_2aabd245: 'Results preview:',
  x_32e0b823: 'Birthdays in the next 30 days (',
  x_4e1abb5c: 'Message content (supports',
  x_122c804a: 'Plan to be sent (',
  x_d0176d3e: 'Send records (almost 50 articles total',
  x_f2b7c51d: 'ready to go',
  x_fb9b45b1: '· Coupons',
  x_8e9b7f87: 'party',
  x_4ca669c7: 'Sent ·',
  x_7100dc7a: 'Jump ·',
  x_ff8318c2: '⚡ ASSIGNED TO YOU / ASSIGNED TO YOU',
  x_f1f28de8: 'Login / Login',
  x_ed2d1a22: 'Send Registration / Send',
  x_618ab9b1: 'Confirm within s',
  x_49074539: 'Estimated weekly salary: $',
  x_9013fa6e: 'Order #',
  x_1b3e5894: 'rider',
  x_d7d4b3fc: 'Sending',
  x_875225ef: '— Select specification / Select size and color',
  x_8dcf5483: '📤 Sent to manager / Early deliveries (',
  x_69a49f6a: '📩 New online store orders (',
  x_532e7e2f: 'Item · #',
  x_f38a0357: 'Prescription Drug Customers Have Registered:',
  x_2105a088: 'Expires after days',
  x_f77c9383: 'More...',
  x_56f0d339: 'Expiration date ≈',
  x_4727e7e1: 'US dollars',
  x_4b8b23a7: 'in a few days',
  x_100bd194: 'articles ·',
  x_56ec6c2c: '% Minimum Deposit = $',
  x_338f8935: 'Inventory:',
  x_dd8e89b9: 'More products... Enter keywords to search',
  x_698818eb: 'To sync:',
  x_2751b59b: 'Amount / Amount (',
  x_423485d6: '📜 This flight has been bagged (',
  x_9fb8b1b7: '🏷️ Reserve / Retention Management —',
  x_f9659c1d: 'i$',
  x_e7feb554: '💯 Collect balance $',
  x_d127a089: 'Select the table to be merged (the count of this table will be merged into',
  x_d0846a09: '✓ in',
  x_1e68d525: 'Query/Search',
  x_d7b1fd5f: 'found',
  x_5f6ef156: 'Generate combination / Generate',
  x_29953c6f: 'be saved',
  x_50918dbc: 'variations ·',
  x_fc461ac5: 'save inventory (',
  x_e468fa4f: '⚠️ Your browser is outdated —',
  x_9ba1a642: '(threshold',
  x_f876a49c: '% · It is recommended to consult the sales price of the product)',
  x_795eaf50: '🖨️ Print',
  x_8059771f: 'No image',
  x_cec3f014: 'Replace',
  x_532c8856: 'Take photo',
  x_207eb32c: 'From gallery',
  x_2425155d: '💡 Place the product on a shiny surface, the front will be the lightest',
  x_9cf1afed: 'Focusing, hold steady for ~1 second',
  x_77abc2a1: '👇 Choose which one to keep',
  x_2d86ed95: 'Use original',
  x_82fc4841: 'Starting camera...',
  x_8df3213a: 'Use AI version',
  x_781f0d75: 'Retake',
  x_dd740dc5: 'The two co-owners receive the bills equally. AI automatically sends detailed sales reports to both bosses via WhatsApp on a daily or monthly basis.',
  x_2eb1e982: '📅Diary',
  x_d5ac2190: '📆Monthly Monthly',
  x_b5c8b0a2: 'Professional',
  x_3706b4d0: 'Friendly',
  x_e366ccf1: 'settings',
  x_0a9c8842: 'Preview',
  x_c7db6d4f: 'restore',
  rider_reset_pw: 'Reset password',
  rider_navigate_btn: 'Navigate',
  rider_navigate_addr: 'By address',
  rider_forgot_hint: 'Forgot your password? Ask the shop owner to reset it under Riders',
  x_5fb1fd09: 'QR Poster',
  x_aba55e6b: 'Scan link:',
  x_6f7fff38: 'Download PNG',
  x_bc96a998: 'Configuration',
  x_4fc91b55: 'Scan and buy easily',
  x_c154a693: 'Printers Manual',
  x_6b78e860: 'Install QZ Tray',
  x_75688f20: 'Configure Printers',
  x_12ee3d19: 'Print Flow',
  x_90167330: 'Frequently Asked Questions',
  x_433baf5e: 'Download',
  x_27db0784: 'Download Certificate',
  x_5482983f: '🔥Active for 30 days',
  x_01b2a86b: '🎂 Today\'s birthday',
  x_6810ae91: '📱 Export CSV customer list → Import',
  x_59556b40: 'Mark Allsent',
  x_1535fcfa: 'send',
  x_b1731af3: 'Export CSV for WhatsApp Business',
  x_58f4fc4b: 'APP → Create Broadcast List (256 people at a time) → Mass Promotion/Birthday',
  x_28cfe557: 'Reserved for now',
  x_23532881: 'new merchandise',
  x_ed3046c5: 'Create and add to purchase order',
  x_71e9bba3: 'Delete (permanently delete)',
  x_846e5470: 'Hidden (file retention logs)',
  x_a9818765: 'Methods without points',
  x_e1d9e1d6: 'Biopayment.',
  x_00155faf: 'Generate my referral code',
  x_040f51a6: 'copy code',
  x_879058ce: 'Copy link',
  x_db07affa: 'Resetting negative inventory to zero',
  x_8f9b2023: 'Delete items without cost price',
  x_07c8a48c: 'WhatsApp self-service connection (free/unlimited shipping)',
  x_ed2be317: 'Scan the QR code once to permanently mount your WhatsApp account on the Sellox system. Send automatic messages to all customers/employees without joining.',
  x_8277b145: 'After turning it on, if the customer has a mobile phone number + has subscribed to WhatsApp notifications during checkout,',
  x_301c285f: 'Cashiers no longer need to manually click on wa.me.',
  x_4fa7c9cc: 'Avoid harassing the same person every day.',
  x_fdbb8738: '⚙️Range 1-60 days. Recommendation: 3 days for small groups of clients, 7 days for normal clients, 14-30 days for large clients.',
  x_bbe42801: '🔒 Each screenshot will deduct 1 AI voucher independently; Repeated sending of the same image within 5 minutes will be automatically ignored.',
  x_9eba1d0b: 'The QR code is automatically updated every 25 seconds; Don\'t worry about not being able to scan it.',
  x_a3ac5646: 'Assembled:',
  x_5319c74b: 'it will be in 30 seconds',
  x_78623eae: 'every day',
  x_b036b784: 'same client',
  x_2ee44035: '💡 For example, suppose',
  x_ef49a64e: 'The customer took a screenshot of the transfer.',
  x_676ea371: 'It will also automatically reply to the customer "✅ Payment confirmed / order confirmed".',
  x_69893eef: '💡 In this case, when the exact matching order cannot be found after AI recognition, the voucher will be recorded in the store\'s "Payment Verification" list for the employee to process manually.',
  x_1b037636: 'Connection',
  x_771d235b: '🎂Festival/birthday marketing',
  x_75c856b1: 'Sign out',
  x_2abe9e2c: 'Electronic receipt link —',
  x_2b9efa91: 'Currently closed: the effect will take effect immediately after being activated',
  x_acabef73: 'Automatically scan all credit records - Give',
  x_e30c7cd7: 'of customers send reminders via WhatsApp.',
  x_5a445658: ', it will not bother you repeatedly. Also available in',
  x_95de8c70: '"Manual claim with a single click on the page.',
  x_8ee2848b: ', AI automatically identifies the reference number/amount,',
  x_53eb1951: 'Orders pending in the last 48 hours and marked as paid,',
  x_01276a67: 'Industry',
  x_60624b98: 'Clean up orphaned inventory',
  x_1c74acdb: 'Complete inventory records',
  x_01702b13: 'Delete all orders (dangerous)',
  x_fcc3d39a: 'Automatic repair',
  x_be0ade04: 'Reconstruction index',
  x_fd76118e: 'Export backup data',
  x_aac9e1d1: 'AI Credits Top-up',
  x_a8fc5824: 'Set the cost price in product management and check it again.',
  x_67c6118c: 'BCV',
  x_a2084b07: 'Threshold',
  x_66bfebe7: 'Boss Phone',
  x_c0d5d68f: 'ignore',
  x_e38cac91: 'Reopen',
  x_842010db: 'F11',
  x_a24983d8: '📞Customer Service WhatsApp (required)',
  x_48912e07: '🪙 USDT (stablecoin, globally accepted)',
  x_1d7f3562: '🧩 Other payment methods (Wise/Zelle/Binance Pay...)',
  x_bad080e4: '📍 After switching to the clothing store, you can complete the size/color variants on the product edit page.',
  x_7f9f889d: 'When enabled, the restaurant\'s POS cashier will **automatically** add an X% service fee after the subtotal at checkout.',
  x_9dad4122: 'The cashier can cancel a single transaction. The customer\'s receipt will also show this line.',
  x_47bd55cf: 'If you already have product categories, it is recommended to use "',
  x_7b6d74a4: '📍 After switching to the restaurant, "🍽️ Table Management" will appear in the left menu.',
  x_78841a5c: 'Changing industries** only adds categories** and will not delete your existing products/categories.',
  x_6c525ddf: '”And then use only the features you need (like restaurant tables).',
  x_8d63ef38: 'pause',
  x_e7c3bc5c: 'The rider completes the store code upon registration.',
  x_7037508b: '💡 Ranking rules:',
  x_23c1f399: 'Pass',
  x_7173f809: 'reject',
  x_a5978c43: '(or your tenant ID), you will see "pending review" on this page and he can accept the order after approving it.',
  x_70f983d4: 'Use current location (click here in store)',
  x_13e8fee8: '· The closer + the freer, priority is given ·',
  x_929fc89b: 'AI message style:',
  x_144db44b: 'AI reminder',
  x_9d6f026a: '📖 First time using it? Click here to see the full setup tutorial',
  x_7bd0aecf: 'Cost: ~$0.01/item (Meta Cloud API, 24+ hour service window)',
  x_9fe61acb: 'After closing, the employee can still manually click the [WhatsApp] button to submit in the "Order Completed" pop-up window.',
  x_1dcf3bf4: 'Copy the following two values to the Meta Webhook page (left menu',
  x_a4e7978d: 'Conditions: ① The boss checks this switch ② WhatsApp has been configured and enabled ③ The client has created a profile + has a mobile phone number ④',
  x_defd4e63: '→ Check three permissions:',
  x_31aadde4: 'Fill out the card:',
  x_922a7731: 'automatic response',
  x_85849d21: 'Automatic receipt',
  x_83413c5e: '— Just check it when you go to Customer Management/Create a new customer.',
  x_88b8d068: 'Print report',
  x_88ae41b0: 'Inventory by size & color',
  x_1af9ab5b: '🔗 Connect client files with one click',
  x_0563df42: 'Recharge with USDT (TRC-20)',
  x_6ae048ae: 'Cancel',
  x_6503c16e: 'Supports USDT TRC-20 (very low handling fee) Automatically credited to account about 1-2 minutes after payment No KYC',
  x_3eb35747: 'Status:',
  x_90ef892d: 'Copy Address',
  x_4f8d48ef: 'update status',
  x_5b9fc057: 'Alternative payment page',
  x_c4ab90ae: 'whatsapp tracking',
  x_f1d9634a: 'open WhatsApp',
  x_81930d76: 'Purchase activated:',
  x_69774c73: 'Copy address',
  x_84f49b2a: 'Annual Maintenance',
  x_1ecf95c4: 'Invoice Photo',
  x_075b05f1: 'Update sale price →',
  x_1d447944: 'take an order',
  x_ae765162: 'Choose your plan · USDT TRC-20',
  x_b610fd7a: 'Current Subscription',
  x_04a54e6d: '✅ Everything synchronized',
  x_f9885395: 'tasks rejected by the server',
  x_4606c263: '— ⚠️ These operations had no effect! Please see the reasons below: It needs to be corrected, re-operated, and discarded after confirming that it is useless.',
  x_2395acb4: '🗑️ Discard all failed ones',
  x_8dd7df98: 'Any modifications you make offline (add products, credit, inventory, etc.) will automatically appear here and will be automatically uploaded when the network is restored.',
  x_a1ef1534: 'dollar value',
  x_70f80ce3: '🎂 Available today',
  x_5248ea19: 'A birthday boy!',
  x_49bc061f: 'Client:',
  x_e6c8ab7b: 'use this template',
  x_115028a6: 'Automatic birthday wishes',
  x_ae8e4235: 'Preview today',
  x_bb4c3061: 'Send now today',
  x_f45f7f98: 'Holiday/Promotion Bulk Shipping',
  x_8e4d1d3b: 'Preview of the number of people',
  x_acac71c9: 'No account? Sign up',
  x_b7074575: '← Login again',
  x_7f8fb4ff: '⚠️ After registration, you must wait for the store owner to approve it in the background before you can start receiving orders. Be patient and wait about 30 minutes.',
  x_1c88cdf2: 'Your registration has been received. Once the store owner approves the order, you will be able to view and receive it. Generally 5 to 30 minutes, please be patient.',
  x_f0d22726: '📋 Available to take away',
  x_3d0cf184: '🛵 Delivering',
  x_24eee8a8: '👤 mine',
  x_79646591: 'There are no new orders at this time, please wait and update again.',
  x_7957b16f: 'Accept',
  x_2f3b0a05: 'Pass',
  x_350d4758: 'Take order',
  x_edc9f0b4: 'No orders yet',
  x_6cb26531: 'I picked up order',
  x_26407f6e: 'Start delivery',
  x_285135ae: '✅ Delivered, payment completed',
  x_3f53cc4a: 'After registration, the store owner must approve it before you can accept orders.',
  x_4a566f8e: 'Navigate with Google Maps',
  x_e33fe8b5: 'Sign out',
  x_52dc2f55: 'Sign in',
  x_d839dff6: 'AI verifying...',
  x_70654539: 'You are not yet a member of our store. Fill out the following form',
  x_ae1f9579: 'Sign up for free and start accumulating points immediately for your next purchase 🎁',
  x_295a203d: 'Register for free Free registration',
  x_3e869d4a: 'No schedule this week',
  x_c7a3ad5d: 'Account up to date',
  x_fa9a9ed5: 'Forgot your password?',
  x_5dac1074: 'Place the product on a light background · Best taken on a bright background',
  x_b2d24a53: '👇 Choose which version to use',
  x_ab4a66f9: 'Use original',
  x_cd32a3bc: 'Take photo',
  x_d978ee93: 'Use improved ✨',
  x_ad7db97f: 'take another',
  x_757bfeeb: 'Tracking',
  x_b01f7e91: 'Match yourself with the nearest cyclist... Generally 1-3 minutes',
  x_f2dec5f3: 'Updates every 5 sec',
  x_c1558ab2: 'Proof',
  x_b426bb47: '⚠️ This version must be updated to continue using it',
  x_f26ef914: 'Download',
  x_4ddef578: 'Direct download',
  x_2905f1e3: 'Add',
  x_fa8d0ac2: 'Reset',
  x_cf5fddcb: '💡 points',
  x_4bf93975: '⋮ Long press or the small icon in the upper right corner:',
  x_1f15f435: 'Table: Transfer the order for this table to the shopping cart.',
  x_d432ce48: 'Show $USD',
  x_910a7387: 'Show Bs.',
  x_fdf6f7f6: 'display name',
  x_37c233bc: 'Screen specifications',
  x_b8da42c6: 'Code',
  x_eaeef91b: 'labels',
  x_288f0c40: 'Delete',
  x_e429696c: 'Print',
  x_61a0eed9: '🏷️ Create Aparta',
  x_bcc9eb9f: 'ℹ️ Deduct inventory immediately after creation and WhatsApp will automatically send receipts to customers',
  x_13b83977: 'Client Signature',
  x_2fe011c2: 'Credit Agreement',
  x_7c82e213: 'The client has read and accepts the terms',
  x_ba00b607: 'Advance',
  x_4d28eb40: '🔄 Update',
  x_28a2f60d: '📨 Allow WhatsApp notifications (receipts + birthday wishes)',
  x_5698e78f: 'Early Cash Drop',
  x_c052324e: 'Expiration:',
  x_e56c9982: 'Confirm payment',
  x_386c1cb4: 'Cancel order (restore inventory)',
  x_e6a96594: '💡 This is a "separate receipt" for customers - the actual payment will be settled based on the total price.',
  x_eb695f9f: 'Everything uploaded',
  x_ba769ad1: '← Back',
  x_50d1e443: '⏳Online payment is opening. Please come up',
  x_9747fec8: 'After payment, send the screenshot to WhatsApp customer service → Activate your Sellox account in 30 minutes ✅',
  x_d6e0b32d: 'Contact customer service to complete your purchase and activate your account within 30 minutes.',
  x_2070ff11: 'Scan barcode',
  x_a9cebdd2: 'Point the barcode at the camera',
  x_0e626263: '💡 Scan barcode with USB barcode gun → input box will auto populate + enter automatically',
  x_b779b5fc: 'Just fill in the name + price manually. Clicking “Use this barcode” will pre-populate the barcode fields and AI can help you generate product images.',
  x_1ee3ff57: 'Camera',
  x_5f78052a: 'Manual entry/barcode gun',
  x_c600be33: 'Variants Size × Color',
  x_0c240da9: '⚠️ Generation will overwrite existing variants (size/color will be automatically migrated if inventory data remains unchanged)',
  x_443da31a: 'Step 1: Enter the size and color (use commas',
  x_e0baad05: 'separated), click "Generate" to create the combination',
  x_fc14f592: 'Recover password',
  x_2a86dd91: '← Change number',
  x_49f38495: 'Sign in',
  x_ffcd6690: 'Some features (such as offline payment, PWA installation, QR code scanner, etc.) may not work. It is recommended to update to the following browsers:',
  x_a415f6c2: 'UI Error',
  x_d470d3d3: 'The screen crashed. The sale MAY NOT be recorded! Click Close, check Recent orders for this sale and re-charge if it is missing.',
  x_8d2f4bdd: 'Dismiss',
  x_5428abef: 'Reload',
  x_f1a0be3e: 'View history/set thresholds',
  x_fix_shop_confirm: 'Click the "Confirm order" button below',
  x_fix_bosspin_3: '3. Modification actions (price/void/inventory/collection) will reply "Boss PIN required".',
  x_fix_profit_warn: ', profit calculation is inaccurate (shown as "?").',
  x_fix_intlpay_empty: 'Not added yet. Click "Add" at the top right to add any method (Wise/Revolut/Zelle/Binance Pay/Pix/Western Union, etc.)',
  x_fix_rider_flow: 'New order → system picks the nearest free rider → 60s to confirm → passes to next if declined → returns to "manual dispatch" only if all decline',
  x_fix_rider_gps: 'Rider needs a GPS heartbeat within 5 minutes to count as "online"',
  x_fix_super_outbox: 'Clicking "Send" adds to Outbox and opens WhatsApp Web/App; just press the ➤ arrow.',
  x_fix_pin_lock: '5 failed attempts = 15 min lockout',
  x_fix_none: '—',
  x_fix_agotado_tip: '• If the system shows "OUT OF STOCK" but there is physical stock → go to ',
  x_fix_days_remind: 'days before reminding again.',
  x_fix_rider_fee_example: '💡 E.g.: base $1.0 + $0.3/km, 5 km → delivery $1 + $0.3×5 =',
  x_fix_all: 'All',
  x_fix_wa_reply_tip: 'When received, reply "report" on WhatsApp → the AI answers with real data 🎉',
  x_fix_usdt_note: 'USDT TRC-20 supported (minimal fees) · Subscription extends automatically on confirmation · 1 month = 30 days · No KYC',
  x_fix_apk_download: 'Clicking "Download" opens the browser to get the new APK',
  x_fix_shift_prefill: '💡 The system "expected amount" is pre-filled. Only edit the line that differs from your actual count (usually cash).',
  x_fix_added_expected: '(added to the "expected amount")',
  x_fix_usb_scanner_tip: '💡 USB barcode scanners also use "keyboard" mode',
  x_m0: '',
  x_m1: 'January',
  x_m2: 'February',
  x_m3: 'March',
  x_m4: 'April',
  x_m5: 'May',
  x_m6: 'June',
  x_m7: 'July',
  x_m8: 'August',
  x_m9: 'September',
  x_m10: 'October',
  x_m11: 'November',
  x_m12: 'December',
  x_fix_all_stores: 'All stores',
  next: 'next',
  priceEdited: 'Price changed',
  noProducts: 'Product not found',
  spec: 'Specifications',
  cedula: 'Identification number Card',
  goToAdmin: 'Go to Admin Panel',
  switchAccount: 'Change account',
  refresh: 'Update',
  addPayment: 'add payment',
  editPayment: 'Change payment',
  transfers: 'Transfer and receive goods.',
  submitting: 'Sending...',
  marginPercent: 'profit margin',
  autoCalcPrice: 'The system automatically calculates the price.',
  taxRate: 'tax rate',
  pendingTransfers: 'Goods transfer order to receive',
  noTransfers: 'There is no transfer order to receive',
  saved: 'bran',
  scheduleTemplates: 'Shift template',
  new: '+ New',
  weeklySalaryEstimate: 'weekly salary estimate',
  morningShift: 'tomorrow',
  afternoonShift: 'afternoon',
  off: 'hugo',
  clickToToggle: 'Click on the grid to scroll through it',
  noPermission: 'without permission',
  invalidPrice: 'Please enter a valid price',
  noNewKitchenItems: '✅ The order has been placed (no new plates, no printed ones)',
  addCustomerSuccess: 'Client successfully added',
  quickPriceTooltip: 'Quick sale: directly enter the price (cigarettes/bags/bulk products)',
  quickSell: 'Quick Sale',
  quickSellHint: 'Products without barcodes: cigarettes/bags/bulk goods, etc., enter the price directly to add to shopping cart',
  priceInCurrency: 'Price',
  itemNameOptional: 'name (optional)',
  itemNamePlaceholder: 'For example: Cigarette/Cigar/Bag',
  barcodeNotFound: 'The barcode does not match the product.',
  creating: 'Creating...',
  reprintReport: 'Reprint the report',
  customers: 'Client',
  equivalent: 'equivalent',
  summary: 'Summary',
  orderDetails: 'Product details',
  deleteProductWarning: 'Note: Removing products will affect all branches!',
  confirmResequence: 'Are you sure you want to recode all products sorted by name? (01, 02, 03...)',
  labelPaperSize: 'label paper',
  salary: 'Salary ($)',
  x_fix_iva_enabled: 'VAT (IVA) enabled',
  x_fix_iva_included: 'VAT included in price',
  x_fix_igtf_label: 'IGTF 3% — foreign currency (USD) payments',
  x_fix_min_salary_note: 'Current minimum wage per Official Gazette. Used in the monthly pay slip (LOTTT Art. 106).',
  x_fix_404: 'Page not found',
  x_fix_404_home: '← Back to home',
  einv_menu: 'E-Invoice',
  einv_title: 'Electronic Invoice (SENIAT)',
  einv_subtitle: 'Digital invoicing readiness — fiscal profile, IVA and export',
  einv_tab_profile: 'Fiscal Profile',
  einv_tab_invoices: 'Invoices',
  einv_tab_health: 'Health Check',
  einv_tab_export: 'Export',
  einv_rif: 'RIF',
  einv_razon: 'Legal Name',
  einv_address: 'Fiscal Address',
  einv_phone: 'Phone',
  einv_taxpayer: 'Taxpayer Type',
  einv_taxpayer_ordinario: 'Ordinary',
  einv_taxpayer_especial: 'Special Taxpayer',
  einv_apply_iva: 'Add IVA at checkout (tax-exclusive prices)',
  einv_apply_iva_hint: 'When enabled: POS adds IVA (16%/8% per product) to the total at payment time.',
  einv_saved: 'Fiscal profile saved',
  einv_not_enabled_title: 'Pilot module',
  einv_not_enabled_desc: 'Electronic invoicing is in preparation. Contact Sellox to join the pilot.',
  einv_run_health: 'Run health check',
  einv_profile_missing: 'Missing profile fields',
  einv_orders_total: 'Invoices in period',
  einv_orders_ready: 'E-invoice ready',
  einv_missing_rif: 'Missing customer RIF/ID',
  einv_missing_fiscal: 'Missing fiscal number',
  einv_products_no_tax: 'Products without tax rate',
  einv_ready_pct: 'Readiness',
  einv_invoice_no: 'Invoice',
  einv_control_no: 'Control No.',
  einv_date: 'Date',
  einv_customer: 'Customer',
  einv_customer_rif: 'RIF/ID',
  einv_total: 'Total',
  einv_iva_col: 'IVA',
  einv_status_ready: 'Complete',
  einv_status_incomplete: 'Incomplete',
  einv_pos_rif: 'RIF / ID for invoice (optional)',
  einv_load: 'Load',
  einv_export_hint: 'Export period invoices in SENIAT-ready format (XML / CSV / JSON).',
  einv_none: 'No invoices in period',
  einv_ok_all: 'All set — fiscal profile complete',
  wa_connect_mine: 'Connect my own WhatsApp',
  wa_connect_started: 'Starting session — QR will appear in a few seconds…',
  wa_channel_title: 'Sending channel',
  wa_channel_platform_title: 'Sellox platform number (recommended for new stores)',
  wa_channel_platform_desc: 'No QR scan — receipts and notices are sent from the official Sellox number with a "do not reply" note',
  wa_channel_own_title: 'Your own number (scan QR below)',
  wa_channel_own_desc: 'Customers see YOUR number and can reply (AI seller available)',
  wa_channel_meta_title: 'Official Meta API (never blocked)',
  wa_channel_meta_desc: 'Connect your own Meta Business account — step-by-step guide included',
  wa_channel_configure: 'Configure →',
  wa_channel_on: '✅ Platform channel enabled',
  wa_channel_off: '✅ Using your own number',
  wa_relay_usage_month: '📊 This month: {n} messages sent',
  qs_assigned: 'Assigned',
  qs_paid: 'Paid',
  qs_due: 'Due',
  qs_hint: '💡 Type the amount on each method, 2+ boxes = split payment',
  qs_missing: 'Missing',
  qs_change: 'Change',
  wa_not_connected: 'Not connected (scan to link your number)',
  wa_platform_fallback: 'Messages currently go out via the Sellox platform number. Connect your own number so customers see your store\'s WhatsApp.',
  wa_own_number_hint: 'Each business can link its own WhatsApp number — scan once, stays mounted.',
  sx_cost: 'Cost',
  sx_taxable_base: 'Taxable Base',
  sx_exempt: 'Exempt (No VAT)',
  sx_iva: 'VAT (IVA)',
  sx_total: 'TOTAL',
  sx_gravado_sales: 'Taxed Sales',
  sx_exento_sales: 'Exempt Sales',
  sx_iva_due: 'VAT due (16%)',
  sx_tax_card_title: 'VAT / Tax summary',
  sx_pkg_title: 'Session Packages',
  sx_pkg_new: 'New package',
  sx_pkg_defs: 'Package definitions',
  sx_pkg_sold: 'Sold packages',
  sx_pkg_sell: 'Sell to customer',
  sx_pkg_redeem: 'Redeem 1 session',
  sx_pkg_left: 'Left',
  sx_pkg_times: 'sessions',
  sx_pkg_name_hint: 'Name (e.g. Haircut x10)',
  sx_pkg_sessions: 'Sessions',
  sx_pkg_price: 'Price $',
  sx_pkg_days: 'Valid days',
  sx_pkg_customer: 'Customer',
  sx_pkg_paymethod: 'Payment method',
  sx_pkg_confirm: 'Confirm sale',
  sx_pkg_none: 'No packages yet',
  sx_pkg_sold_none: 'No sold packages yet',
  sx_menu_packages: 'Session packages',
  sx_note_no_spicy: 'No spicy',
  sx_note_no_sauce: 'No sauce',
  sx_note_egg: 'Add egg',
  sx_note_well_done: 'Well done',
  sx_note_less_salt: 'Less salt',
  sx_note_no_cheese: 'No cheese',
  sx_usd_toggle: '💵 USD payments',
  sx_cashier_price_switch: '🔓 Cashier can switch price (P1/P2/Box)',
  sx_usd_off_info: 'POS will hide USD mode; only Bs checkout (BCV rate still shown as reference)',
  sx_cashea_pct: 'Cashea surcharge %',
  sx_cashea_pct_hint: 'Added to the total when paying with Cashea (0 = none)',
  sx_variant_pick: 'Choose option (size/color/flavor)',
  sx_recargo: 'surcharge',
  sx_customer: 'Customer',
  sx_subtotal: 'Subtotal (excl. tax)',
  sx_discount: 'Discount',
  sx_promo: 'Promo',
  sx_promo_incl: 'already in unit price',
  sx_cost_usd: 'Cost $',
  sx_cost_bs: 'Cost Bs',
  sx_profit: 'Profit',
  sx_sales_summary: 'Sales Summary',
  sx_loading_orders: 'Loading orders, please wait…',
  sx_loss_alert: 'Selling at loss',
  sx_stale_alert: 'Stale price',
  sx_loss_hint: 'Net price (after IVA) is below cost',
  sx_stale_hint: 'Bs price uses an old rate or not updated for 30+ days',
  sx_net_price: 'Net (no IVA)',
  sx_loss_each: 'Loss each',
  sx_current_bs: 'Current Bs',
  sx_expected_bs: 'Expected Bs',
  sx_days_no_update: 'Days stale',
  sx_reason_rate: 'old rate',
  sx_reason_old: 'not updated',
  sx_production_date: 'Production date',
  sx_expiry_alert: 'Expiring soon',
  sx_expiry_hint: 'Expires within 30 days or already expired',
  sx_days_left: 'Days left',
  sx_expired: 'Expired',
  sx_batch_expiry: 'Batch expiry',
  sx_export_products: 'Export Excel',
  sx_payment_breakdown: 'Payment Breakdown',
  sx_orders_count: 'Orders',
  sx_items_count: 'Items',
  sx_total_bs: 'Total Bs',
  sx_cash_usd: 'Cash $',
  sx_cash_bs: 'Cash Bs',
  sx_avg_ticket: 'Avg ticket',
  sx_gravado: 'Taxable',
  sx_exento_short: 'Exempt',
  sx_subtotal_short: 'Subtotal',
  sx_tax_total: 'Total tax',
  sx_pay_total: 'Total due',
  sx_printer_default: 'Default printer',
  sx_fiscal_machine: 'Fiscal machine',
  sx_fiscal_already: '🧾 This order was already fiscalized — cannot duplicate',
  sx_fiscal_done: 'Fiscalized',
  sx_fiscal_desktop_only: 'Fiscal machine only available in the desktop app (COM)',
  sx_pretax: 'Pre-tax',
  sx_customer_display: 'Customer display',
  sx_ws_mode: 'Wholesale mode (B2B)',
  sx_ws_mode_desc: 'When enabled: shop visitors cannot see prices; customers must register and be approved by you (Wholesale toggle in Customers). Orders by dozen/pack.',
  sx_ws_locked: 'Prices visible to registered wholesalers only',
  sx_ws_apply: 'Apply for wholesale account',
  sx_ws_pending: 'Your wholesale account is under review. Prices unlock once approved.',
  sx_ws_pending_badge: 'Pending approval',
  sx_ws_moq: 'Min. order',
  sx_ws_moq_hint: 'Default MOQ (dozen); product box quantity overrides it',
  wsx_zone: 'Wholesale Zone',
  wsx_go_retail: 'Go to retail store',
  wsx_go_mayor: 'Wholesale entrance',
  wsx_closed_retail_title: 'Wholesale only',
  wsx_closed_retail_sub: 'The retail store is closed. Please enter the wholesale zone.',
  wsx_closed_mayor_title: 'Wholesale not available',
  wsx_closed_mayor_sub: 'This store does not accept wholesale orders yet. Visit the retail store.',
  wsx_tier_ge: '≥{n} pcs',
  wsx_mix_hint: '✨ Mix & match: combine styles to reach {n} pcs total for wholesale pricing',
  wsx_mix_need: '{n} pcs short of the mix-batch minimum',
  wsx_mix_ok: 'Mix-batch minimum reached',
  wsx_mix_progress: 'Mix-batch progress',
  wsx_vip_badge: 'VIP price -{n}%',
  wsx_moq_multi: 'Min {n} pcs, in multiples of {n}',
  wsx_moq_min: 'Min {n} pcs',
  wsx_settings_title: 'Online Wholesale Shop (B2B)',
  wsx_tab_orders: 'Orders',
  wsx_tab_salesmen: 'Salesmen',
  wsx_tab_settings: 'Settings',
  wsx_terms_title: 'Credit terms & discount (online wholesale orders)',
  wsx_terms_hint: 'Customer picks a term at checkout. Positive % = discount, negative = surcharge (e.g. 15 days -3%)',
  wsx_terms_days: 'days',
  wsx_terms_pct: '% disc.',
  wsx_terms_add: 'Add term',
  wsx_retail_toggle: 'Retail shop',
  wsx_ws_toggle: 'Wholesale shop (/mayor)',
  wsx_copy_link: 'Copy link',
  wsx_link_copied: 'Link copied',
  wsx_default_moq: 'Default MOQ (pcs)',
  wsx_retail_ws_qty: 'Retail shop wholesale qty (global)',
  wsx_retail_ws_qty_hint: '0 = off; per-product qty takes priority',
  sx_boss_confirm: '✔ Confirm',
  sx_boss_confirm_ask: 'Confirm this payment was verified? It will move to the green section',
  wsx_mix_enable: 'Allow mix-batch (combine styles)',
  wsx_mix_min: 'Mix-batch total minimum (pcs)',
  wsx_vip_pct: 'VIP extra discount %',
  wsx_ai_desc: 'A customer asks on WhatsApp "Do you have Harina PAN? How much?" — the AI checks stock, quotes, records the purchase intent and replies (in Spanish). Each reply uses 1 AI credit.',
  wsx_ai_setup: 'First connect your store WhatsApp by scanning the QR (green card above). When the customer confirms, the AI creates a held order — press F10 at the register to charge it.',
  wsx_ai_store: 'Order store (where AI-taken orders are saved)',
  wsx_ai_store_auto: 'Automatic (first store)',
  wsx_ai_extra: 'Extra store info (hours / delivery / payment methods — the AI will use it when replying)',
  wsx_ai_kb: 'AI knowledge base (FAQ / store rules / returns policy / what NOT to say — the AI follows it to the letter)',
  wsx_ai_kb_ph: 'E.g.\nQ: Do you deliver? A: Free in Caracas from $20; other areas by distance.\nQ: Credit? A: Only known customers with owner approval.\nNever promise arrival dates; no discounts; never mention competitors.',
  wsx_ai_lead_phone: 'Partner / supplier lead phone',
  wsx_ai_lead_hint: 'When someone writes about partnership, integration, API or is a supplier, the AI stops selling and forwards the message to this number (empty = order-notification number)',
  wsx_ai_save: 'Save info',
  wsx_ai_chats_view: 'View AI chats',
  wsx_ai_chats_hide: 'Hide chats',
  wsx_ai_chats_none: 'No AI chats yet',
  wsx_ai_msgs: 'msgs',
  wsx_ai_on: 'Enabled',
  wsx_ai_enable: 'Enable',
  wsx_cr_l1: 'Every day at 9:30 AM all credit records are scanned and a WhatsApp reminder is sent to customers overdue or due within 3 days.',
  wsx_cr_int_pre: 'Each customer gets at most 1 reminder every ',
  wsx_cr_int_post: ' days — no repeated nagging. You can also collect manually on the /admin/credits page.',
  dlv_enforce_max: 'Block orders out of range',
  dlv_enforce_max_hint: 'When on, customers beyond the max delivery distance cannot order (requires sharing location)',
  dlv_map_hint: '🗺️ Coverage map — click the map to set your store location',
  dlv_map_legend_max: 'Max delivery range',
  dlv_map_legend_free: 'Free shipping',
  sh_week_hint: 'Per-day hours (e.g. Sunday half-day or closed); unset days use the default hours above',
  sh_mode_default: 'Default hours',
  sh_mode_custom: 'Custom',
  sh_mode_closed: 'Closed',
  sh_day_mon: 'Monday', sh_day_tue: 'Tuesday', sh_day_wed: 'Wednesday', sh_day_thu: 'Thursday', sh_day_fri: 'Friday', sh_day_sat: 'Saturday', sh_day_sun: 'Sunday',
  pl_mode_p1: 'P1 (Retail)', pl_mode_p2: 'P2 (Wholesale)', pl_mode_p3: 'P3 (Bulk)',
  pl_mode_p1p2: 'P1 + P2', pl_mode_cashea: 'P1 + Cashea', pl_mode_box: 'P1 + Box', pl_mode_p1p2box: 'P1 + P2 + Box', pl_mode_p1p3: 'P1 + P3', pl_mode_all: 'All 3 prices',
  pl_instock: 'In stock', pl_all: 'All', pl_clear: 'Clear',
  wsx_save_ok: 'Wholesale settings saved',
  wsx_tiers_btn: 'Tier pricing',
  wsx_tiers_title: 'Tiered wholesale prices',
  wsx_tiers_sub: 'E.g. ≥12 pcs $5.00, ≥48 pcs $4.50, ≥144 pcs $4.00. Empty = uses P2 price. First tier qty = product MOQ.',
  wsx_tier_qty: 'Qty ≥',
  wsx_tier_price: 'Price $',
  wsx_tiers_saved: 'Tier prices saved',
  wsx_tier_manage: 'Set product tier prices',
  wsx_search_product: 'Search product to set tier prices...',
  wsx_catalog_btn: 'PDF catalog',
  wsx_catalog_with: 'With prices (approved clients)',
  wsx_catalog_without: 'Without prices (lead magnet)',
  wsx_catalog_note: 'Register as wholesaler to see prices and order',
  wsx_vip_toggle_on: 'Customer upgraded to VIP wholesaler',
  wsx_vip_toggle_off: 'VIP removed',
  wsx_guide_title: '📖 How does the wholesale shop work? Open tutorial',
  wsx_guide_1: '1️⃣ Turn on the "Wholesale shop" switch and share the /mayor link in your WhatsApp groups. Retail and wholesale share products and stock; each entrance can be toggled separately.',
  wsx_guide_2: '2️⃣ Default "No approval": customers register (name + phone) and can immediately see prices and order — ideal for regular credit customers. To control who sees prices, disable it and approve manually in Customers.',
  wsx_guide_3: '3️⃣ Set tier prices: bigger qty = lower unit price (e.g. 12 pcs $5 / 48 pcs $4.5 / 144 pcs $4). Products without tiers use the P2 price.',
  wsx_guide_4: '4️⃣ Minimums: with tiers, the first tier is the MOQ; otherwise box quantity or default MOQ applies, in multiples (12, 24, 36…).',
  wsx_guide_5: '5️⃣ Mix-batch for small buyers: when enabled, they can combine styles to reach the total minimum (e.g. 36 pcs) with no per-style minimum.',
  wsx_guide_6: '6️⃣ VIP customers: enable VIP in Customers to give them an extra % off wholesale prices.',
  wsx_guide_7: '7️⃣ Generate the PDF catalog: "no prices" version for lead-gen in groups, "with prices" version for approved clients.',
  wsx_guide_8: '8️⃣ Orders arrive in "Online Orders"; print A4 wholesale invoices. Credit-approved customers can order on credit with automatic WhatsApp due reminders.',
  wsx_hot_title: 'Wholesale hot sellers',
  wsx_hot_sold: '{n} pcs in 7 days',
  wsx_auto_approve: 'No approval (register = see prices & order)',
  wsx_pedido_nopay: 'Order without payment (Pedido)',
  wsx_pedido_nopay_hint: 'Customers submit the pedido without paying or reserving stock; print the A5 for picking, stock is deducted on confirmation and the detail is sent to the customer WhatsApp',
  wsx_salesman: "Salesman's WhatsApp (wholesale orders auto-pushed)",
  wsx_wa_target: 'WhatsApp number or group ID',
  wsx_send_with: 'Send catalog with prices',
  wsx_send_without: 'Send catalog without prices',
  wsx_sent_ok: 'Sent via WhatsApp',
  wsx_send_fail: 'Send failed — check WhatsApp connection',
  wsx_size_mix: 'Size mix (e.g. S*4 M*4 L*4)',
  wsx_statement: 'Account statement',
  wsx_only_left: 'Only {n} left!',
  wsx_load_groups: 'Load WhatsApp groups',
  wsx_pick_group: 'Pick group',
  wsx_groups_fail: 'Failed — check WhatsApp connection',
  wsx_salesman_multi: "Salesmen's WhatsApp (multiple, comma-separated)",
  wsx_sm_title: 'Salesmen & Commissions',
  wsx_settle_pdf: 'Settlement PDF',
  wsx_settle_send: 'Send settlement (WhatsApp)',
  wsx_settle_sent: 'Settlement sent ✓',
  wsx_sm_enable: 'Enable commissions',
  wsx_sm_add: 'Add salesman',
  wsx_sm_name: 'Name',
  wsx_sm_pct: 'Commission %',
  wsx_sm_link: 'Personal link',
  wsx_sm_customers: 'Customers',
  wsx_sm_orders: 'Orders',
  wsx_sm_sales: 'Sales $',
  wsx_sm_collected: 'Collected $',
  wsx_sm_comm_sales: 'Commission (sales)',
  wsx_sm_comm_coll: 'Commission (collected)',
  wsx_sm_none: 'Unassigned',
  wsx_sm_unassigned: 'Orders without salesman',
  wsx_sm_saved: 'Saved',
  wsx_sm_hint: "💡 Share each salesman's personal link: customers who register through it are assigned to him (you can also assign manually in Customers). His customers' orders are pushed only to him.",
  wsx_wechat_copy: 'WeChat / other apps:',
  wsx_copy_with: 'Copy text with prices',
  wsx_copy_without: 'Copy text without prices',
  wsx_copied: 'Text copied — paste it into the group and send',
  wsx_color_theme: 'Online shop color theme',
  wsx_color_hint: 'Pick and save — retail and wholesale shop colors change instantly',
  x_nosalary_prompt: '⚠️ This employee has no salary configured, so the deduction cannot be calculated automatically.\nEnter the amount to deduct ($USD). Cancel = do not record debt:',
  x_nosalary_skipped: 'No debt recorded. Tip: set the employee salary in "Employees" to auto-calculate absence deductions',
  x_free_label: 'FREE',
  x_credits_unit: 'credits',
  ci_btn: 'Packing List',
  ci_title: 'Container Packing List Import (China sourcing)',
  ci_upload_hint: 'Upload the supplier packing list (Excel .xlsx or .csv). Standard template imports directly; messy formats are auto-mapped by AI.',
  ci_choose_file: 'Choose file',
  ci_analyzing: 'Analyzing...',
  ci_download_template: 'Download template',
  ci_ai_note: 'AI fallback: any supplier format works — the system recognizes columns (SKU/name/cartons/units per box/RMB cost) and you can correct before importing.',
  ci_ai_used: '✨ AI mapped the columns — review and confirm',
  ci_ai_mapped: 'AI mapped',
  ci_analyze_fail: 'File analysis failed',
  ci_total_rows: 'Data rows',
  ci_mapping_hint: 'Change each column mapping above',
  ci_f_ignore: '— Ignore —',
  ci_f_code: 'SKU',
  ci_f_name: 'Name',
  ci_f_barcode: 'Barcode',
  ci_f_cartons: 'Cartons',
  ci_f_per_box: 'Units/carton',
  ci_f_qty: 'Total qty',
  ci_f_cost_rmb: 'Cost RMB',
  ci_f_cost_usd: 'Cost USD',
  ci_f_retail_usd: 'Retail USD',
  ci_f_wholesale_usd: 'Wholesale USD',
  ci_f_t1_qty: 'Tier1 min',
  ci_f_t1_price: 'Tier1 price$',
  ci_f_t2_qty: 'Tier2 min',
  ci_f_t2_price: 'Tier2 price$',
  ci_f_t3_qty: 'Tier3 min',
  ci_f_t3_price: 'Tier3 price$',
  ci_f_category: 'Category',
  ci_f_spec: 'Spec/color',
  ci_rmb_rate: 'RMB→USD rate',
  ci_live_rate: 'Live rate applied',
  rmb_card_title: 'RMB rate (live, auto)',
  rmb_auto_note: 'Live USD→CNY, converted to Bs via BCV/Binance (refreshes every 6h)',
  rmb_refresh: 'Refresh',
  rmb_unavailable: 'RMB rate unavailable right now',
  rmb_example: 'Example',
  ci_shipping: 'Total freight USD (allocated to cost)',
  ci_warehouse: 'Target warehouse',
  ci_wh_default: 'Default warehouse',
  ci_dup_mode: 'Existing SKUs',
  ci_mode_add: 'Add stock + update prices',
  ci_mode_skip: 'Skip',
  ci_commit: 'Confirm import',
  ci_back: 'Re-upload',
  ci_commit_fail: 'Import failed',
  ci_result_created: 'Products created',
  ci_result_updated: 'Stock added',
  ci_result_skipped: 'Skipped',
  ci_result_failed: 'Failed',
  ci_result_units: 'Units received',
  ci_ship_per_unit: 'Freight per unit',
  ci_po_created: 'Received purchase order auto-created (see container cost in Purchases)',
  bi_offer: 'Add photos to this batch — sell in the online shop right away',
  bi_create_link: 'Generate mobile photo link',
  bi_link_copied: 'Link copied — open on the phone to take photos',
  bi_copy: 'Copy link',
  bi_wa_text: '📸 New stock photo link (open on mobile, AI white background):',
  bi_hint: 'Open the link on the phone and photograph item by item; AI adds white background. Original is free, AI version costs credits per photo. Valid 7 days.',
  bi_title: 'New batch photos',
  bi_done_count: 'with photo',
  bi_take_photo: 'Take / choose photo',
  bi_processing: 'AI processing...',
  bi_use_this: 'Use this',
  bi_ai_failed: 'AI failed — use the original',
  bi_retake: 'Retake',
  bi_cancel: 'Back to list',
  bi_style_whitebg: 'White background',
  bi_style_poster: 'E-commerce poster (AI copy)',
  ci_done: 'Done',
  pt_tier_title: 'Wholesale tier prices (≥qty → price$, saved with the product)',
  pt_tier_minqty: 'Qty',
  pt_tier_price: 'Price',
  pt_tier_hint: 'E.g. ≥12 $2.80 / ≥60 $2.50 / ≥120 $2.20. Leave empty for no tiers.',
  pt_tier_save_fail: 'Tier save failed — retry in the Wholesale page',
  wsx_cp_title: 'Smart early-payment credit discount',
  wsx_cp_slogan: 'Slogan (shown on customer statement)',
  wsx_cp_slogan_ph: 'E.g.: Pay within 30 days and get 3% off!',
  wsx_cp_days: 'Default credit term (days)',
  wsx_cp_tier_days: '≤ days',
  wsx_cp_tier_pct: 'Disc. %',
  wsx_pronto_hint_1: 'Owed for',
  wsx_days: 'days',
  wsx_pronto_receive: 'pay now only',
  wsx_pronto_save: 'save',
  wsx_pronto_btn: 'Apply early-payment discount',
  pu_loading: 'Loading...',
  pu_done_title: 'Done!',
  pu_saved_for: 'Photo saved for',
  pu_close_tab: 'You can close this tab now',
  pu_title: 'Upload product photo',
  pu_code: 'SKU',
  wsx_banner: 'Shop banner (top image of the online shop)',
  wsx_banner_upload: 'Upload banner image',
  aisd_btn: 'AI Design',
  pos_ai_logo_btn: 'AI store logo',
  pos_ai_logo_regen: 'Regenerate AI logo',
  aisd_title: 'AI Shop Designer',
  aisd_kind_banner: 'Shop Banner',
  aisd_kind_logo: 'Shop Logo',
  aisd_style: 'Style',
  aisd_color_synced: 'Shop theme color synced to the banner',
  aisd_ref_hint: 'optional',
  aisd_ref_upload: 'Upload a banner you like and AI will copy its style',
  aisd_ref_active: 'Will imitate the reference style (with your store name and contact)',
  aisd_style_supermercado: '🛒 Latin Supermarket',
  aisd_style_modern: 'Modern',
  aisd_style_anime: '🎌 Anime',
  aisd_style_tech: '⚡ Tech',
  aisd_style_3d: '🧊 3D',
  aisd_style_warm: 'Warm',
  aisd_style_luxury: 'Luxury',
  aisd_style_promo: 'Promo',
  aisd_style_minimal: 'Minimal',
  aisd_style_festive: 'Festive',
  aisd_desc: 'Extra description (optional)',
  aisd_desc_ph: 'E.g.: I sell fresh produce, want a red promotional style',
  aisd_generate: 'Generate',
  aisd_generating: 'Generating…',
  aisd_regen: 'Regenerate',
  aisd_apply: 'Apply to shop',
  aisd_applied: 'Applied to your shop!',
  aisd_cost: 'Cost',
  aisd_credits: 'credits',
  aisd_balance: 'Balance',
  aisd_no_credits: 'Not enough AI credits — top up in ✨AI Credits',
  aisd_failed: 'Generation failed — credits refunded, try again',
  aisd_wait_hint: 'Takes 30-90 seconds, do not close this window',
  shopslug_label: 'Custom shop URL',
  shopslug_hint: '3-30 chars: lowercase letters, numbers and hyphens. The old link keeps working.',
  shopslug_save: 'Save URL',
  shopslug_saved: 'URL saved!',
  shopslug_invalid: 'Invalid or already taken',
  poster_btn: 'AI Poster',
  poster_title: 'AI Promo Poster',
  poster_select_hint: 'Check 1-6 products and AI composes one promo poster',
  poster_max6: 'Max 6 products',
  poster_promo_label: 'Promo headline (optional)',
  poster_promo_ph: 'E.g.: Weekend mega sale! 3 days only',
  poster_sent: 'Poster sent to WhatsApp:',
  poster_phone_ph: 'Phone (empty = boss number)',
  poster_wa_hint: 'Arrives on your WhatsApp — forward it to your customer groups',
  poster_download: 'Download poster image',
  hb_toggle: 'Auto holiday banner',
  hb_hint: '5 days before Christmas, Black Friday, etc., AI generates a festive banner (16 credits) and WhatsApps you a 1-click apply link',
  hb_enabled: 'Auto holiday banner enabled',
  hb_disabled: 'Auto holiday banner disabled',
  gb_title: '🔥 Group Buying',
  payqr_upload: '📷 Upload bank QR',
  pk_menu: '📦 Picking / Dispatch',
  vd_menu: '🧳 Salespeople',
  vendedor: 'Salesperson',
  pd_gallery_label: 'More images (shop product page)',
  pd_gallery_hint: 'Shoppers see these when tapping the product in the online shop',
  pd_desc_label: 'Product description (shown on shop product page)',
  tid_contact_admin: 'Merchant ID is managed by the platform — contact Sellox support to change it',
  payqr_change: '📷 Change QR',
  aiverify_label: '🤖 AI auto-read payment screenshots',
  aiverify_hint: 'When off, proofs go to manual review (no AI credits used): customer enters reference + uploads proof, owner confirms',
  sdc_btn: '🎉 Promo card',
  sdc_download: '📥 Download image',
  sdc_share: 'Share on WhatsApp',
  sdc_hint: 'Download the image first, then post it to your WhatsApp status or send it to customers',
  gb_intro: 'Pinduoduo-style: set a group price + group size. Customer starts a group, shares on WhatsApp, orders are auto-created when the group fills. Expires in 24h.',
  gb_enabled: 'Enabled',
  gb_disabled: 'Disabled (click to enable)',
  gb_on: 'Group buying enabled!',
  gb_off: 'Group buying disabled',
  gb_add_product: 'Add group-buy product',
  gb_search_ph: 'Search product by name/code',
  gb_price: 'Group price',
  gb_size: 'Group size',
  gb_saved: 'Group-buy product saved!',
  gb_configured: 'Group-buy products',
  gb_none: 'No products yet — search above to add',
  gb_groups: 'Groups',
  gb_no_groups: 'No groups started yet',
  gb_st_completed: 'Completed',
  gb_st_open: 'Open',
  gb_st_expired: 'Expired',

  wsx_banner_removed: 'Banner removed',
  sx_fiscal_copy_ok: 'Copy printed (fiscal invoice already issued; copy has no fiscal value)',
  sx_last_cost: 'Last cost',
  sx_ocr_menu: 'Scan invoice (AI)',
  sx_cost_up: 'Up vs last purchase',
  sx_cheaper_sup: 'Cheaper supplier',
  sx_shrink_menu: 'Shrinkage Report',
  sx_shrink_title: 'Shrinkage / Theft Report',
  sx_shrink_sub: 'Stocktake discrepancies + declared losses — invisible losses in clear numbers',
  sx_shrink_stk_loss: 'Missing (count)',
  sx_shrink_declared: 'Declared losses',
  sx_shrink_gain: 'Surplus (count)',
  sx_shrink_total: 'Total loss',
  sx_shrink_top: 'Top loss products (by value)',
  sx_shrink_times: 'Times',
  sx_shrink_qty: 'Qty missing',
  sx_shrink_value: 'Loss $',
  sx_shrink_no_data: 'No losses recorded in this period 🎉',
  sx_shrink_wh: 'Warehouse',
  sx_shrink_events: 'Event details',
  sx_shrink_source_stk: 'Stocktake',
  sx_shrink_source_loss: 'Declared',
  sx_resq_title: '⚠️ Resequence codes — dangerous action',
  sx_resq_body: 'This will change ALL product codes to 01, 02, 03… ordered by name. Current codes will be replaced! (A backup of codes is saved automatically)',
  sx_resq_type_hint: 'To continue, type below',
  sx_resq_go: 'Resequence now',
  sx_exit_system: 'Exit system completely',
  sx_ocr2_cur_q: 'What currency are the prices on this invoice?',
  sx_ocr2_usd: 'US Dollars',
  sx_ocr2_bs: 'Bolívares Bs',
  sx_ocr2_rate: 'Rate (Bs ÷ rate = $)',
  sx_ocr2_rate_hint: 'Bs prices are divided by the rate and stored in USD (priority: your rate, then the rate printed on the invoice)',
  sx_ocr2_usd_hint: 'If the invoice shows both $ and Bs columns, AI reads ONLY the $ column; box prices are divided by units per box automatically',
  sx_ocr2_rate_req: 'Enter the exchange rate first',
  sx_ocr2_src_user: 'manual rate',
  sx_ocr2_src_invoice: 'invoice rate',
  sx_ocr2_src_system: 'system rate',
  sx_ocr2_box_conv: 'Box conversion',
  sx_ocr2_units: 'unit',
  sx_ocr2_pick: '🔍 Search & pick product…',
  sx_ocr2_no_pick: 'marked as match but no product chosen',
  pm_wait_bank: '⏳ Waiting for bank notice (may take 1-2 min)…',
  overpay_label: 'Overcharged',
  overpay_return_by: 'Refund via',
  overpay_cash: '💵 Cash',
  overpay_transfer: '🏦 Transfer',
  overpay_cash_hint: 'Deducted from the cashier cash drawer',
  overpay_transfer_hint: 'Does not affect the cash drawer',
  aisd_ref_banner: '🖼️ Reference banner',
  aisd_style_gold3d: '3D Gold',
  aisd_style_mascota: '3D Mascot',
  aisd_style_emblema: 'Emblem',
  aisd_style_neon: 'Neon',
  pay_where_transfer: '📍 Shown at: online shop checkout → account the customer sees when choosing "Transfer" (legacy single account; prefer the "Receiving Accounts" list below, supports multiple)',
  pay_where_pm: '📍 Shown at: online shop checkout → details the customer sees when choosing "Pago Móvil" (legacy single account; prefer the "Receiving Accounts" list below)',
  pay_where_wa: '📍 Shown at: online shop checkout → customers can order via WhatsApp to this number',
  pay_where_cashea: '📍 Shown at: online shop checkout → Cashea installments option',
  pm_edit_auth_action: 'Editing payment requires manager authorization (scan QR or password)',
  dlv_charge_customer: 'Customer pays delivery',
  dlv_charge_customer_hint: 'When enabled, the online shop adds the delivery fee at checkout (base fee + $/km × distance)',
  dlv_free_over: 'FREE shipping over (US$)',
  dlv_free_over_hint: 'When the order subtotal reaches this amount, shipping is free; 0 = disabled',
  dlv_free_km: 'FREE shipping within (km)',
  dlv_free_km_hint: 'If the customer is within this distance from the store, shipping is free; 0 = disabled (needs customer location)',
  dlv_banner_toggle: 'Show free-shipping banner in shop',
  dlv_banner_hint: 'Shows a "FREE shipping from $X" banner above the product list to boost cart size',
  oe_edit_auth_action: 'Editing the order requires manager authorization (scan QR or password)',
  oe_edit_note: 'Editing the order adjusts stock and is audited',
  x_4ea2dc0c: 'In Safari tap Share → Add to Home Screen',
  x_b3f1742d: 'Browser menu ⋮ → Add to Home Screen / Install app',
  x_c6b0ecc1: 'PROFORMA',
  x_b43540a2: 'Reference document — not fiscal. Subject to stock confirmation.',
  x_d2a5f47d: 'Outside business hours, orders paused. Hours',
  x_79da6318: 'Order failed',
  x_a7387278: 'My orders',
  x_0134ef91: 'Install on your phone',
  x_e655a410: 'Install',
  x_9f68a807: 'Points',
  x_c6a7617b: 'Wholesale price from 12 units',
  x_db3c3f79: 'Free delivery on your first order!',
  x_92254b8d: 'Group deal',
  x_1cb0067b: '✨ New',
  x_262a5f78: '💥 Sale',
  x_9789ea3d: 'Sold out',
  x_7c114133: 'Wholesale',
  x_fe0e8bf7: 'Sign up',
  x_c5f36f1e: 'Account type',
  x_a634b186: 'Wholesaler',
  x_33809226: 'Retail customer',
  x_1b21e28e: 'Store name',
  x_abbe4bb4: 'Date of birth',
  x_fccc2b4a: 'Jan',
  x_c1d13f1d: 'Feb',
  x_c4767bc3: 'Mar',
  x_3eaf4b30: 'Apr',
  x_0545f138: 'May',
  x_f2422a6e: 'Jun',
  x_464bab7f: 'Jul',
  x_81017142: 'Aug',
  x_4b592d5e: 'Sep',
  x_f544c399: 'Oct',
  x_57c44755: 'Nov',
  x_c0615eb3: 'Dec',
  x_e42b99d5: 'Month',
  x_465260fe: 'Year',
  x_a65be661: 'Phone or ID number',
  x_ab735ef3: 'Registered store customers can log in with phone or ID',
  x_5f57ab2b: 'Select your full date of birth',
  x_18d9ac63: 'Welcome back!',
  x_c94c6645: 'Registered successfully!',
  x_c91539c5: 'You are already a member! Set a password for first online login; points and history are kept',
  x_bc490ac9: 'No account? Sign up',
  x_89438cb2: 'My points',
  x_70c5388d: 'Outstanding credit',
  x_99b7dc82: 'Term',
  x_f7013966: '-- Select bank --',
  x_b00a4f4e: 'Free delivery',
  x_abd7f31c: 'Delivery area limited, please share your location above',
  x_df4e7845: 'Group buy',
  x_e77dadaf: 'Group size',
  x_96b165fe: 'This group ended — start a new one',
  x_a49dc062: 'Select payment method',
  x_0d6fd032: 'Enter payment reference (min 4 digits)',
  x_0025409e: '🎉 Group complete! Order created',
  x_934a013a: 'Something went wrong, try again',
  x_918d2e43: 'Groups in progress — join!',
  x_cece7904: 'customers',
  x_4d99b1b3: 'Join →',
  x_7be5df87: '🚀 Start a group',
  x_02c280bb: 'Your name',
  x_a0b92ea7: 'Your phone (WhatsApp)',
  x_630a2d4f: '💳 Pay now to lock your spot',
  x_e3648a5b: '📲 Scan with your bank app',
  x_bc7dbf60: 'Payment reference *',
  x_78fbb3b8: 'The store verifies your payment. Refund if group not complete in 24h.',
  x_fbf44f79: '💬 Once complete, arrange payment via WhatsApp with the store.',
  x_661f0360: '✅ Join group',
  x_a392ec03: '🚀 Create group',
  x_9c401b86: 'Share the link — order confirms automatically when complete. Valid 24h.',
  x_1d7b443a: 'Share on WhatsApp',
  x_4b7d6310: 'Link copied',
  x_02b52fdf: 'Group complete!',
  x_375ec885: 'OK',
  x_0b4f1582: 'SENIAT - Fiscal Control Center',
  x_a2a6e3a5: 'Fiscal management · Z/X reports · Export · Audit',
  x_466ef11d: 'X report',
  x_aecc6c50: 'Z report (close)',
  x_52f43ce8: 'Counters',
  x_685de23a: 'SENIAT export',
  x_a722bf43: 'Audit log',
  x_18f25f32: 'Sequence check',
  x_917b67ce: 'Generate X report',
  x_3fca2d1d: 'Generate Z report (close)',
  x_4d020ba3: 'Generating...',
  x_2a9ce745: 'Z report = daily fiscal close, generated once at closing.',
  x_6ca3821a: '⚠️ Browser mode: fiscal printer only works from the desktop app',
  x_4823e2b3: '📅 Reprint Z copy by date — fiscal memory',
  x_1b1964c7: 'Reprints the legal copy of a saved Z for a date. No new Z, no data changes — accepted by SENIAT and accountants.',
  x_d3955f6a: 'Print on fiscal machine',
  x_0ef2525d: '⚠️ Desktop app only (fiscal printer required)',
  x_a8be906b: 'No Z report generated yet',
  x_ade95bda: 'Today\'s sales',
  x_f4f5a946: 'transactions',
  x_ee1689c9: 'VAT collected',
  x_52f7f49a: 'Exempt sales',
  x_f2a378e9: 'Voided',
  x_983f27e7: 'Net sales',
  x_d3c85a4d: 'Invoice No.',
  x_d3a4a490: 'Control No.',
  x_6cced836: 'VAT detail',
  x_b294fbbf: 'Tax base',
  x_2bb46698: 'No counters yet. Created with first invoiced sale.',
  x_f74759c0: 'Control number counter',
  x_353cab9e: 'Invoice number counter',
  x_4c9bb426: 'Prefix',
  x_ca8f0b14: 'Current number',
  x_f2c71b78: 'Export fiscal data (SENIAT)',
  x_b44c0f33: 'Start date',
  x_1d468be9: 'End date',
  x_55405ea6: 'Export',
  x_aa03f534: 'CSV: semicolon separated, Excel/SENIAT compatible',
  x_7a5bbc5b: 'TXT: pipe-separated plain text for SENIAT systems',
  x_725b5a3e: 'JSON: structured format for API integrations',
  x_1fd02a90: 'User',
  x_79c05840: 'No audit records',
  x_5839aebb: 'Audit data kept 10 years per SENIAT (SNAT/2024/000121).',
  x_43c011c1: 'Check sequence',
  x_0410cb00: 'Checking...',
  x_bc5b83bc: 'No dates = check all. Internal self-check, independent of SENIAT.',
  x_7974ad56: '✅ Sequence complete',
  x_8dc2b6cc: '⚠️ Issues found',
  x_19616fb8: 'invoices · range',
  x_9a136985: 'Gaps (missing numbers)',
  x_a656f3be: 'Duplicate numbers',
  x_c258e133: 'Out of time order',
  x_5da53c3a: 'Offline entries / voided',
  x_af5eba6e: 'Gap detail (missing control numbers)',
  x_d8066277: 'Duplicate control numbers',
  x_351f1da9: 'Invoices out of chronological order',
  x_8ce24893: 'Generate Z report? Closes the fiscal day, once per day. Confirm?',
  x_87d27264: '⚠️ Desktop app only',
  x_66823aa3: 'Assigned to',
  x_89a92538: 'Published, riders can claim it',
  x_d02627fe: '✅ Notification settings saved',
  x_6af47376: '✅ Order updated',
  x_d3cb9a21: '✅ Invoicing complete',
  x_cdbe0c92: 'Cancel this order? Stock released, delivery cancelled',
  x_32ff009c: '✅ Order cancelled',
  x_a769cdc2: 'Permanently delete this order? Releases reserved stock, irreversible',
  x_2716e6a7: 'Permanently delete this record? Irreversible',
  x_cbb7bf56: '🗑 Permanently deleted',
  x_00e41368: 'Enter return quantity',
  x_96c48fd4: '✅ Exchange done, collect from customer',
  x_7ef40e73: '✅ Return successful, stock updated',
  x_44c198c1: 'Refund',
  x_f36ecce3: 'New order notifications',
  x_359ff4db: 'WhatsApp number for order alerts (empty = off)',
  x_b7656e18: 'Ringtone',
  x_0d9c291a: 'Crisp',
  x_1fdac4c2: 'Loud',
  x_95b9408f: 'Voice announce amount',
  x_f4a35245: 'Test',
  x_f62dea70: 'Which accounts ring (none = all)',
  x_2026e292: 'PC rings and voice-announces new order amount',
  x_2dad819e: 'Fully refunded',
  x_f67d89db: 'Partial refund',
  x_bc3583b5: 'Invoice',
  x_4efd6a13: 'Send to rider',
  x_cbfc5ba6: 'Out of stock: adjust qty, 0 removes item',
  x_855fb7e2: 'Confirmed total',
  x_d613b1b4: 'On confirm: stock deducted + customer credit + salesperson commission',
  x_b59c07ff: '✅ Confirm invoicing',
  x_897dbdee: 'Edit order',
  x_7650487a: 'Address',
  x_d2dd7e1c: 'Out of stock: adjust qty, 0 removes item',
  x_d99e3dbb: 'New total (without delivery)',
  x_926c613a: '⚠️ Order already paid, settle difference with customer',
  x_84693468: '💾 Save changes',
  x_b163cb6a: 'Order return',
  x_a9275c2e: 'Defaults to full return; adjust for partial (0 = keep)',
  x_2f656a74: 'Returned',
  x_4178e0b6: 'Refund method',
  x_976f94a1: 'Reason (optional)',
  x_fd3108f0: 'E.g. damaged product',
  x_cf55227f: 'Exchange (optional) — swap product, difference auto-calculated',
  x_33bda28d: 'Search replacement product...',
  x_9854a54a: 'Return amount',
  x_51811a84: 'Exchange amount',
  x_2718ce26: 'Refund to customer',
  x_d1903e50: 'Customer owes',
  x_1830fefb: 'On confirm: returned stock in + exchange out + refund record + WhatsApp receipt to customer',
  x_54945fc4: '✅ Confirm exchange/return',
  x_6be8ae78: '✅ Confirm return',
  x_1817ed2a: 'Assign to rider',
  x_dc2c3193: 'No verified riders. They register at sellox.shop/rider for your approval.',
  x_727df9ee: 'Publish for pickup (unassigned)',
  x_c29ce6fd: 'Cash $',
  x_58ef5787: 'Draft cleared',
  x_129fe574: 'Supplier invoice No.:',
  x_2959bd81: '✅ Daily auto-restock draft on (7:00)',
  x_e6a85d28: 'Auto draft off',
  x_a2a843ad: 'No hot items need restocking',
  x_513d596e: '✅ Draft confirmed as purchase order',
  x_0c456ca5: 'Delete this draft?',
  x_9b19d9c6: '⚠️ Select a warehouse first',
  x_20b73ca7: '💾 Purchase saved offline, uploads when back online',
  x_1922f043: '💾 Receipt saved offline, uploads when back online',
  x_31d1f953: '📋 Product copied, just change name and barcode',
  x_673942b6: 'Barcode already exists',
  x_47e03fd1: 'Code already in use',
  x_b0007365: 'No supplier',
  x_e24ce335: 'Auto draft: ON',
  x_9cfd9afd: 'Auto draft: OFF',
  x_31416882: 'Generate draft now',
  x_719fb446: 'Search supplier or seller...',
  x_4091474b: '📝 Draft',
  x_d7291e52: 'Document currency',
  x_2ced248f: 'Copy as new (change name & barcode only)',
  x_e21626f3: '🗑 Clear draft',
  x_64457c62: 'Click to change department/category',
  x_00ca7c29: 'No category · click to set',
  x_df6d0757: 'pcs/box',
  x_64d9ef93: 'Margin',
  x_9e4dbf03: 'Amount Bs',
  x_77449ea5: 'Rate (Bs/$)',
  x_5e496273: 'Enter Bs, converts to USD at daily rate (editable)',
  x_be85dc34: 'Reference / transaction No.',
  x_0edbdf53: 'Transfer reference, Zelle confirmation…',
  x_8f8b954f: 'E.g. cash to salesman Juan, partial deposit…',
  x_f8580966: 'Payment proof (screenshot/receipt)',
  x_be6f0f22: 'Photo / upload proof',
  x_aa24f2e1: 'Image too large (max 8MB)',
  x_94171ce2: 'Proof',
  x_3e440694: 'This code is already in use',
  x_be607248: 'This barcode already exists',
  x_515c0b7e: 'Change warehouse for whole document? Received stock moves to new warehouse',
  x_15816bc7: 'Change this document\'s warehouse?',
  x_0e344978: 'Banking',
  x_5bb78d8a: 'Transfer between accounts',
  x_228d2bab: 'New account',
  x_3b186bad: 'No accounts yet. Create bank/cash accounts and payments auto-post.',
  x_6095e59c: 'Transactions',
  x_348e534e: 'Doc No. / note',
  x_09e1d043: 'No transactions',
  x_6f484666: 'Edit account',
  x_f3f18020: 'Name (e.g. BNC main / USD cash box)',
  x_f430b947: 'Bank (optional)',
  x_4d72cab9: 'Last 4 digits (optional)',
  x_de35ac7b: 'Opening balance',
  x_1f0fca13: 'Linked payment methods (payments post here)',
  x_68e9a989: 'Note (optional)',
  x_3e25b5d4: 'From account',
  x_e83fca1c: 'To account',
  x_33ed7cfa: 'Amount out',
  x_30f229d9: 'Amount received',
  x_26050b04: 'Confirm transfer',
  x_9e268a5d: 'Enter a name',
  x_db8ac4f2: 'Invalid amount',
  x_4ab08f52: 'Recorded',
  x_51e7ba4a: 'Transfer recorded',
  x_3524c978: 'Export statement',
  x_be123473: 'Export statement (Excel/PDF)',
  x_81909158: 'Month',
  x_37cb3781: 'Summary',
  x_32f2f705: 'Funds summary',
  x_026d5880: 'Opening',
  x_361ffa7f: 'Inflow',
  x_37cc0a9a: 'Outflow',
  x_b39409ce: 'Net',
  x_d6080990: 'Closing',
  x_79ceb63f: 'Store cash drawer',
  x_936cf2c9: 'Approvals',
  x_5a97be8a: 'Large amount approval',
  x_6fded8ab: 'Enable approval (withdrawals/transfers/supplier payments above threshold need PIN)',
  x_a54fc320: 'USD threshold $ (0 = none)',
  x_807af4c1: 'Bs threshold (0 = none)',
  x_c0e9bd0c: 'New 6-digit PIN (empty = keep)',
  x_47217200: 'Current PIN (to change settings)',
  x_9ccb14f1: 'Approval settings saved',
  x_d9d6d5ba: '🔐 Boss approval required',
  x_be9d2bc1: 'Amount over threshold, enter 6-digit PIN',
  x_0e1667c5: '6-digit PIN',
  x_9cc24820: 'Wrong PIN',
  x_b8e32288: 'PIN locked, retry in 15 minutes',
  x_7116e7ec: 'Account',
  x_e3dea388: 'No data for this period',
  x_767d5ae4: 'Unclosed shift auto-recovered',
  x_b231f6b0: 'Today\'s unclosed shift recovered, continue',
  x_d5ff526d: 'You have an unclosed shift, close it before opening a new one',
  x_42d9293a: '30 days',
  x_94903830: '60 days',
  x_dc491dae: '90 days',
  x_cba8c4ef: 'Allow pop-ups',
  x_6f2838fe: 'Enter price',
  x_32a79f1b: 'Slow movers',
  x_ed320806: 'Best sellers',
  x_9e3d9f77: 'Products in stock',
  x_862dacd0: 'Dead stock cost',
  x_70ac9021: 'Total inventory cost',
  x_966a2e61: 'Months of stock',
  x_460e109d: 'Stuck cost',
  x_993a1358: 'Last sold',
  x_7098d682: 'Clearance',
  x_d81bb206: 'Never',
  x_0dc5dc88: 'Group buy',
  x_28183523: '💥 Set clearance price',
  x_baed7f26: '🔥 Clear via group buy',
  x_f9c82b80: 'Sale active (OFERTA tag online + POS price synced)',
  x_6edc3851: 'Print sale labels',
  x_23a605c4: 'Sale price (USD) — default -15%',
  x_3576efc7: 'Group price (USD)',
  x_ec798f44: 'People to complete (2-5)',
  x_3907665a: 'Sale duration (price restores after expiry)',
  x_d716067e: '7 days',
  x_d9926871: '15 days',
  x_853f8cf7: '30 days',
  x_544cb8d3: 'Changes price 1 and adds OFERTA tag online',
  x_6ff9fab3: 'Enables group buy for this product (requires master switch on)',
  x_15af542a: '🔒 Fiscal info is managed by your provider. Name/address changes: contact provider (paid service).',
  x_6e0df37b: '🧾 Invoice numbering',
  x_12923f27: '✅ Sequential numbering active',
  x_9aa9020f: '⬜ Off (click to enable)',
  x_99a06c43: 'Prefix',
  x_453340fc: 'Digits',
  x_f45ac04c: 'Next No.',
  x_02f02875: 'When on, each confirmed online order gets a sequential invoice number shown on e-invoice and receipt.',
  x_eea9deb9: 'Store logo (for printing or WhatsApp avatar)',
  x_8c57e455: 'Upload logo',
  x_456885ba: 'Download logo',
  x_967d445b: '🕐 Online ordering hours',
  x_8a0bbf6e: 'Venezuela time; outside these hours online orders pause; POS unaffected',
  x_2086719a: 'Return to Price 1 after each scan (P2/Box applies to next product only)',
  x_b9f9fade: 'Receipt currency',
  x_d30839fd: 'Bolívares only',
  x_99f08c08: 'Dollars only',
  x_75bffa13: 'Bs + $',
  x_09d4c026: '🧑‍💼 Manager panel',
  x_41ebcf52: 'Disabled features hidden from store manager (boss unrestricted)',
  x_a2e95088: 'Day summary',
  x_1ae34829: 'Inventory & products',
  x_eb479750: 'Stock count',
  x_e7926cff: 'Expenses',
  x_75e361e0: 'FX gain',
  x_1a7665ae: 'Cash in drawer',
  x_9a127288: 'Employee accounts',
  x_d7a96cba: 'Schedule',
  x_9ac5ab89: 'Credits',
  x_c1f80f9b: 'Add product',
  x_0735fcbc: 'Transfers',
  x_2ff230cf: '📊 Visitor analytics',
  x_677d39e2: 'Who browses your shop, what they view and buy',
  x_49ea343c: 'Online now',
  x_36331e50: 'Visitors today',
  x_63568477: 'Views today',
  x_f2a70aa0: 'Orders today',
  x_43798078: 'Visitor trend',
  x_c527743c: 'Order conversion',
  x_852da3f7: 'Visitors',
  x_88bc4d7a: 'Views',
  x_dd2a2f3b: '🔥 Hot products (add-to-cart)',
  x_f2581824: 'No data yet — counts when customers add to cart',
  x_4f15720f: 'Devices',
  x_e855972e: 'Desktop',
  x_c77c44eb: 'No visitors yet — share your shop link',
  x_c864ee0a: '14 days',
  x_fdfd62e8: 'Signups today',
  x_bd83f3a1: '🛒 Purchase funnel',
  x_3c5c43e5: 'Add to cart',
  x_423da4b1: 'Orders',
  x_6e3a0666: 'times added to cart',
  x_72df3158: '📝 New signups',
  x_1818467a: 'No new signups in this period',
  x_61dd3548: '👀 Recent visitors',
  x_44761c5f: 'Anonymous visitor',
  x_ff6e1828: 'No visit records',
  x_e9ac9962: 'views',
  x_381fb5ef: '🔔 Traffic spike alert',
  x_3836004f: 'WhatsApp alert when many are online — great for flash promos',
  x_468a206b: 'Online ≥',
  x_60051ff7: 'Alert number (empty = order number)',
  x_0c18a538: 'At least 60 min between alerts',
  x_add9c8bf: '⚖️ Labor LOTTT',
  x_a09fe96e: '🧾 Tax SENIAT',
  x_e9f30aae: '🏢 Commercial',
  x_3dcf62b4: 'Ask anything, for example:',
  x_50a1215a: 'How much severance for a 3-year employee?',
  x_c9e9a906: 'How is overtime calculated?',
  x_eb3853bc: '"Severance for a 3-year employee?" · "Current cestaticket amount?"',
  x_b08d2eca: '⚖️ AI checking the law…',
  x_323d361d: 'Type your legal question…',
  x_74221fd8: 'Clear chat',
  x_2aad6aeb: 'Select an employee first',
  x_842bd876: 'Employee',
  x_f48c1e0f: 'From',
  x_0a50a227: 'To',
  x_60197011: 'AI calculating…',
  x_9945bf6c: 'AI monthly payroll',
  x_98a98282: 'AI reads real employee data (salary, attendance, loans) and builds a LOTTT-compliant payroll.',
  x_010a3d9c: '⚖️ AI checking LOTTT and calculating… (20-40s)',
  x_b7014d64: 'LOTTT labor · SENIAT tax · commercial law — AI cites articles and builds compliant payrolls',
  x_1a1d2d4e: 'AI credits balance',
  x_88426c86: 'Question 1 credit · Payroll 3 credits',
  x_10d691fd: '💰 AI payroll',
  x_c228ed55: '⏳ Pending upload',
  x_95a03b22: '✅ Duplicate - likely already charged, verify then delete',
  x_b60c2cbc: '❌ No stock - NOT recorded, restock and re-ring',
  x_9ed2da59: '❌ Rejected by server - NOT recorded',
  x_9c8b638d: 'Nothing to sync',
  x_59c10673: 'Sync queue',
  x_963d2f9c: 'All synced, nothing pending',
  x_422e18f2: 'Deleted',
  x_6b1192c7: 'Delete',
};

Object.assign(en, {
  refCommNav: '💵 Referral Commissions',
  refCommTitle: 'Referral Commissions',
  refCommDesc: 'When a referred merchant makes their first payment, the referrer earns a one-time cash commission',
  refCommEnabled: 'Enable cash commissions',
  refCommRate: 'Commission rate (%)',
  refCommSave: 'Save',
  refCommSettingsSaved: 'Commission settings saved',
  refCommPendingTotal: 'Pending payouts',
  refCommPaidTotal: 'Paid out',
  refCommPendingCount: 'pending',
  refCommRecords: 'Commission records',
  refCommReferrer: 'Referrer',
  refCommReferred: 'New merchant',
  refCommAmountPaid: 'Customer paid',
  refCommAmount: 'Commission',
  refCommStatus: 'Status',
  refCommPending: 'Pending',
  refCommPaid: 'Paid',
  refCommCancelled: 'Cancelled',
  refCommMarkPaid: 'Mark paid',
  refCommPayMethod: 'Payment method',
  refCommPayRef: 'Transfer reference / note',
  refCommConfirmPay: 'Confirm paid',
  refCommCancelRec: 'Cancel',
  refCommManualAdd: 'Add commission manually',
  refCommSelectTenant: 'Select referred merchant',
  refCommNoEligible: 'No eligible merchants (must be registered with a referral code and have no commission yet)',
  refCommNoRecords: 'No commission records yet',
  refCommDate: 'Date',
  refCommClose: 'Close',
  refCommMyEarnings: 'My Cash Commissions',
  refCommPendingBalance: 'Pending',
  refCommReceived: 'Received',
  refCommEarnRule: 'When a new customer registers with your code and makes their first payment, you earn {rate}% of that payment in cash',
  refCommPayoutNote: '💰 Payouts are sent by the platform via Pago Móvil / Zelle / Binance',
  refCommCreatedToast: 'Commission record created',
  renewAmountPaid: 'Amount received (USD)',
  renewAmountPaidHint: 'Optional · used for payment records and referral commission',
  renewReferredHint: 'This merchant registered with a referral code — first payment will create a commission',
  refPosterBtn: 'Poster',
  refPosterTitle: 'Referral Share Poster',
  refPosterDownload: 'Download poster',
  refPosterDownloaded: 'Poster downloaded — share it on WhatsApp!',
  refPosterHint: 'Download the poster image or tap WhatsApp to share your referral link directly',
  refProgramNav: '🎁 Refer & Earn · Sellox Platform',
  refHow2Desc: 'Your friend registers a trial with your code (no commission yet)',
  refHow3Title: 'Paid = you earn',
  refHow3Desc: 'Only when they actually pay do you earn {rate}% of their payment in cash',
  refStatUses: 'Merchants referred',
  refStatEarned: 'Total commissions',
  duTitle: 'Direct USDT Payment (Binance)',
  duZeroFee: 'Zero fees',
  duDesc: 'Send USDT (TRC20) directly to the platform address, paste the TxID and get activated instantly. For Binance internal transfers use screenshot review.',
  duBuyLifetime: 'Activate plan (incl. 1st-year service; yearly fee applies)',
  duMaintenance: 'Renew yearly maintenance',
  duMaintenance12m: 'Yearly maintenance · 12 months',
  duExpiry: 'Expires',
  duCredits: 'Top up AI credits',
  duStep1: 'Step 1: Send this exact amount to the address (TRC20 network only)',
  duStep2: 'Step 2: Paste the transaction hash (TxID) — verified on-chain and activated instantly',
  duTxidPlaceholder: 'Paste the 64-char transaction hash…',
  duVerifyBtn: 'Verify & Activate',
  duPasteTxid: 'Please paste the TxID',
  duNetworkWarn: 'Use TRC20 (TRON) network only — wrong network = lost funds!',
  duBinanceInternal: 'Binance internal transfer (no TxID)?',
  duUploadScreenshot: 'Upload screenshot for review',
  duMyOrders: 'My payment orders',
  duStPending: 'Pending',
  duStReview: 'In review',
  duStConfirmed: 'Activated',
  duStRejected: 'Rejected',
  duNav: '💰 USDT Direct Pay',
  duAdminTitle: 'USDT Direct Pay Orders',
  duAll: 'All',
  duTenant: 'Merchant',
  duUseCase: 'Purpose',
  duApprove: 'Approve',
  duRejectNote: 'Rejection reason (optional)',
  duScreenshot: 'Payment screenshot',
  duYearFee: '1st-year service',
  mainSupplier: 'Main supplier (smart restock groups orders by it)',
  noSupplier: '— Not set —',
  priceCompare: 'Supplier price comparison (purchase history, cheapest first)',
  posRejTitle: 'ORDER REJECTED',
  posRejLine1: 'This order was NOT saved! It will not appear in the system',
  posRejLine2: 'Do NOT hand over change or goods yet!',
  posRejLine3: 'The cart is still there: fix the problem and charge again',
  posSaveFailTitle: 'COULD NOT SAVE!',
  posSaveFailLine1: 'Server is down and this device could not store the order either',
  posSaveFailLine2: 'Take a photo or write down the number and amount above, tell the boss',
  posSaveFailLine3: 'Do NOT close this page! Charge again when internet is back',
  posShiftWarnTitle: 'Shift started offline',
  posShiftWarnLine1: 'The shift was saved on this device, you can keep selling',
  posShiftWarnLine2: 'If internet does not come back, let the boss know',
  supBasicInfo: 'Basic info',
  supExtraInfo: 'Additional info',
  supCategory: 'Category',
  supAddCategory: 'Add category',
  supTaxId: 'Tax ID (RIF)',
  supCurrency: 'Settlement currency',
  supTerms: 'Payment terms (days)',
  supEmail: 'Email',
  supPostal: 'Postal code',
  supBankName: 'Bank',
  supBankAccount: 'Bank account',
  supCarrier: 'Default carrier',
  supCountry: 'Country',
  supState: 'State',
  supCity: 'City',
  supNotes: 'Notes',
  supAutoGen: 'Auto-generated if left empty',
  supDupName: '⚠️ Supplier name already exists',
  supDupCode: '⚠️ Code already in use',
  supSearch: 'Search supplier by name/code…',
  supNoMatch: 'No matching suppliers',
  posAlertSoundTitle: 'POS alert sound',
  posAlertSoundHint: 'Plays when the red alert pops (click to preview)',
  soundBuzzer: 'Buzzer (default)',
  soundBeep: 'Beep',
  soundChime: 'Chime',
  posSaleSoundTitle: 'Sale completed sound',
  posSaleSoundHint: 'Plays after every completed sale (click to preview)',
  saleSoundDing: 'Ding',
  saleSoundCash: 'Cash register',
  saleSoundOk: 'Double OK',
  pmVoiceTitle: 'Voice on Pago Móvil / transfer check',
  pmVoiceHint: 'Announces the verification result at the register: confirmed / flagged / not found',
  pmVoiceShort: 'Just “Pago Móvil confirmed”',
  pmVoiceAmount: '“Confirmed” + Bs amount',
  soundSiren: 'Siren',
  soundOff: 'Off',
  invLedger: 'Stock ledger',
  ledgerSale: 'Sale',
  ledgerReturn: 'Return',
  ledgerPurchase: 'Purchase',
  ledgerAdjust: 'Adjust',
  ledgerLoss: 'Loss',
  ledgerTransfer: 'Transfer',
  ledgerCreate: 'Product created',
  ledgerDelete: 'Product deleted',
  ledgerAllProducts: 'All products (created/deleted/adjusted)',
  ledgerNoData: 'No movements in this period',
  ledgerCurStock: 'Current stock',
  posNoLastOrder: 'No receipt to reprint yet (complete a sale first)',
  posOk: 'GOT IT',
  verNewWeb: '🆕 New version',
  verClickReload: 'click to update',
  cat_pdf_btn: 'Catalog PDF',
  cat_pdf_title: 'Export product catalog PDF by category',
  cat_pdf_hint: 'Landscape catalog with big photos, perfect for WhatsApp groups. Prices match the wholesale shop.',
  cat_pdf_select_all: 'All',
  cat_pdf_clear: 'None',
  cat_pdf_hide_inactive: 'Hide inactive products',
  cat_pdf_hide_oos: 'Hide out-of-stock products',
  cat_pdf_show_prices: 'Show prices',
  cat_pdf_generate: 'Generate PDF',
  cat_pdf_generating: 'Generating… (10–30 s with many photos)',
  cat_pdf_done: 'PDF generated',
  cat_pdf_empty: 'Selected categories have no products',
  cat_pdf_pick: 'Select at least one category',
  cat_pdf_color: 'Catalog color',
  cat_pdf_color_custom: 'Custom color',
  wsx_sm_qr: 'Shop QR',
  wsx_sm_qr_hint: 'Customers scan to open the wholesale shop; their orders are credited to this salesman. Save the image and share it on WhatsApp.',
  bulto: 'Bale',
  bultoBoxes: 'Boxes per bale',
  bultoPrice: 'Bale price',
  bultoHint: 'Bale = large pack holding several boxes. 0 = none.',
  bultos: 'bales',
  wsx_moq_mode: 'Minimum order',
  wsx_moq_mode_box: 'Full boxes (multiples of box)',
  wsx_moq_mode_unit: 'Single units (from 1, +1 box button)',
  wsx_moq_mode_hint: 'If your smallest unit is already a pack/box, choose «Single units».',
  cat_pdf_products: 'products',
  cat_pdf_uncat: 'uncategorized (not in PDF)',
  cat_pdf_uncat_hint: 'Assign a category in Products so they appear',
  x_svc_staff_pick: 'Staff…',
  x_svc_not_found: 'service not found, add it manually',
  x_beauty_center: 'Beauty center',
  x_appt_pay_pos: 'Charge at POS',
  x_appt_paid: 'Paid',
  x_appt_online: 'Online booking',
  x_appt_pick_service: 'Pick a service…',
  x_appt_pick_staff: 'Pick staff…',
  x_cust_beauty: 'Beauty profile',
  x_pkg_service: 'Service it covers (POS only redeems that service)',
  x_pkg_service_any: 'Any service',
  x_save_btn: 'Save',
});

export default en;